if (void 0 === easyorder || "function" != typeof easyorder.jq) {
  var commandDetails = [];
  !(function (e, t) {
    var i,
      n,
      r = typeof t,
      o = e.document,
      a = e.location,
      s = e.jQuery,
      l = e.$,
      c = {},
      u = [],
      d = "1.9.1",
      p = u.concat,
      h = u.push,
      I = u.slice,
      f = u.indexOf,
      m = c.toString,
      j = c.hasOwnProperty,
      M = d.trim,
      y = function (e, t) {
        return new y.fn.init(e, t, n);
      },
      N = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
      Y = /\S+/g,
      T = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
      Z = /^(?:(<[\w\W]+>)[^>]*|#([\w-]*))$/,
      g = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
      O = /^[\],:{}\s]*$/,
      z = /(?:^|:|,)(?:\s*\[)+/g,
      W = /\\(?:["\\\/bfnrt]|u[\da-fA-F]{4})/g,
      D = /"[^"\\\r\n]*"|true|false|null|-?(?:\d+\.|)\d+(?:[eE][+-]?\d+|)/g,
      k = /^-ms-/,
      x = /-([\da-z])/gi,
      v = function (e, t) {
        return t.toUpperCase();
      },
      w = function (e) {
        (o.addEventListener ||
          "load" === e.type ||
          "complete" === o.readyState) &&
          (J(), y.ready());
      },
      J = function () {
        o.addEventListener
          ? (o.removeEventListener("DOMContentLoaded", w, !1),
            e.removeEventListener("load", w, !1))
          : (o.detachEvent("onreadystatechange", w),
            e.detachEvent("onload", w));
      };

    function C(e) {
      var t = e.length,
        i = y.type(e);
      return (
        !y.isWindow(e) &&
        (!(1 !== e.nodeType || !t) ||
          "array" === i ||
          ("function" !== i &&
            (0 === t || ("number" == typeof t && t > 0 && t - 1 in e))))
      );
    }
    (y.fn = y.prototype =
      {
        jquery: d,
        constructor: y,
        init: function (e, i, n) {
          var r, a;
          if (!e) return this;
          if ("string" == typeof e) {
            if (
              !(r =
                "<" === e.charAt(0) &&
                ">" === e.charAt(e.length - 1) &&
                e.length >= 3
                  ? [null, e, null]
                  : Z.exec(e)) ||
              (!r[1] && i)
            )
              return !i || i.jquery
                ? (i || n).find(e)
                : this.constructor(i).find(e);
            if (r[1]) {
              if (
                ((i = i instanceof y ? i[0] : i),
                y.merge(
                  this,
                  y.parseHTML(
                    r[1],
                    i && i.nodeType ? i.ownerDocument || i : o,
                    !0
                  )
                ),
                g.test(r[1]) && y.isPlainObject(i))
              )
                for (r in i)
                  y.isFunction(this[r]) ? this[r](i[r]) : this.attr(r, i[r]);
              return this;
            }
            if ((a = o.getElementById(r[2])) && a.parentNode) {
              if (a.id !== r[2]) return n.find(e);
              (this.length = 1), (this[0] = a);
            }
            return (this.context = o), (this.selector = e), this;
          }
          return e.nodeType
            ? ((this.context = this[0] = e), (this.length = 1), this)
            : y.isFunction(e)
            ? n.ready(e)
            : (e.selector !== t &&
                ((this.selector = e.selector), (this.context = e.context)),
              y.makeArray(e, this));
        },
        selector: "",
        length: 0,
        size: function () {
          return this.length;
        },
        toArray: function () {
          return I.call(this);
        },
        get: function (e) {
          return null == e
            ? this.toArray()
            : 0 > e
            ? this[this.length + e]
            : this[e];
        },
        pushStack: function (e) {
          var t = y.merge(this.constructor(), e);
          return (t.prevObject = this), (t.context = this.context), t;
        },
        each: function (e, t) {
          return y.each(this, e, t);
        },
        ready: function (e) {
          return y.ready.promise().done(e), this;
        },
        slice: function () {
          return this.pushStack(I.apply(this, arguments));
        },
        first: function () {
          return this.eq(0);
        },
        last: function () {
          return this.eq(-1);
        },
        eq: function (e) {
          var t = this.length,
            i = +e + (0 > e ? t : 0);
          return this.pushStack(i >= 0 && t > i ? [this[i]] : []);
        },
        map: function (e) {
          return this.pushStack(
            y.map(this, function (t, i) {
              return e.call(t, i, t);
            })
          );
        },
        end: function () {
          return this.prevObject || this.constructor(null);
        },
        push: h,
        sort: [].sort,
        splice: [].splice,
      }),
      (y.fn.init.prototype = y.fn),
      (y.extend = y.fn.extend =
        function () {
          var e,
            i,
            n,
            r,
            o,
            a,
            s = arguments[0] || {},
            l = 1,
            c = arguments.length,
            u = !1;
          for (
            "boolean" == typeof s &&
              ((u = s), (s = arguments[1] || {}), (l = 2)),
              "object" == typeof s || y.isFunction(s) || (s = {}),
              c === l && ((s = this), --l);
            c > l;
            l++
          )
            if (null != (o = arguments[l]))
              for (r in o)
                (e = s[r]),
                  s !== (n = o[r]) &&
                    (u && n && (y.isPlainObject(n) || (i = y.isArray(n)))
                      ? (i
                          ? ((i = !1), (a = e && y.isArray(e) ? e : []))
                          : (a = e && y.isPlainObject(e) ? e : {}),
                        (s[r] = y.extend(u, a, n)))
                      : n !== t && (s[r] = n));
          return s;
        }),
      y.extend({
        noConflict: function (t) {
          return (
            e.$ === y && (e.$ = l), t && e.jQuery === y && (e.jQuery = s), y
          );
        },
        isReady: !1,
        readyWait: 1,
        holdReady: function (e) {
          e ? y.readyWait++ : y.ready(!0);
        },
        ready: function (e) {
          if (!0 === e ? !--y.readyWait : !y.isReady) {
            if (!o.body) return setTimeout(y.ready);
            (y.isReady = !0),
              (!0 !== e && --y.readyWait > 0) ||
                (i.resolveWith(o, [y]),
                y.fn.trigger && y(o).trigger("ready").off("ready"));
          }
        },
        isFunction: function (e) {
          return "function" === y.type(e);
        },
        isArray:
          Array.isArray ||
          function (e) {
            return "array" === y.type(e);
          },
        isWindow: function (e) {
          return null != e && e == e.window;
        },
        isNumeric: function (e) {
          return !isNaN(parseFloat(e)) && isFinite(e);
        },
        type: function (e) {
          return null == e
            ? e + ""
            : "object" == typeof e || "function" == typeof e
            ? c[m.call(e)] || "object"
            : typeof e;
        },
        isPlainObject: function (e) {
          if (!e || "object" !== y.type(e) || e.nodeType || y.isWindow(e))
            return !1;
          try {
            if (
              e.constructor &&
              !j.call(e, "constructor") &&
              !j.call(e.constructor.prototype, "isPrototypeOf")
            )
              return !1;
          } catch (e) {
            return !1;
          }
          var i;
          for (i in e);
          return i === t || j.call(e, i);
        },
        isEmptyObject: function (e) {
          var t;
          for (t in e) return !1;
          return !0;
        },
        error: function (e) {
          throw Error(e);
        },
        parseHTML: function (e, t, i) {
          if (!e || "string" != typeof e) return null;
          "boolean" == typeof t && ((i = t), (t = !1)), (t = t || o);
          var n = g.exec(e),
            r = !i && [];
          return n
            ? [t.createElement(n[1])]
            : ((n = y.buildFragment([e], t, r)),
              r && y(r).remove(),
              y.merge([], n.childNodes));
        },
        parseJSON: function (i) {
          return e.JSON && e.JSON.parse
            ? e.JSON.parse(i)
            : null === i
            ? i
            : "string" == typeof i &&
              (i = y.trim(i)) &&
              O.test(i.replace(W, "@").replace(D, "]").replace(z, ""))
            ? Function("return " + i)()
            : (y.error("Invalid JSON: " + i), t);
        },
        parseXML: function (i) {
          var n;
          if (!i || "string" != typeof i) return null;
          try {
            e.DOMParser
              ? (n = new DOMParser().parseFromString(i, "text/xml"))
              : (((n = new ActiveXObject("Microsoft.XMLDOM")).async = "false"),
                n.loadXML(i));
          } catch (e) {
            n = t;
          }
          return (
            (n &&
              n.documentElement &&
              !n.getElementsByTagName("parsererror").length) ||
              y.error("Invalid XML: " + i),
            n
          );
        },
        noop: function () {},
        globalEval: function (t) {
          t &&
            y.trim(t) &&
            (
              e.execScript ||
              function (t) {
                e.eval.call(e, t);
              }
            )(t);
        },
        camelCase: function (e) {
          return e.replace(k, "ms-").replace(x, v);
        },
        nodeName: function (e, t) {
          return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
        },
        each: function (e, t, i) {
          var n = 0,
            r = e.length,
            o = C(e);
          if (i) {
            if (o) for (; r > n && !1 !== t.apply(e[n], i); n++);
            else for (n in e) if (!1 === t.apply(e[n], i)) break;
          } else if (o) for (; r > n && !1 !== t.call(e[n], n, e[n]); n++);
          else for (n in e) if (!1 === t.call(e[n], n, e[n])) break;
          return e;
        },
        trim:
          M && !M.call("\ufeffÂ ")
            ? function (e) {
                return null == e ? "" : M.call(e);
              }
            : function (e) {
                return null == e ? "" : (e + "").replace(T, "");
              },
        makeArray: function (e, t) {
          var i = t || [];
          return (
            null != e &&
              (C(Object(e))
                ? y.merge(i, "string" == typeof e ? [e] : e)
                : h.call(i, e)),
            i
          );
        },
        inArray: function (e, t, i) {
          var n;
          if (t) {
            if (f) return f.call(t, e, i);
            for (
              n = t.length, i = i ? (0 > i ? Math.max(0, n + i) : i) : 0;
              n > i;
              i++
            )
              if (i in t && t[i] === e) return i;
          }
          return -1;
        },
        merge: function (e, i) {
          var n = i.length,
            r = e.length,
            o = 0;
          if ("number" == typeof n) for (; n > o; o++) e[r++] = i[o];
          else for (; i[o] !== t; ) e[r++] = i[o++];
          return (e.length = r), e;
        },
        grep: function (e, t, i) {
          var n = [],
            r = 0,
            o = e.length;
          for (i = !!i; o > r; r++) i !== !!t(e[r], r) && n.push(e[r]);
          return n;
        },
        map: function (e, t, i) {
          var n,
            r = 0,
            o = e.length,
            a = [];
          if (C(e))
            for (; o > r; r++) null != (n = t(e[r], r, i)) && (a[a.length] = n);
          else for (r in e) null != (n = t(e[r], r, i)) && (a[a.length] = n);
          return p.apply([], a);
        },
        guid: 1,
        proxy: function (e, i) {
          var n, r, o;
          return (
            "string" == typeof i && ((o = e[i]), (i = e), (e = o)),
            y.isFunction(e)
              ? ((n = I.call(arguments, 2)),
                ((r = function () {
                  return e.apply(i || this, n.concat(I.call(arguments)));
                }).guid = e.guid =
                  e.guid || y.guid++),
                r)
              : t
          );
        },
        access: function (e, i, n, r, o, a, s) {
          var l = 0,
            c = e.length,
            u = null == n;
          if ("object" === y.type(n))
            for (l in ((o = !0), n)) y.access(e, i, l, n[l], !0, a, s);
          else if (
            r !== t &&
            ((o = !0),
            y.isFunction(r) || (s = !0),
            u &&
              (s
                ? (i.call(e, r), (i = null))
                : ((u = i),
                  (i = function (e, t, i) {
                    return u.call(y(e), i);
                  }))),
            i)
          )
            for (; c > l; l++) i(e[l], n, s ? r : r.call(e[l], l, i(e[l], n)));
          return o ? e : u ? i.call(e) : c ? i(e[0], n) : a;
        },
        now: function () {
          return new Date().getTime();
        },
      }),
      (y.ready.promise = function (t) {
        if (!i)
          if (((i = y.Deferred()), "complete" === o.readyState))
            setTimeout(y.ready);
          else if (o.addEventListener)
            o.addEventListener("DOMContentLoaded", w, !1),
              e.addEventListener("load", w, !1);
          else {
            o.attachEvent("onreadystatechange", w), e.attachEvent("onload", w);
            var n = !1;
            try {
              n = null == e.frameElement && o.documentElement;
            } catch (e) {}
            n &&
              n.doScroll &&
              (function e() {
                if (!y.isReady) {
                  try {
                    n.doScroll("left");
                  } catch (t) {
                    return setTimeout(e, 50);
                  }
                  J(), y.ready();
                }
              })();
          }
        return i.promise(t);
      }),
      y.each(
        "Boolean Number String Function Array Date RegExp Object Error".split(
          " "
        ),
        function (e, t) {
          c["[object " + t + "]"] = t.toLowerCase();
        }
      ),
      (n = y(o));
    var b = {};
    (y.Callbacks = function (e) {
      e =
        "string" == typeof e
          ? b[e] ||
            (function (e) {
              var t = (b[e] = {});
              return (
                y.each(e.match(Y) || [], function (e, i) {
                  t[i] = !0;
                }),
                t
              );
            })(e)
          : y.extend({}, e);
      var i,
        n,
        r,
        o,
        a,
        s,
        l = [],
        c = !e.once && [],
        u = function (t) {
          for (
            n = e.memory && t, r = !0, a = s || 0, s = 0, o = l.length, i = !0;
            l && o > a;
            a++
          )
            if (!1 === l[a].apply(t[0], t[1]) && e.stopOnFalse) {
              n = !1;
              break;
            }
          (i = !1),
            l && (c ? c.length && u(c.shift()) : n ? (l = []) : d.disable());
        },
        d = {
          add: function () {
            if (l) {
              var t = l.length;
              (function t(i) {
                y.each(i, function (i, n) {
                  var r = y.type(n);
                  "function" === r
                    ? (e.unique && d.has(n)) || l.push(n)
                    : n && n.length && "string" !== r && t(n);
                });
              })(arguments),
                i ? (o = l.length) : n && ((s = t), u(n));
            }
            return this;
          },
          remove: function () {
            return (
              l &&
                y.each(arguments, function (e, t) {
                  for (var n; (n = y.inArray(t, l, n)) > -1; )
                    l.splice(n, 1), i && (o >= n && o--, a >= n && a--);
                }),
              this
            );
          },
          has: function (e) {
            return e ? y.inArray(e, l) > -1 : !(!l || !l.length);
          },
          empty: function () {
            return (l = []), this;
          },
          disable: function () {
            return (l = c = n = t), this;
          },
          disabled: function () {
            return !l;
          },
          lock: function () {
            return (c = t), n || d.disable(), this;
          },
          locked: function () {
            return !c;
          },
          fireWith: function (e, t) {
            return (
              (t = [e, (t = t || []).slice ? t.slice() : t]),
              !l || (r && !c) || (i ? c.push(t) : u(t)),
              this
            );
          },
          fire: function () {
            return d.fireWith(this, arguments), this;
          },
          fired: function () {
            return !!r;
          },
        };
      return d;
    }),
      y.extend({
        Deferred: function (e) {
          var t = [
              ["resolve", "done", y.Callbacks("once memory"), "resolved"],
              ["reject", "fail", y.Callbacks("once memory"), "rejected"],
              ["notify", "progress", y.Callbacks("memory")],
            ],
            i = "pending",
            n = {
              state: function () {
                return i;
              },
              always: function () {
                return r.done(arguments).fail(arguments), this;
              },
              then: function () {
                var e = arguments;
                return y
                  .Deferred(function (i) {
                    y.each(t, function (t, o) {
                      var a = o[0],
                        s = y.isFunction(e[t]) && e[t];
                      r[o[1]](function () {
                        var e = s && s.apply(this, arguments);
                        e && y.isFunction(e.promise)
                          ? e
                              .promise()
                              .done(i.resolve)
                              .fail(i.reject)
                              .progress(i.notify)
                          : i[a + "With"](
                              this === n ? i.promise() : this,
                              s ? [e] : arguments
                            );
                      });
                    }),
                      (e = null);
                  })
                  .promise();
              },
              promise: function (e) {
                return null != e ? y.extend(e, n) : n;
              },
            },
            r = {};
          return (
            (n.pipe = n.then),
            y.each(t, function (e, o) {
              var a = o[2],
                s = o[3];
              (n[o[1]] = a.add),
                s &&
                  a.add(
                    function () {
                      i = s;
                    },
                    t[1 ^ e][2].disable,
                    t[2][2].lock
                  ),
                (r[o[0]] = function () {
                  return (
                    r[o[0] + "With"](this === r ? n : this, arguments), this
                  );
                }),
                (r[o[0] + "With"] = a.fireWith);
            }),
            n.promise(r),
            e && e.call(r, r),
            r
          );
        },
        when: function (e) {
          var t,
            i,
            n,
            r = 0,
            o = I.call(arguments),
            a = o.length,
            s = 1 !== a || (e && y.isFunction(e.promise)) ? a : 0,
            l = 1 === s ? e : y.Deferred(),
            c = function (e, i, n) {
              return function (r) {
                (i[e] = this),
                  (n[e] = arguments.length > 1 ? I.call(arguments) : r),
                  n === t ? l.notifyWith(i, n) : --s || l.resolveWith(i, n);
              };
            };
          if (a > 1)
            for (t = Array(a), i = Array(a), n = Array(a); a > r; r++)
              o[r] && y.isFunction(o[r].promise)
                ? o[r]
                    .promise()
                    .done(c(r, n, o))
                    .fail(l.reject)
                    .progress(c(r, i, t))
                : --s;
          return s || l.resolveWith(n, o), l.promise();
        },
      }),
      (y.support = (function () {
        var t,
          i,
          n,
          a,
          s,
          l,
          c,
          u,
          d,
          p,
          h = o.createElement("div");
        if (
          (h.setAttribute("className", "t"),
          (h.innerHTML =
            "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>"),
          (i = h.getElementsByTagName("*")),
          (n = h.getElementsByTagName("a")[0]),
          !i || !n || !i.length)
        )
          return {};
        (c = (s = o.createElement("select")).appendChild(
          o.createElement("option")
        )),
          (a = h.getElementsByTagName("input")[0]),
          (n.style.cssText = "top:1px;float:left;opacity:.5"),
          (t = {
            getSetAttribute: "t" !== h.className,
            leadingWhitespace: 3 === h.firstChild.nodeType,
            tbody: !h.getElementsByTagName("tbody").length,
            htmlSerialize: !!h.getElementsByTagName("link").length,
            style: /top/.test(n.getAttribute("style")),
            hrefNormalized: "/a" === n.getAttribute("href"),
            opacity: /^0.5/.test(n.style.opacity),
            cssFloat: !!n.style.cssFloat,
            checkOn: !!a.value,
            optSelected: c.selected,
            enctype: !!o.createElement("form").enctype,
            html5Clone:
              "<:nav></:nav>" !==
              o.createElement("nav").cloneNode(!0).outerHTML,
            boxModel: "CSS1Compat" === o.compatMode,
            deleteExpando: !0,
            noCloneEvent: !0,
            inlineBlockNeedsLayout: !1,
            shrinkWrapBlocks: !1,
            reliableMarginRight: !0,
            boxSizingReliable: !0,
            pixelPosition: !1,
          }),
          (a.checked = !0),
          (t.noCloneChecked = a.cloneNode(!0).checked),
          (s.disabled = !0),
          (t.optDisabled = !c.disabled);
        try {
          delete h.test;
        } catch (e) {
          t.deleteExpando = !1;
        }
        for (p in ((a = o.createElement("input")).setAttribute("value", ""),
        (t.input = "" === a.getAttribute("value")),
        (a.value = "t"),
        a.setAttribute("type", "radio"),
        (t.radioValue = "t" === a.value),
        a.setAttribute("checked", "t"),
        a.setAttribute("name", "t"),
        (l = o.createDocumentFragment()).appendChild(a),
        (t.appendChecked = a.checked),
        (t.checkClone = l.cloneNode(!0).cloneNode(!0).lastChild.checked),
        h.attachEvent &&
          (h.attachEvent("onclick", function () {
            t.noCloneEvent = !1;
          }),
          h.cloneNode(!0).click()),
        {
          submit: !0,
          change: !0,
          focusin: !0,
        }))
          h.setAttribute((u = "on" + p), "t"),
            (t[p + "Bubbles"] = u in e || !1 === h.attributes[u].expando);
        return (
          (h.style.backgroundClip = "content-box"),
          (h.cloneNode(!0).style.backgroundClip = ""),
          (t.clearCloneStyle = "content-box" === h.style.backgroundClip),
          y(function () {
            var i,
              n,
              a,
              s =
                "padding:0;margin:0;border:0;display:block;box-sizing:content-box;-moz-box-sizing:content-box;-webkit-box-sizing:content-box;",
              l = o.getElementsByTagName("body")[0];
            l &&
              (((i = o.createElement("div")).style.cssText =
                "border:0;width:0;height:0;position:absolute;top:0;left:-9999px;margin-top:1px"),
              l.appendChild(i).appendChild(h),
              (h.innerHTML = "<table><tr><td></td><td>t</td></tr></table>"),
              ((a = h.getElementsByTagName("td"))[0].style.cssText =
                "padding:0;margin:0;border:0;display:none"),
              (d = 0 === a[0].offsetHeight),
              (a[0].style.display = ""),
              (a[1].style.display = "none"),
              (t.reliableHiddenOffsets = d && 0 === a[0].offsetHeight),
              (h.innerHTML = ""),
              (h.style.cssText =
                "box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;padding:1px;border:1px;display:block;width:4px;margin-top:1%;position:absolute;top:1%;"),
              (t.boxSizing = 4 === h.offsetWidth),
              (t.doesNotIncludeMarginInBodyOffset = 1 !== l.offsetTop),
              e.getComputedStyle &&
                ((t.pixelPosition =
                  "1%" !== (e.getComputedStyle(h, null) || {}).top),
                (t.boxSizingReliable =
                  "4px" ===
                  (
                    e.getComputedStyle(h, null) || {
                      width: "4px",
                    }
                  ).width),
                ((n = h.appendChild(o.createElement("div"))).style.cssText =
                  h.style.cssText =
                    s),
                (n.style.marginRight = n.style.width = "0"),
                (h.style.width = "1px"),
                (t.reliableMarginRight = !parseFloat(
                  (e.getComputedStyle(n, null) || {}).marginRight
                ))),
              typeof h.style.zoom !== r &&
                ((h.innerHTML = ""),
                (h.style.cssText =
                  s + "width:1px;padding:1px;display:inline;zoom:1"),
                (t.inlineBlockNeedsLayout = 3 === h.offsetWidth),
                (h.style.display = "block"),
                (h.innerHTML = "<div></div>"),
                (h.firstChild.style.width = "5px"),
                (t.shrinkWrapBlocks = 3 !== h.offsetWidth),
                t.inlineBlockNeedsLayout && (l.style.zoom = 1)),
              l.removeChild(i),
              (i = h = a = n = null));
          }),
          (i = s = l = c = n = a = null),
          t
        );
      })());
    var E = /(?:\{[\s\S]*\}|\[[\s\S]*\])$/,
      G = /([A-Z])/g;

    function Q(e, i, n, r) {
      if (y.acceptData(e)) {
        var o,
          a,
          s = y.expando,
          l = "string" == typeof i,
          c = e.nodeType,
          d = c ? y.cache : e,
          p = c ? e[s] : e[s] && s;
        if ((p && d[p] && (r || d[p].data)) || !l || n !== t)
          return (
            p || (c ? (e[s] = p = u.pop() || y.guid++) : (p = s)),
            d[p] || ((d[p] = {}), c || (d[p].toJSON = y.noop)),
            ("object" == typeof i || "function" == typeof i) &&
              (r
                ? (d[p] = y.extend(d[p], i))
                : (d[p].data = y.extend(d[p].data, i))),
            (o = d[p]),
            r || (o.data || (o.data = {}), (o = o.data)),
            n !== t && (o[y.camelCase(i)] = n),
            l ? null == (a = o[i]) && (a = o[y.camelCase(i)]) : (a = o),
            a
          );
      }
    }

    function F(e, t, i) {
      if (y.acceptData(e)) {
        var n,
          r,
          o,
          a = e.nodeType,
          s = a ? y.cache : e,
          l = a ? e[y.expando] : y.expando;
        if (s[l]) {
          if (t && (o = i ? s[l] : s[l].data)) {
            y.isArray(t)
              ? (t = t.concat(y.map(t, y.camelCase)))
              : t in o
              ? (t = [t])
              : (t = (t = y.camelCase(t)) in o ? [t] : t.split(" "));
            for (n = 0, r = t.length; r > n; n++) delete o[t[n]];
            if (!(i ? S : y.isEmptyObject)(o)) return;
          }
          (i || (delete s[l].data, S(s[l]))) &&
            (a
              ? y.cleanData([e], !0)
              : y.support.deleteExpando || s != s.window
              ? delete s[l]
              : (s[l] = null));
        }
      }
    }

    function U(e, i, n) {
      if (n === t && 1 === e.nodeType) {
        var r = "data-" + i.replace(G, "-$1").toLowerCase();
        if ("string" == typeof (n = e.getAttribute(r))) {
          try {
            n =
              "true" === n ||
              ("false" !== n &&
                ("null" === n
                  ? null
                  : +n + "" === n
                  ? +n
                  : E.test(n)
                  ? y.parseJSON(n)
                  : n));
          } catch (e) {}
          y.data(e, i, n);
        } else n = t;
      }
      return n;
    }

    function S(e) {
      var t;
      for (t in e)
        if (("data" !== t || !y.isEmptyObject(e[t])) && "toJSON" !== t)
          return !1;
      return !0;
    }
    y.extend({
      cache: {},
      expando: "jQuery" + (d + Math.random()).replace(/\D/g, ""),
      noData: {
        embed: !0,
        object: "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000",
        applet: !0,
      },
      hasData: function (e) {
        return (
          !!(e = e.nodeType ? y.cache[e[y.expando]] : e[y.expando]) && !S(e)
        );
      },
      data: function (e, t, i) {
        return Q(e, t, i);
      },
      removeData: function (e, t) {
        return F(e, t);
      },
      _data: function (e, t, i) {
        return Q(e, t, i, !0);
      },
      _removeData: function (e, t) {
        return F(e, t, !0);
      },
      acceptData: function (e) {
        if (e.nodeType && 1 !== e.nodeType && 9 !== e.nodeType) return !1;
        var t = e.nodeName && y.noData[e.nodeName.toLowerCase()];
        return !t || (!0 !== t && e.getAttribute("classid") === t);
      },
    }),
      y.fn.extend({
        data: function (e, i) {
          var n,
            r,
            o = this[0],
            a = 0,
            s = null;
          if (e === t) {
            if (
              this.length &&
              ((s = y.data(o)), 1 === o.nodeType && !y._data(o, "parsedAttrs"))
            ) {
              for (n = o.attributes; n.length > a; a++)
                (r = n[a].name).indexOf("data-") ||
                  ((r = y.camelCase(r.slice(5))), U(o, r, s[r]));
              y._data(o, "parsedAttrs", !0);
            }
            return s;
          }
          return "object" == typeof e
            ? this.each(function () {
                y.data(this, e);
              })
            : y.access(
                this,
                function (i) {
                  return i === t
                    ? o
                      ? U(o, e, y.data(o, e))
                      : null
                    : (this.each(function () {
                        y.data(this, e, i);
                      }),
                      t);
                },
                null,
                i,
                arguments.length > 1,
                null,
                !0
              );
        },
        removeData: function (e) {
          return this.each(function () {
            y.removeData(this, e);
          });
        },
      }),
      y.extend({
        queue: function (e, i, n) {
          var r;
          return e
            ? ((i = (i || "fx") + "queue"),
              (r = y._data(e, i)),
              n &&
                (!r || y.isArray(n)
                  ? (r = y._data(e, i, y.makeArray(n)))
                  : r.push(n)),
              r || [])
            : t;
        },
        dequeue: function (e, t) {
          t = t || "fx";
          var i = y.queue(e, t),
            n = i.length,
            r = i.shift(),
            o = y._queueHooks(e, t);
          "inprogress" === r && ((r = i.shift()), n--),
            (o.cur = r),
            r &&
              ("fx" === t && i.unshift("inprogress"),
              delete o.stop,
              r.call(
                e,
                function () {
                  y.dequeue(e, t);
                },
                o
              )),
            !n && o && o.empty.fire();
        },
        _queueHooks: function (e, t) {
          var i = t + "queueHooks";
          return (
            y._data(e, i) ||
            y._data(e, i, {
              empty: y.Callbacks("once memory").add(function () {
                y._removeData(e, t + "queue"), y._removeData(e, i);
              }),
            })
          );
        },
      }),
      y.fn.extend({
        queue: function (e, i) {
          var n = 2;
          return (
            "string" != typeof e && ((i = e), (e = "fx"), n--),
            n > arguments.length
              ? y.queue(this[0], e)
              : i === t
              ? this
              : this.each(function () {
                  var t = y.queue(this, e, i);
                  y._queueHooks(this, e),
                    "fx" === e && "inprogress" !== t[0] && y.dequeue(this, e);
                })
          );
        },
        dequeue: function (e) {
          return this.each(function () {
            y.dequeue(this, e);
          });
        },
        delay: function (e, t) {
          return (
            (e = (y.fx && y.fx.speeds[e]) || e),
            (t = t || "fx"),
            this.queue(t, function (t, i) {
              var n = setTimeout(t, e);
              i.stop = function () {
                clearTimeout(n);
              };
            })
          );
        },
        clearQueue: function (e) {
          return this.queue(e || "fx", []);
        },
        promise: function (e, i) {
          var n,
            r = 1,
            o = y.Deferred(),
            a = this,
            s = this.length,
            l = function () {
              --r || o.resolveWith(a, [a]);
            };
          for ("string" != typeof e && ((i = e), (e = t)), e = e || "fx"; s--; )
            (n = y._data(a[s], e + "queueHooks")) &&
              n.empty &&
              (r++, n.empty.add(l));
          return l(), o.promise(i);
        },
      });
    var L,
      R,
      V = /[\t\r\n]/g,
      A = /\r/g,
      B = /^(?:input|select|textarea|button|object)$/i,
      q = /^(?:a|area)$/i,
      _ =
        /^(?:checked|selected|autofocus|autoplay|async|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped)$/i,
      H = /^(?:checked|selected)$/i,
      X = y.support.getSetAttribute,
      P = y.support.input;
    y.fn.extend({
      attr: function (e, t) {
        return y.access(this, y.attr, e, t, arguments.length > 1);
      },
      removeAttr: function (e) {
        return this.each(function () {
          y.removeAttr(this, e);
        });
      },
      prop: function (e, t) {
        return y.access(this, y.prop, e, t, arguments.length > 1);
      },
      removeProp: function (e) {
        return (
          (e = y.propFix[e] || e),
          this.each(function () {
            try {
              (this[e] = t), delete this[e];
            } catch (e) {}
          })
        );
      },
      addClass: function (e) {
        var t,
          i,
          n,
          r,
          o,
          a = 0,
          s = this.length,
          l = "string" == typeof e && e;
        if (y.isFunction(e))
          return this.each(function (t) {
            y(this).addClass(e.call(this, t, this.className));
          });
        if (l)
          for (t = (e || "").match(Y) || []; s > a; a++)
            if (
              (n =
                1 === (i = this[a]).nodeType &&
                (i.className ? (" " + i.className + " ").replace(V, " ") : " "))
            ) {
              for (o = 0; (r = t[o++]); )
                0 > n.indexOf(" " + r + " ") && (n += r + " ");
              i.className = y.trim(n);
            }
        return this;
      },
      removeClass: function (e) {
        var t,
          i,
          n,
          r,
          o,
          a = 0,
          s = this.length,
          l = 0 === arguments.length || ("string" == typeof e && e);
        if (y.isFunction(e))
          return this.each(function (t) {
            y(this).removeClass(e.call(this, t, this.className));
          });
        if (l)
          for (t = (e || "").match(Y) || []; s > a; a++)
            if (
              (n =
                1 === (i = this[a]).nodeType &&
                (i.className ? (" " + i.className + " ").replace(V, " ") : ""))
            ) {
              for (o = 0; (r = t[o++]); )
                for (; n.indexOf(" " + r + " ") >= 0; )
                  n = n.replace(" " + r + " ", " ");
              i.className = e ? y.trim(n) : "";
            }
        return this;
      },
      toggleClass: function (e, t) {
        var i = typeof e,
          n = "boolean" == typeof t;
        return y.isFunction(e)
          ? this.each(function (i) {
              y(this).toggleClass(e.call(this, i, this.className, t), t);
            })
          : this.each(function () {
              if ("string" === i)
                for (
                  var o, a = 0, s = y(this), l = t, c = e.match(Y) || [];
                  (o = c[a++]);

                )
                  (l = n ? l : !s.hasClass(o)),
                    s[l ? "addClass" : "removeClass"](o);
              else
                (i === r || "boolean" === i) &&
                  (this.className &&
                    y._data(this, "__className__", this.className),
                  (this.className =
                    this.className || !1 === e
                      ? ""
                      : y._data(this, "__className__") || ""));
            });
      },
      hasClass: function (e) {
        for (var t = " " + e + " ", i = 0, n = this.length; n > i; i++)
          if (
            1 === this[i].nodeType &&
            (" " + this[i].className + " ").replace(V, " ").indexOf(t) >= 0
          )
            return !0;
        return !1;
      },
      val: function (e) {
        var i,
          n,
          r,
          o = this[0];
        return arguments.length
          ? ((r = y.isFunction(e)),
            this.each(function (i) {
              var o,
                a = y(this);
              1 === this.nodeType &&
                (null == (o = r ? e.call(this, i, a.val()) : e)
                  ? (o = "")
                  : "number" == typeof o
                  ? (o += "")
                  : y.isArray(o) &&
                    (o = y.map(o, function (e) {
                      return null == e ? "" : e + "";
                    })),
                ((n =
                  y.valHooks[this.type] ||
                  y.valHooks[this.nodeName.toLowerCase()]) &&
                  "set" in n &&
                  n.set(this, o, "value") !== t) ||
                  (this.value = o));
            }))
          : o
          ? (n = y.valHooks[o.type] || y.valHooks[o.nodeName.toLowerCase()]) &&
            "get" in n &&
            (i = n.get(o, "value")) !== t
            ? i
            : "string" == typeof (i = o.value)
            ? i.replace(A, "")
            : null == i
            ? ""
            : i
          : void 0;
      },
    }),
      y.extend({
        valHooks: {
          option: {
            get: function (e) {
              var t = e.attributes.value;
              return !t || t.specified ? e.value : e.text;
            },
          },
          select: {
            get: function (e) {
              for (
                var t,
                  i,
                  n = e.options,
                  r = e.selectedIndex,
                  o = "select-one" === e.type || 0 > r,
                  a = o ? null : [],
                  s = o ? r + 1 : n.length,
                  l = 0 > r ? s : o ? r : 0;
                s > l;
                l++
              )
                if (
                  !(
                    (!(i = n[l]).selected && l !== r) ||
                    (y.support.optDisabled
                      ? i.disabled
                      : null !== i.getAttribute("disabled")) ||
                    (i.parentNode.disabled &&
                      y.nodeName(i.parentNode, "optgroup"))
                  )
                ) {
                  if (((t = y(i).val()), o)) return t;
                  a.push(t);
                }
              return a;
            },
            set: function (e, t) {
              var i = y.makeArray(t);
              return (
                y(e)
                  .find("option")
                  .each(function () {
                    this.selected = y.inArray(y(this).val(), i) >= 0;
                  }),
                i.length || (e.selectedIndex = -1),
                i
              );
            },
          },
        },
        attr: function (e, i, n) {
          var o,
            a,
            s,
            l = e.nodeType;
          if (e && 3 !== l && 8 !== l && 2 !== l)
            return typeof e.getAttribute === r
              ? y.prop(e, i, n)
              : ((a = 1 !== l || !y.isXMLDoc(e)) &&
                  ((i = i.toLowerCase()),
                  (o = y.attrHooks[i] || (_.test(i) ? R : L))),
                n === t
                  ? o && a && "get" in o && null !== (s = o.get(e, i))
                    ? s
                    : (typeof e.getAttribute !== r && (s = e.getAttribute(i)),
                      null == s ? t : s)
                  : null !== n
                  ? o && a && "set" in o && (s = o.set(e, n, i)) !== t
                    ? s
                    : (e.setAttribute(i, n + ""), n)
                  : (y.removeAttr(e, i), t));
        },
        removeAttr: function (e, t) {
          var i,
            n,
            r = 0,
            o = t && t.match(Y);
          if (o && 1 === e.nodeType)
            for (; (i = o[r++]); )
              (n = y.propFix[i] || i),
                _.test(i)
                  ? !X && H.test(i)
                    ? (e[y.camelCase("default-" + i)] = e[n] = !1)
                    : (e[n] = !1)
                  : y.attr(e, i, ""),
                e.removeAttribute(X ? i : n);
        },
        attrHooks: {
          type: {
            set: function (e, t) {
              if (
                !y.support.radioValue &&
                "radio" === t &&
                y.nodeName(e, "input")
              ) {
                var i = e.value;
                return e.setAttribute("type", t), i && (e.value = i), t;
              }
            },
          },
        },
        propFix: {
          tabindex: "tabIndex",
          readonly: "readOnly",
          for: "htmlFor",
          class: "className",
          maxlength: "maxLength",
          cellspacing: "cellSpacing",
          cellpadding: "cellPadding",
          rowspan: "rowSpan",
          colspan: "colSpan",
          usemap: "useMap",
          frameborder: "frameBorder",
          contenteditable: "contentEditable",
        },
        prop: function (e, i, n) {
          var r,
            o,
            a = e.nodeType;
          if (e && 3 !== a && 8 !== a && 2 !== a)
            return (
              (1 !== a || !y.isXMLDoc(e)) &&
                ((i = y.propFix[i] || i), (o = y.propHooks[i])),
              n !== t
                ? o && "set" in o && (r = o.set(e, n, i)) !== t
                  ? r
                  : (e[i] = n)
                : o && "get" in o && null !== (r = o.get(e, i))
                ? r
                : e[i]
            );
        },
        propHooks: {
          tabIndex: {
            get: function (e) {
              var i = e.getAttributeNode("tabindex");
              return i && i.specified
                ? parseInt(i.value, 10)
                : B.test(e.nodeName) || (q.test(e.nodeName) && e.href)
                ? 0
                : t;
            },
          },
        },
      }),
      (R = {
        get: function (e, i) {
          var n = y.prop(e, i),
            r = "boolean" == typeof n && e.getAttribute(i),
            o =
              "boolean" == typeof n
                ? P && X
                  ? null != r
                  : H.test(i)
                  ? e[y.camelCase("default-" + i)]
                  : !!r
                : e.getAttributeNode(i);
          return o && !1 !== o.value ? i.toLowerCase() : t;
        },
        set: function (e, t, i) {
          return (
            !1 === t
              ? y.removeAttr(e, i)
              : (P && X) || !H.test(i)
              ? e.setAttribute((!X && y.propFix[i]) || i, i)
              : (e[y.camelCase("default-" + i)] = e[i] = !0),
            i
          );
        },
      }),
      (P && X) ||
        (y.attrHooks.value = {
          get: function (e, i) {
            var n = e.getAttributeNode(i);
            return y.nodeName(e, "input")
              ? e.defaultValue
              : n && n.specified
              ? n.value
              : t;
          },
          set: function (e, i, n) {
            return y.nodeName(e, "input")
              ? ((e.defaultValue = i), t)
              : L && L.set(e, i, n);
          },
        }),
      X ||
        ((L = y.valHooks.button =
          {
            get: function (e, i) {
              var n = e.getAttributeNode(i);
              return n &&
                ("id" === i || "name" === i || "coords" === i
                  ? "" !== n.value
                  : n.specified)
                ? n.value
                : t;
            },
            set: function (e, i, n) {
              var r = e.getAttributeNode(n);
              return (
                r ||
                  e.setAttributeNode((r = e.ownerDocument.createAttribute(n))),
                (r.value = i += ""),
                "value" === n || i === e.getAttribute(n) ? i : t
              );
            },
          }),
        (y.attrHooks.contenteditable = {
          get: L.get,
          set: function (e, t, i) {
            L.set(e, "" !== t && t, i);
          },
        }),
        y.each(["width", "height"], function (e, i) {
          y.attrHooks[i] = y.extend(y.attrHooks[i], {
            set: function (e, n) {
              return "" === n ? (e.setAttribute(i, "auto"), n) : t;
            },
          });
        })),
      y.support.hrefNormalized ||
        (y.each(["href", "src", "width", "height"], function (e, i) {
          y.attrHooks[i] = y.extend(y.attrHooks[i], {
            get: function (e) {
              var n = e.getAttribute(i, 2);
              return null == n ? t : n;
            },
          });
        }),
        y.each(["href", "src"], function (e, t) {
          y.propHooks[t] = {
            get: function (e) {
              return e.getAttribute(t, 4);
            },
          };
        })),
      y.support.style ||
        (y.attrHooks.style = {
          get: function (e) {
            return e.style.cssText || t;
          },
          set: function (e, t) {
            return (e.style.cssText = t + "");
          },
        }),
      y.support.optSelected ||
        (y.propHooks.selected = y.extend(y.propHooks.selected, {
          get: function (e) {
            var t = e.parentNode;
            return (
              t &&
                (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex),
              null
            );
          },
        })),
      y.support.enctype || (y.propFix.enctype = "encoding"),
      y.support.checkOn ||
        y.each(["radio", "checkbox"], function () {
          y.valHooks[this] = {
            get: function (e) {
              return null === e.getAttribute("value") ? "on" : e.value;
            },
          };
        }),
      y.each(["radio", "checkbox"], function () {
        y.valHooks[this] = y.extend(y.valHooks[this], {
          set: function (e, i) {
            return y.isArray(i)
              ? (e.checked = y.inArray(y(e).val(), i) >= 0)
              : t;
          },
        });
      });
    var $ = /^(?:input|select|textarea)$/i,
      K = /^key/,
      ee = /^(?:mouse|contextmenu)|click/,
      te = /^(?:focusinfocus|focusoutblur)$/,
      ie = /^([^.]*)(?:\.(.+)|)$/;

    function ne() {
      return !0;
    }

    function re() {
      return !1;
    }
    (y.event = {
      global: {},
      add: function (e, i, n, o, a) {
        var s,
          l,
          c,
          u,
          d,
          p,
          h,
          I,
          f,
          m,
          j,
          M = y._data(e);
        if (M) {
          for (
            n.handler && ((n = (u = n).handler), (a = u.selector)),
              n.guid || (n.guid = y.guid++),
              (l = M.events) || (l = M.events = {}),
              (p = M.handle) ||
                ((p = M.handle =
                  function (e) {
                    return typeof y === r || (e && y.event.triggered === e.type)
                      ? t
                      : y.event.dispatch.apply(p.elem, arguments);
                  }).elem = e),
              c = (i = (i || "").match(Y) || [""]).length;
            c--;

          )
            (f = j = (s = ie.exec(i[c]) || [])[1]),
              (m = (s[2] || "").split(".").sort()),
              (d = y.event.special[f] || {}),
              (f = (a ? d.delegateType : d.bindType) || f),
              (d = y.event.special[f] || {}),
              (h = y.extend(
                {
                  type: f,
                  origType: j,
                  data: o,
                  handler: n,
                  guid: n.guid,
                  selector: a,
                  needsContext: a && y.expr.match.needsContext.test(a),
                  namespace: m.join("."),
                },
                u
              )),
              (I = l[f]) ||
                (((I = l[f] = []).delegateCount = 0),
                (d.setup && !1 !== d.setup.call(e, o, m, p)) ||
                  (e.addEventListener
                    ? e.addEventListener(f, p, !1)
                    : e.attachEvent && e.attachEvent("on" + f, p))),
              d.add &&
                (d.add.call(e, h), h.handler.guid || (h.handler.guid = n.guid)),
              a ? I.splice(I.delegateCount++, 0, h) : I.push(h),
              (y.event.global[f] = !0);
          e = null;
        }
      },
      remove: function (e, t, i, n, r) {
        var o,
          a,
          s,
          l,
          c,
          u,
          d,
          p,
          h,
          I,
          f,
          m = y.hasData(e) && y._data(e);
        if (m && (u = m.events)) {
          for (c = (t = (t || "").match(Y) || [""]).length; c--; )
            if (
              ((h = f = (s = ie.exec(t[c]) || [])[1]),
              (I = (s[2] || "").split(".").sort()),
              h)
            ) {
              for (
                d = y.event.special[h] || {},
                  p = u[(h = (n ? d.delegateType : d.bindType) || h)] || [],
                  s =
                    s[2] &&
                    RegExp("(^|\\.)" + I.join("\\.(?:.*\\.|)") + "(\\.|$)"),
                  l = o = p.length;
                o--;

              )
                (a = p[o]),
                  (!r && f !== a.origType) ||
                    (i && i.guid !== a.guid) ||
                    (s && !s.test(a.namespace)) ||
                    (n && n !== a.selector && ("**" !== n || !a.selector)) ||
                    (p.splice(o, 1),
                    a.selector && p.delegateCount--,
                    d.remove && d.remove.call(e, a));
              l &&
                !p.length &&
                ((d.teardown && !1 !== d.teardown.call(e, I, m.handle)) ||
                  y.removeEvent(e, h, m.handle),
                delete u[h]);
            } else for (h in u) y.event.remove(e, h + t[c], i, n, !0);
          y.isEmptyObject(u) && (delete m.handle, y._removeData(e, "events"));
        }
      },
      trigger: function (i, n, r, a) {
        var s,
          l,
          c,
          u,
          d,
          p,
          h,
          I = [r || o],
          f = j.call(i, "type") ? i.type : i,
          m = j.call(i, "namespace") ? i.namespace.split(".") : [];
        if (
          ((c = p = r = r || o),
          3 !== r.nodeType &&
            8 !== r.nodeType &&
            !te.test(f + y.event.triggered) &&
            (f.indexOf(".") >= 0 &&
              ((m = f.split(".")), (f = m.shift()), m.sort()),
            (l = 0 > f.indexOf(":") && "on" + f),
            ((i = i[y.expando]
              ? i
              : new y.Event(f, "object" == typeof i && i)).isTrigger = !0),
            (i.namespace = m.join(".")),
            (i.namespace_re = i.namespace
              ? RegExp("(^|\\.)" + m.join("\\.(?:.*\\.|)") + "(\\.|$)")
              : null),
            (i.result = t),
            i.target || (i.target = r),
            (n = null == n ? [i] : y.makeArray(n, [i])),
            (d = y.event.special[f] || {}),
            a || !d.trigger || !1 !== d.trigger.apply(r, n)))
        ) {
          if (!a && !d.noBubble && !y.isWindow(r)) {
            for (
              u = d.delegateType || f, te.test(u + f) || (c = c.parentNode);
              c;
              c = c.parentNode
            )
              I.push(c), (p = c);
            p === (r.ownerDocument || o) &&
              I.push(p.defaultView || p.parentWindow || e);
          }
          for (h = 0; (c = I[h++]) && !i.isPropagationStopped(); )
            (i.type = h > 1 ? u : d.bindType || f),
              (s =
                (y._data(c, "events") || {})[i.type] && y._data(c, "handle")) &&
                s.apply(c, n),
              (s = l && c[l]) &&
                y.acceptData(c) &&
                s.apply &&
                !1 === s.apply(c, n) &&
                i.preventDefault();
          if (
            ((i.type = f),
            !(
              a ||
              i.isDefaultPrevented() ||
              (d._default && !1 !== d._default.apply(r.ownerDocument, n)) ||
              ("click" === f && y.nodeName(r, "a"))
            ) &&
              y.acceptData(r) &&
              l &&
              r[f] &&
              !y.isWindow(r))
          ) {
            (p = r[l]) && (r[l] = null), (y.event.triggered = f);
            try {
              r[f]();
            } catch (e) {}
            (y.event.triggered = t), p && (r[l] = p);
          }
          return i.result;
        }
      },
      dispatch: function (e) {
        e = y.event.fix(e);
        var i,
          n,
          r,
          o,
          a,
          s = [],
          l = I.call(arguments),
          c = (y._data(this, "events") || {})[e.type] || [],
          u = y.event.special[e.type] || {};
        if (
          ((l[0] = e),
          (e.delegateTarget = this),
          !u.preDispatch || !1 !== u.preDispatch.call(this, e))
        ) {
          for (
            s = y.event.handlers.call(this, e, c), i = 0;
            (o = s[i++]) && !e.isPropagationStopped();

          )
            for (
              e.currentTarget = o.elem, a = 0;
              (r = o.handlers[a++]) && !e.isImmediatePropagationStopped();

            )
              (!e.namespace_re || e.namespace_re.test(r.namespace)) &&
                ((e.handleObj = r),
                (e.data = r.data),
                (n = (
                  (y.event.special[r.origType] || {}).handle || r.handler
                ).apply(o.elem, l)) !== t &&
                  !1 === (e.result = n) &&
                  (e.preventDefault(), e.stopPropagation()));
          return u.postDispatch && u.postDispatch.call(this, e), e.result;
        }
      },
      handlers: function (e, i) {
        var n,
          r,
          o,
          a,
          s = [],
          l = i.delegateCount,
          c = e.target;
        if (l && c.nodeType && (!e.button || "click" !== e.type))
          for (; c != this; c = c.parentNode || this)
            if (1 === c.nodeType && (!0 !== c.disabled || "click" !== e.type)) {
              for (o = [], a = 0; l > a; a++)
                o[(n = (r = i[a]).selector + " ")] === t &&
                  (o[n] = r.needsContext
                    ? y(n, this).index(c) >= 0
                    : y.find(n, this, null, [c]).length),
                  o[n] && o.push(r);
              o.length &&
                s.push({
                  elem: c,
                  handlers: o,
                });
            }
        return (
          i.length > l &&
            s.push({
              elem: this,
              handlers: i.slice(l),
            }),
          s
        );
      },
      fix: function (e) {
        if (e[y.expando]) return e;
        var t,
          i,
          n,
          r = e.type,
          a = e,
          s = this.fixHooks[r];
        for (
          s ||
            (this.fixHooks[r] = s =
              ee.test(r) ? this.mouseHooks : K.test(r) ? this.keyHooks : {}),
            n = s.props ? this.props.concat(s.props) : this.props,
            e = new y.Event(a),
            t = n.length;
          t--;

        )
          e[(i = n[t])] = a[i];
        return (
          e.target || (e.target = a.srcElement || o),
          3 === e.target.nodeType && (e.target = e.target.parentNode),
          (e.metaKey = !!e.metaKey),
          s.filter ? s.filter(e, a) : e
        );
      },
      props:
        "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(
          " "
        ),
      fixHooks: {},
      keyHooks: {
        props: "char charCode key keyCode".split(" "),
        filter: function (e, t) {
          return (
            null == e.which &&
              (e.which = null != t.charCode ? t.charCode : t.keyCode),
            e
          );
        },
      },
      mouseHooks: {
        props:
          "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(
            " "
          ),
        filter: function (e, i) {
          var n,
            r,
            a,
            s = i.button,
            l = i.fromElement;
          return (
            null == e.pageX &&
              null != i.clientX &&
              ((a = (r = e.target.ownerDocument || o).documentElement),
              (n = r.body),
              (e.pageX =
                i.clientX +
                ((a && a.scrollLeft) || (n && n.scrollLeft) || 0) -
                ((a && a.clientLeft) || (n && n.clientLeft) || 0)),
              (e.pageY =
                i.clientY +
                ((a && a.scrollTop) || (n && n.scrollTop) || 0) -
                ((a && a.clientTop) || (n && n.clientTop) || 0))),
            !e.relatedTarget &&
              l &&
              (e.relatedTarget = l === e.target ? i.toElement : l),
            e.which ||
              s === t ||
              (e.which = 1 & s ? 1 : 2 & s ? 3 : 4 & s ? 2 : 0),
            e
          );
        },
      },
      special: {
        load: {
          noBubble: !0,
        },
        click: {
          trigger: function () {
            return y.nodeName(this, "input") &&
              "checkbox" === this.type &&
              this.click
              ? (this.click(), !1)
              : t;
          },
        },
        focus: {
          trigger: function () {
            if (this !== o.activeElement && this.focus)
              try {
                return this.focus(), !1;
              } catch (e) {}
          },
          delegateType: "focusin",
        },
        blur: {
          trigger: function () {
            return this === o.activeElement && this.blur
              ? (this.blur(), !1)
              : t;
          },
          delegateType: "focusout",
        },
        beforeunload: {
          postDispatch: function (e) {
            e.result !== t && (e.originalEvent.returnValue = e.result);
          },
        },
      },
      simulate: function (e, t, i, n) {
        var r = y.extend(new y.Event(), i, {
          type: e,
          isSimulated: !0,
          originalEvent: {},
        });
        n ? y.event.trigger(r, null, t) : y.event.dispatch.call(t, r),
          r.isDefaultPrevented() && i.preventDefault();
      },
    }),
      (y.removeEvent = o.removeEventListener
        ? function (e, t, i) {
            e.removeEventListener && e.removeEventListener(t, i, !1);
          }
        : function (e, t, i) {
            var n = "on" + t;
            e.detachEvent &&
              (typeof e[n] === r && (e[n] = null), e.detachEvent(n, i));
          }),
      (y.Event = function (e, i) {
        return this instanceof y.Event
          ? (e && e.type
              ? ((this.originalEvent = e),
                (this.type = e.type),
                (this.isDefaultPrevented =
                  e.defaultPrevented ||
                  !1 === e.returnValue ||
                  (e.getPreventDefault && e.getPreventDefault())
                    ? ne
                    : re))
              : (this.type = e),
            i && y.extend(this, i),
            (this.timeStamp = (e && e.timeStamp) || y.now()),
            (this[y.expando] = !0),
            t)
          : new y.Event(e, i);
      }),
      (y.Event.prototype = {
        isDefaultPrevented: re,
        isPropagationStopped: re,
        isImmediatePropagationStopped: re,
        preventDefault: function () {
          var e = this.originalEvent;
          (this.isDefaultPrevented = ne),
            e && (e.preventDefault ? e.preventDefault() : (e.returnValue = !1));
        },
        stopPropagation: function () {
          var e = this.originalEvent;
          (this.isPropagationStopped = ne),
            e &&
              (e.stopPropagation && e.stopPropagation(), (e.cancelBubble = !0));
        },
        stopImmediatePropagation: function () {
          (this.isImmediatePropagationStopped = ne), this.stopPropagation();
        },
      }),
      y.each(
        {
          mouseenter: "mouseover",
          mouseleave: "mouseout",
        },
        function (e, t) {
          y.event.special[e] = {
            delegateType: t,
            bindType: t,
            handle: function (e) {
              var i,
                n = e.relatedTarget,
                r = e.handleObj;
              return (
                (!n || (n !== this && !y.contains(this, n))) &&
                  ((e.type = r.origType),
                  (i = r.handler.apply(this, arguments)),
                  (e.type = t)),
                i
              );
            },
          };
        }
      ),
      y.support.submitBubbles ||
        (y.event.special.submit = {
          setup: function () {
            return (
              !y.nodeName(this, "form") &&
              (y.event.add(
                this,
                "click._submit keypress._submit",
                function (e) {
                  var i = e.target,
                    n =
                      y.nodeName(i, "input") || y.nodeName(i, "button")
                        ? i.form
                        : t;
                  n &&
                    !y._data(n, "submitBubbles") &&
                    (y.event.add(n, "submit._submit", function (e) {
                      e._submit_bubble = !0;
                    }),
                    y._data(n, "submitBubbles", !0));
                }
              ),
              t)
            );
          },
          postDispatch: function (e) {
            e._submit_bubble &&
              (delete e._submit_bubble,
              this.parentNode &&
                !e.isTrigger &&
                y.event.simulate("submit", this.parentNode, e, !0));
          },
          teardown: function () {
            return (
              !y.nodeName(this, "form") && (y.event.remove(this, "._submit"), t)
            );
          },
        }),
      y.support.changeBubbles ||
        (y.event.special.change = {
          setup: function () {
            return $.test(this.nodeName)
              ? (("checkbox" === this.type || "radio" === this.type) &&
                  (y.event.add(this, "propertychange._change", function (e) {
                    "checked" === e.originalEvent.propertyName &&
                      (this._just_changed = !0);
                  }),
                  y.event.add(this, "click._change", function (e) {
                    this._just_changed &&
                      !e.isTrigger &&
                      (this._just_changed = !1),
                      y.event.simulate("change", this, e, !0);
                  })),
                !1)
              : (y.event.add(this, "beforeactivate._change", function (e) {
                  var t = e.target;
                  $.test(t.nodeName) &&
                    !y._data(t, "changeBubbles") &&
                    (y.event.add(t, "change._change", function (e) {
                      !this.parentNode ||
                        e.isSimulated ||
                        e.isTrigger ||
                        y.event.simulate("change", this.parentNode, e, !0);
                    }),
                    y._data(t, "changeBubbles", !0));
                }),
                t);
          },
          handle: function (e) {
            var i = e.target;
            return this !== i ||
              e.isSimulated ||
              e.isTrigger ||
              ("radio" !== i.type && "checkbox" !== i.type)
              ? e.handleObj.handler.apply(this, arguments)
              : t;
          },
          teardown: function () {
            return y.event.remove(this, "._change"), !$.test(this.nodeName);
          },
        }),
      y.support.focusinBubbles ||
        y.each(
          {
            focus: "focusin",
            blur: "focusout",
          },
          function (e, t) {
            var i = 0,
              n = function (e) {
                y.event.simulate(t, e.target, y.event.fix(e), !0);
              };
            y.event.special[t] = {
              setup: function () {
                0 == i++ && o.addEventListener(e, n, !0);
              },
              teardown: function () {
                0 == --i && o.removeEventListener(e, n, !0);
              },
            };
          }
        ),
      y.fn.extend({
        on: function (e, i, n, r, o) {
          var a, s;
          if ("object" == typeof e) {
            for (a in ("string" != typeof i && ((n = n || i), (i = t)), e))
              this.on(a, i, n, e[a], o);
            return this;
          }
          if (
            (null == n && null == r
              ? ((r = i), (n = i = t))
              : null == r &&
                ("string" == typeof i
                  ? ((r = n), (n = t))
                  : ((r = n), (n = i), (i = t))),
            !1 === r)
          )
            r = re;
          else if (!r) return this;
          return (
            1 === o &&
              ((s = r),
              ((r = function (e) {
                return y().off(e), s.apply(this, arguments);
              }).guid = s.guid || (s.guid = y.guid++))),
            this.each(function () {
              y.event.add(this, e, r, n, i);
            })
          );
        },
        one: function (e, t, i, n) {
          return this.on(e, t, i, n, 1);
        },
        off: function (e, i, n) {
          var r, o;
          if (e && e.preventDefault && e.handleObj)
            return (
              (r = e.handleObj),
              y(e.delegateTarget).off(
                r.namespace ? r.origType + "." + r.namespace : r.origType,
                r.selector,
                r.handler
              ),
              this
            );
          if ("object" == typeof e) {
            for (o in e) this.off(o, i, e[o]);
            return this;
          }
          return (
            (!1 === i || "function" == typeof i) && ((n = i), (i = t)),
            !1 === n && (n = re),
            this.each(function () {
              y.event.remove(this, e, n, i);
            })
          );
        },
        bind: function (e, t, i) {
          return this.on(e, null, t, i);
        },
        unbind: function (e, t) {
          return this.off(e, null, t);
        },
        delegate: function (e, t, i, n) {
          return this.on(t, e, i, n);
        },
        undelegate: function (e, t, i) {
          return 1 === arguments.length
            ? this.off(e, "**")
            : this.off(t, e || "**", i);
        },
        trigger: function (e, t) {
          return this.each(function () {
            y.event.trigger(e, t, this);
          });
        },
        triggerHandler: function (e, i) {
          var n = this[0];
          return n ? y.event.trigger(e, i, n, !0) : t;
        },
      }),
      (function (e, t) {
        var i,
          n,
          r,
          o,
          a,
          s,
          l,
          c,
          u,
          d,
          p,
          h,
          I,
          f,
          m,
          j,
          M,
          N = "sizzle" + -new Date(),
          Y = e.document,
          T = {},
          Z = 0,
          g = 0,
          O = ie(),
          z = ie(),
          W = ie(),
          D = typeof t,
          k = 1 << 31,
          x = [],
          v = x.pop,
          w = x.push,
          J = x.slice,
          C =
            x.indexOf ||
            function (e) {
              for (var t = 0, i = this.length; i > t; t++)
                if (this[t] === e) return t;
              return -1;
            },
          b = "[\\x20\\t\\r\\n\\f]",
          E = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
          G = E.replace("w", "w#"),
          Q =
            "\\[" +
            b +
            "*(" +
            E +
            ")" +
            b +
            "*(?:([*^$|!~]?=)" +
            b +
            "*(?:(['\"])((?:\\\\.|[^\\\\])*?)\\3|(" +
            G +
            ")|)|)" +
            b +
            "*\\]",
          F =
            ":(" +
            E +
            ")(?:\\(((['\"])((?:\\\\.|[^\\\\])*?)\\3|((?:\\\\.|[^\\\\()[\\]]|" +
            Q.replace(3, 8) +
            ")*)|.*)\\)|)",
          U = RegExp("^" + b + "+|((?:^|[^\\\\])(?:\\\\.)*)" + b + "+$", "g"),
          S = RegExp("^" + b + "*," + b + "*"),
          L = RegExp("^" + b + "*([\\x20\\t\\r\\n\\f>+~])" + b + "*"),
          R = RegExp(F),
          V = RegExp("^" + G + "$"),
          A = {
            ID: RegExp("^#(" + E + ")"),
            CLASS: RegExp("^\\.(" + E + ")"),
            NAME: RegExp("^\\[name=['\"]?(" + E + ")['\"]?\\]"),
            TAG: RegExp("^(" + E.replace("w", "w*") + ")"),
            ATTR: RegExp("^" + Q),
            PSEUDO: RegExp("^" + F),
            CHILD: RegExp(
              "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
                b +
                "*(even|odd|(([+-]|)(\\d*)n|)" +
                b +
                "*(?:([+-]|)" +
                b +
                "*(\\d+)|))" +
                b +
                "*\\)|)",
              "i"
            ),
            needsContext: RegExp(
              "^" +
                b +
                "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
                b +
                "*((?:-\\d)?\\d*)" +
                b +
                "*\\)|)(?=[^-]|$)",
              "i"
            ),
          },
          B = /[\x20\t\r\n\f]*[+~]/,
          q = /^[^{]+\{\s*\[native code/,
          _ = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
          H = /^(?:input|select|textarea|button)$/i,
          X = /^h\d$/i,
          P = /'|\\/g,
          $ = /\=[\x20\t\r\n\f]*([^'"\]]*)[\x20\t\r\n\f]*\]/g,
          K = /\\([\da-fA-F]{1,6}[\x20\t\r\n\f]?|.)/g,
          ee = function (e, t) {
            var i = "0x" + t - 65536;
            return i != i
              ? t
              : 0 > i
              ? String.fromCharCode(i + 65536)
              : String.fromCharCode(55296 | (i >> 10), 56320 | (1023 & i));
          };
        try {
          J.call(Y.documentElement.childNodes, 0)[0].nodeType;
        } catch (e) {
          J = function (e) {
            for (var t, i = []; (t = this[e++]); ) i.push(t);
            return i;
          };
        }

        function te(e) {
          return q.test(e + "");
        }

        function ie() {
          var e,
            t = [];
          return (e = function (i, n) {
            return (
              t.push((i += " ")) > r.cacheLength && delete e[t.shift()],
              (e[i] = n)
            );
          });
        }

        function ne(e) {
          return (e[N] = !0), e;
        }

        function re(e) {
          var t = d.createElement("div");
          try {
            return e(t);
          } catch (e) {
            return !1;
          } finally {
            t = null;
          }
        }

        function oe(e, t, i, n) {
          var r, o, a, s, l, c, p, f, m, M;
          if (
            ((t ? t.ownerDocument || t : Y) !== d && u(t),
            (i = i || []),
            !e || "string" != typeof e)
          )
            return i;
          if (1 !== (s = (t = t || d).nodeType) && 9 !== s) return [];
          if (!h && !n) {
            if ((r = _.exec(e)))
              if ((a = r[1])) {
                if (9 === s) {
                  if (!(o = t.getElementById(a)) || !o.parentNode) return i;
                  if (o.id === a) return i.push(o), i;
                } else if (
                  t.ownerDocument &&
                  (o = t.ownerDocument.getElementById(a)) &&
                  j(t, o) &&
                  o.id === a
                )
                  return i.push(o), i;
              } else {
                if (r[2])
                  return w.apply(i, J.call(t.getElementsByTagName(e), 0)), i;
                if ((a = r[3]) && T.getByClassName && t.getElementsByClassName)
                  return w.apply(i, J.call(t.getElementsByClassName(a), 0)), i;
              }
            if (T.qsa && !I.test(e)) {
              if (
                ((p = !0),
                (f = N),
                (m = t),
                (M = 9 === s && e),
                1 === s && "object" !== t.nodeName.toLowerCase())
              ) {
                for (
                  c = ue(e),
                    (p = t.getAttribute("id"))
                      ? (f = p.replace(P, "\\$&"))
                      : t.setAttribute("id", f),
                    f = "[id='" + f + "'] ",
                    l = c.length;
                  l--;

                )
                  c[l] = f + de(c[l]);
                (m = (B.test(e) && t.parentNode) || t), (M = c.join(","));
              }
              if (M)
                try {
                  return w.apply(i, J.call(m.querySelectorAll(M), 0)), i;
                } catch (e) {
                } finally {
                  p || t.removeAttribute("id");
                }
            }
          }
          return Me(e.replace(U, "$1"), t, i, n);
        }

        function ae(e, t) {
          var i = t && e,
            n = i && (~t.sourceIndex || k) - (~e.sourceIndex || k);
          if (n) return n;
          if (i) for (; (i = i.nextSibling); ) if (i === t) return -1;
          return e ? 1 : -1;
        }

        function se(e) {
          return function (t) {
            return "input" === t.nodeName.toLowerCase() && t.type === e;
          };
        }

        function le(e) {
          return function (t) {
            var i = t.nodeName.toLowerCase();
            return ("input" === i || "button" === i) && t.type === e;
          };
        }

        function ce(e) {
          return ne(function (t) {
            return (
              (t = +t),
              ne(function (i, n) {
                for (var r, o = e([], i.length, t), a = o.length; a--; )
                  i[(r = o[a])] && (i[r] = !(n[r] = i[r]));
              })
            );
          });
        }
        for (i in ((a = oe.isXML =
          function (e) {
            var t = e && (e.ownerDocument || e).documentElement;
            return !!t && "HTML" !== t.nodeName;
          }),
        (u = oe.setDocument =
          function (e) {
            var i = e ? e.ownerDocument || e : Y;
            return i !== d && 9 === i.nodeType && i.documentElement
              ? ((d = i),
                (p = i.documentElement),
                (h = a(i)),
                (T.tagNameNoComments = re(function (e) {
                  return (
                    e.appendChild(i.createComment("")),
                    !e.getElementsByTagName("*").length
                  );
                })),
                (T.attributes = re(function (e) {
                  e.innerHTML = "<select></select>";
                  var t = typeof e.lastChild.getAttribute("multiple");
                  return "boolean" !== t && "string" !== t;
                })),
                (T.getByClassName = re(function (e) {
                  return (
                    (e.innerHTML =
                      "<div class='hidden e'></div><div class='hidden'></div>"),
                    !(
                      !e.getElementsByClassName ||
                      !e.getElementsByClassName("e").length
                    ) &&
                      ((e.lastChild.className = "e"),
                      2 === e.getElementsByClassName("e").length)
                  );
                })),
                (T.getByName = re(function (e) {
                  (e.id = N + 0),
                    (e.innerHTML =
                      "<a name='" + N + "'></a><div name='" + N + "'></div>"),
                    p.insertBefore(e, p.firstChild);
                  var t =
                    i.getElementsByName &&
                    i.getElementsByName(N).length ===
                      2 + i.getElementsByName(N + 0).length;
                  return (
                    (T.getIdNotName = !i.getElementById(N)), p.removeChild(e), t
                  );
                })),
                (r.attrHandle = re(function (e) {
                  return (
                    (e.innerHTML = "<a href='#'></a>"),
                    e.firstChild &&
                      typeof e.firstChild.getAttribute !== D &&
                      "#" === e.firstChild.getAttribute("href")
                  );
                })
                  ? {}
                  : {
                      href: function (e) {
                        return e.getAttribute("href", 2);
                      },
                      type: function (e) {
                        return e.getAttribute("type");
                      },
                    }),
                T.getIdNotName
                  ? ((r.find.ID = function (e, t) {
                      if (typeof t.getElementById !== D && !h) {
                        var i = t.getElementById(e);
                        return i && i.parentNode ? [i] : [];
                      }
                    }),
                    (r.filter.ID = function (e) {
                      var t = e.replace(K, ee);
                      return function (e) {
                        return e.getAttribute("id") === t;
                      };
                    }))
                  : ((r.find.ID = function (e, i) {
                      if (typeof i.getElementById !== D && !h) {
                        var n = i.getElementById(e);
                        return n
                          ? n.id === e ||
                            (typeof n.getAttributeNode !== D &&
                              n.getAttributeNode("id").value === e)
                            ? [n]
                            : t
                          : [];
                      }
                    }),
                    (r.filter.ID = function (e) {
                      var t = e.replace(K, ee);
                      return function (e) {
                        var i =
                          typeof e.getAttributeNode !== D &&
                          e.getAttributeNode("id");
                        return i && i.value === t;
                      };
                    })),
                (r.find.TAG = T.tagNameNoComments
                  ? function (e, i) {
                      return typeof i.getElementsByTagName !== D
                        ? i.getElementsByTagName(e)
                        : t;
                    }
                  : function (e, t) {
                      var i,
                        n = [],
                        r = 0,
                        o = t.getElementsByTagName(e);
                      if ("*" === e) {
                        for (; (i = o[r++]); ) 1 === i.nodeType && n.push(i);
                        return n;
                      }
                      return o;
                    }),
                (r.find.NAME =
                  T.getByName &&
                  function (e, i) {
                    return typeof i.getElementsByName !== D
                      ? i.getElementsByName(name)
                      : t;
                  }),
                (r.find.CLASS =
                  T.getByClassName &&
                  function (e, i) {
                    return typeof i.getElementsByClassName === D || h
                      ? t
                      : i.getElementsByClassName(e);
                  }),
                (f = []),
                (I = [":focus"]),
                (T.qsa = te(i.querySelectorAll)) &&
                  (re(function (e) {
                    (e.innerHTML =
                      "<select><option selected=''></option></select>"),
                      e.querySelectorAll("[selected]").length ||
                        I.push(
                          "\\[" +
                            b +
                            "*(?:checked|disabled|ismap|multiple|readonly|selected|value)"
                        ),
                      e.querySelectorAll(":checked").length ||
                        I.push(":checked");
                  }),
                  re(function (e) {
                    (e.innerHTML = "<input type='hidden' i=''/>"),
                      e.querySelectorAll("[i^='']").length &&
                        I.push("[*^$]=" + b + "*(?:\"\"|'')"),
                      e.querySelectorAll(":enabled").length ||
                        I.push(":enabled", ":disabled"),
                      e.querySelectorAll("*,:x"),
                      I.push(",.*:");
                  })),
                (T.matchesSelector = te(
                  (m =
                    p.matchesSelector ||
                    p.mozMatchesSelector ||
                    p.webkitMatchesSelector ||
                    p.oMatchesSelector ||
                    p.msMatchesSelector)
                )) &&
                  re(function (e) {
                    (T.disconnectedMatch = m.call(e, "div")),
                      m.call(e, "[s!='']:x"),
                      f.push("!=", F);
                  }),
                (I = RegExp(I.join("|"))),
                (f = RegExp(f.join("|"))),
                (j =
                  te(p.contains) || p.compareDocumentPosition
                    ? function (e, t) {
                        var i = 9 === e.nodeType ? e.documentElement : e,
                          n = t && t.parentNode;
                        return (
                          e === n ||
                          !(
                            !n ||
                            1 !== n.nodeType ||
                            !(i.contains
                              ? i.contains(n)
                              : e.compareDocumentPosition &&
                                16 & e.compareDocumentPosition(n))
                          )
                        );
                      }
                    : function (e, t) {
                        if (t)
                          for (; (t = t.parentNode); ) if (t === e) return !0;
                        return !1;
                      }),
                (M = p.compareDocumentPosition
                  ? function (e, t) {
                      var n;
                      return e === t
                        ? ((l = !0), 0)
                        : (n =
                            t.compareDocumentPosition &&
                            e.compareDocumentPosition &&
                            e.compareDocumentPosition(t))
                        ? 1 & n ||
                          (e.parentNode && 11 === e.parentNode.nodeType)
                          ? e === i || j(Y, e)
                            ? -1
                            : t === i || j(Y, t)
                            ? 1
                            : 0
                          : 4 & n
                          ? -1
                          : 1
                        : e.compareDocumentPosition
                        ? -1
                        : 1;
                    }
                  : function (e, t) {
                      var n,
                        r = 0,
                        o = e.parentNode,
                        a = t.parentNode,
                        s = [e],
                        c = [t];
                      if (e === t) return (l = !0), 0;
                      if (!o || !a)
                        return e === i ? -1 : t === i ? 1 : o ? -1 : a ? 1 : 0;
                      if (o === a) return ae(e, t);
                      for (n = e; (n = n.parentNode); ) s.unshift(n);
                      for (n = t; (n = n.parentNode); ) c.unshift(n);
                      for (; s[r] === c[r]; ) r++;
                      return r
                        ? ae(s[r], c[r])
                        : s[r] === Y
                        ? -1
                        : c[r] === Y
                        ? 1
                        : 0;
                    }),
                (l = !1),
                [0, 0].sort(M),
                (T.detectDuplicates = l),
                d)
              : d;
          }),
        (oe.matches = function (e, t) {
          return oe(e, null, null, t);
        }),
        (oe.matchesSelector = function (e, t) {
          if (
            ((e.ownerDocument || e) !== d && u(e),
            (t = t.replace($, "='$1']")),
            !(!T.matchesSelector || h || (f && f.test(t)) || I.test(t)))
          )
            try {
              var i = m.call(e, t);
              if (
                i ||
                T.disconnectedMatch ||
                (e.document && 11 !== e.document.nodeType)
              )
                return i;
            } catch (e) {}
          return oe(t, d, null, [e]).length > 0;
        }),
        (oe.contains = function (e, t) {
          return (e.ownerDocument || e) !== d && u(e), j(e, t);
        }),
        (oe.attr = function (e, t) {
          var i;
          return (
            (e.ownerDocument || e) !== d && u(e),
            h || (t = t.toLowerCase()),
            (i = r.attrHandle[t])
              ? i(e)
              : h || T.attributes
              ? e.getAttribute(t)
              : ((i = e.getAttributeNode(t)) || e.getAttribute(t)) &&
                !0 === e[t]
              ? t
              : i && i.specified
              ? i.value
              : null
          );
        }),
        (oe.error = function (e) {
          throw Error("Syntax error, unrecognized expression: " + e);
        }),
        (oe.uniqueSort = function (e) {
          var t,
            i = [],
            n = 1,
            r = 0;
          if (((l = !T.detectDuplicates), e.sort(M), l)) {
            for (; (t = e[n]); n++) t === e[n - 1] && (r = i.push(n));
            for (; r--; ) e.splice(i[r], 1);
          }
          return e;
        }),
        (o = oe.getText =
          function (e) {
            var t,
              i = "",
              n = 0,
              r = e.nodeType;
            if (r) {
              if (1 === r || 9 === r || 11 === r) {
                if ("string" == typeof e.textContent) return e.textContent;
                for (e = e.firstChild; e; e = e.nextSibling) i += o(e);
              } else if (3 === r || 4 === r) return e.nodeValue;
            } else for (; (t = e[n]); n++) i += o(t);
            return i;
          }),
        (r = oe.selectors =
          {
            cacheLength: 50,
            createPseudo: ne,
            match: A,
            find: {},
            relative: {
              ">": {
                dir: "parentNode",
                first: !0,
              },
              " ": {
                dir: "parentNode",
              },
              "+": {
                dir: "previousSibling",
                first: !0,
              },
              "~": {
                dir: "previousSibling",
              },
            },
            preFilter: {
              ATTR: function (e) {
                return (
                  (e[1] = e[1].replace(K, ee)),
                  (e[3] = (e[4] || e[5] || "").replace(K, ee)),
                  "~=" === e[2] && (e[3] = " " + e[3] + " "),
                  e.slice(0, 4)
                );
              },
              CHILD: function (e) {
                return (
                  (e[1] = e[1].toLowerCase()),
                  "nth" === e[1].slice(0, 3)
                    ? (e[3] || oe.error(e[0]),
                      (e[4] = +(e[4]
                        ? e[5] + (e[6] || 1)
                        : 2 * ("even" === e[3] || "odd" === e[3]))),
                      (e[5] = +(e[7] + e[8] || "odd" === e[3])))
                    : e[3] && oe.error(e[0]),
                  e
                );
              },
              PSEUDO: function (e) {
                var t,
                  i = !e[5] && e[2];
                return A.CHILD.test(e[0])
                  ? null
                  : (e[4]
                      ? (e[2] = e[4])
                      : i &&
                        R.test(i) &&
                        (t = ue(i, !0)) &&
                        (t = i.indexOf(")", i.length - t) - i.length) &&
                        ((e[0] = e[0].slice(0, t)), (e[2] = i.slice(0, t))),
                    e.slice(0, 3));
              },
            },
            filter: {
              TAG: function (e) {
                return "*" === e
                  ? function () {
                      return !0;
                    }
                  : ((e = e.replace(K, ee).toLowerCase()),
                    function (t) {
                      return t.nodeName && t.nodeName.toLowerCase() === e;
                    });
              },
              CLASS: function (e) {
                var t = O[e + " "];
                return (
                  t ||
                  ((t = RegExp("(^|" + b + ")" + e + "(" + b + "|$)")) &&
                    O(e, function (e) {
                      return t.test(
                        e.className ||
                          (typeof e.getAttribute !== D &&
                            e.getAttribute("class")) ||
                          ""
                      );
                    }))
                );
              },
              ATTR: function (e, t, i) {
                return function (n) {
                  var r = oe.attr(n, e);
                  return null == r
                    ? "!=" === t
                    : !t ||
                        ((r += ""),
                        "=" === t
                          ? r === i
                          : "!=" === t
                          ? r !== i
                          : "^=" === t
                          ? i && 0 === r.indexOf(i)
                          : "*=" === t
                          ? i && r.indexOf(i) > -1
                          : "$=" === t
                          ? i && r.slice(-i.length) === i
                          : "~=" === t
                          ? (" " + r + " ").indexOf(i) > -1
                          : "|=" === t &&
                            (r === i || r.slice(0, i.length + 1) === i + "-"));
                };
              },
              CHILD: function (e, t, i, n, r) {
                var o = "nth" !== e.slice(0, 3),
                  a = "last" !== e.slice(-4),
                  s = "of-type" === t;
                return 1 === n && 0 === r
                  ? function (e) {
                      return !!e.parentNode;
                    }
                  : function (t, i, l) {
                      var c,
                        u,
                        d,
                        p,
                        h,
                        I,
                        f = o !== a ? "nextSibling" : "previousSibling",
                        m = t.parentNode,
                        j = s && t.nodeName.toLowerCase(),
                        M = !l && !s;
                      if (m) {
                        if (o) {
                          for (; f; ) {
                            for (d = t; (d = d[f]); )
                              if (
                                s
                                  ? d.nodeName.toLowerCase() === j
                                  : 1 === d.nodeType
                              )
                                return !1;
                            I = f = "only" === e && !I && "nextSibling";
                          }
                          return !0;
                        }
                        if (((I = [a ? m.firstChild : m.lastChild]), a && M)) {
                          for (
                            h =
                              (c = (u = m[N] || (m[N] = {}))[e] || [])[0] ===
                                Z && c[1],
                              p = c[0] === Z && c[2],
                              d = h && m.childNodes[h];
                            (d = (++h && d && d[f]) || (p = h = 0) || I.pop());

                          )
                            if (1 === d.nodeType && ++p && d === t) {
                              u[e] = [Z, h, p];
                              break;
                            }
                        } else if (
                          M &&
                          (c = (t[N] || (t[N] = {}))[e]) &&
                          c[0] === Z
                        )
                          p = c[1];
                        else
                          for (
                            ;
                            (d =
                              (++h && d && d[f]) || (p = h = 0) || I.pop()) &&
                            ((s
                              ? d.nodeName.toLowerCase() !== j
                              : 1 !== d.nodeType) ||
                              !++p ||
                              (M && ((d[N] || (d[N] = {}))[e] = [Z, p]),
                              d !== t));

                          );
                        return (p -= r) === n || (0 == p % n && p / n >= 0);
                      }
                    };
              },
              PSEUDO: function (e, t) {
                var i,
                  n =
                    r.pseudos[e] ||
                    r.setFilters[e.toLowerCase()] ||
                    oe.error("unsupported pseudo: " + e);
                return n[N]
                  ? n(t)
                  : n.length > 1
                  ? ((i = [e, e, "", t]),
                    r.setFilters.hasOwnProperty(e.toLowerCase())
                      ? ne(function (e, i) {
                          for (var r, o = n(e, t), a = o.length; a--; )
                            e[(r = C.call(e, o[a]))] = !(i[r] = o[a]);
                        })
                      : function (e) {
                          return n(e, 0, i);
                        })
                  : n;
              },
            },
            pseudos: {
              not: ne(function (e) {
                var t = [],
                  i = [],
                  n = s(e.replace(U, "$1"));
                return n[N]
                  ? ne(function (e, t, i, r) {
                      for (var o, a = n(e, null, r, []), s = e.length; s--; )
                        (o = a[s]) && (e[s] = !(t[s] = o));
                    })
                  : function (e, r, o) {
                      return (t[0] = e), n(t, null, o, i), !i.pop();
                    };
              }),
              has: ne(function (e) {
                return function (t) {
                  return oe(e, t).length > 0;
                };
              }),
              contains: ne(function (e) {
                return function (t) {
                  return (t.textContent || t.innerText || o(t)).indexOf(e) > -1;
                };
              }),
              lang: ne(function (e) {
                return (
                  V.test(e || "") || oe.error("unsupported lang: " + e),
                  (e = e.replace(K, ee).toLowerCase()),
                  function (t) {
                    var i;
                    do {
                      if (
                        (i = h
                          ? t.getAttribute("xml:lang") || t.getAttribute("lang")
                          : t.lang)
                      )
                        return (
                          (i = i.toLowerCase()) === e ||
                          0 === i.indexOf(e + "-")
                        );
                    } while ((t = t.parentNode) && 1 === t.nodeType);
                    return !1;
                  }
                );
              }),
              target: function (t) {
                var i = e.location && e.location.hash;
                return i && i.slice(1) === t.id;
              },
              root: function (e) {
                return e === p;
              },
              focus: function (e) {
                return (
                  e === d.activeElement &&
                  (!d.hasFocus || d.hasFocus()) &&
                  !!(e.type || e.href || ~e.tabIndex)
                );
              },
              enabled: function (e) {
                return !1 === e.disabled;
              },
              disabled: function (e) {
                return !0 === e.disabled;
              },
              checked: function (e) {
                var t = e.nodeName.toLowerCase();
                return (
                  ("input" === t && !!e.checked) ||
                  ("option" === t && !!e.selected)
                );
              },
              selected: function (e) {
                return (
                  e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
                );
              },
              empty: function (e) {
                for (e = e.firstChild; e; e = e.nextSibling)
                  if (e.nodeName > "@" || 3 === e.nodeType || 4 === e.nodeType)
                    return !1;
                return !0;
              },
              parent: function (e) {
                return !r.pseudos.empty(e);
              },
              header: function (e) {
                return X.test(e.nodeName);
              },
              input: function (e) {
                return H.test(e.nodeName);
              },
              button: function (e) {
                var t = e.nodeName.toLowerCase();
                return ("input" === t && "button" === e.type) || "button" === t;
              },
              text: function (e) {
                var t;
                return (
                  "input" === e.nodeName.toLowerCase() &&
                  "text" === e.type &&
                  (null == (t = e.getAttribute("type")) ||
                    t.toLowerCase() === e.type)
                );
              },
              first: ce(function () {
                return [0];
              }),
              last: ce(function (e, t) {
                return [t - 1];
              }),
              eq: ce(function (e, t, i) {
                return [0 > i ? i + t : i];
              }),
              even: ce(function (e, t) {
                for (var i = 0; t > i; i += 2) e.push(i);
                return e;
              }),
              odd: ce(function (e, t) {
                for (var i = 1; t > i; i += 2) e.push(i);
                return e;
              }),
              lt: ce(function (e, t, i) {
                for (var n = 0 > i ? i + t : i; --n >= 0; ) e.push(n);
                return e;
              }),
              gt: ce(function (e, t, i) {
                for (var n = 0 > i ? i + t : i; t > ++n; ) e.push(n);
                return e;
              }),
            },
          }),
        {
          radio: !0,
          checkbox: !0,
          file: !0,
          password: !0,
          image: !0,
        }))
          r.pseudos[i] = se(i);
        for (i in {
          submit: !0,
          reset: !0,
        })
          r.pseudos[i] = le(i);

        function ue(e, t) {
          var i,
            n,
            o,
            a,
            s,
            l,
            c,
            u = z[e + " "];
          if (u) return t ? 0 : u.slice(0);
          for (s = e, l = [], c = r.preFilter; s; ) {
            for (a in ((!i || (n = S.exec(s))) &&
              (n && (s = s.slice(n[0].length) || s), l.push((o = []))),
            (i = !1),
            (n = L.exec(s)) &&
              ((i = n.shift()),
              o.push({
                value: i,
                type: n[0].replace(U, " "),
              }),
              (s = s.slice(i.length))),
            r.filter))
              !(n = A[a].exec(s)) ||
                (c[a] && !(n = c[a](n))) ||
                ((i = n.shift()),
                o.push({
                  value: i,
                  type: a,
                  matches: n,
                }),
                (s = s.slice(i.length)));
            if (!i) break;
          }
          return t ? s.length : s ? oe.error(e) : z(e, l).slice(0);
        }

        function de(e) {
          for (var t = 0, i = e.length, n = ""; i > t; t++) n += e[t].value;
          return n;
        }

        function pe(e, t, i) {
          var r = t.dir,
            o = i && "parentNode" === r,
            a = g++;
          return t.first
            ? function (t, i, n) {
                for (; (t = t[r]); )
                  if (1 === t.nodeType || o) return e(t, i, n);
              }
            : function (t, i, s) {
                var l,
                  c,
                  u,
                  d = Z + " " + a;
                if (s) {
                  for (; (t = t[r]); )
                    if ((1 === t.nodeType || o) && e(t, i, s)) return !0;
                } else
                  for (; (t = t[r]); )
                    if (1 === t.nodeType || o)
                      if ((c = (u = t[N] || (t[N] = {}))[r]) && c[0] === d) {
                        if (!0 === (l = c[1]) || l === n) return !0 === l;
                      } else if (
                        (((c = u[r] = [d])[1] = e(t, i, s) || n), !0 === c[1])
                      )
                        return !0;
              };
        }

        function he(e) {
          return e.length > 1
            ? function (t, i, n) {
                for (var r = e.length; r--; ) if (!e[r](t, i, n)) return !1;
                return !0;
              }
            : e[0];
        }

        function Ie(e, t, i, n, r) {
          for (var o, a = [], s = 0, l = e.length, c = null != t; l > s; s++)
            (o = e[s]) && (!i || i(o, n, r)) && (a.push(o), c && t.push(s));
          return a;
        }

        function fe(e, t, i, n, r, o) {
          return (
            n && !n[N] && (n = fe(n)),
            r && !r[N] && (r = fe(r, o)),
            ne(function (o, a, s, l) {
              var c,
                u,
                d,
                p = [],
                h = [],
                I = a.length,
                f =
                  o ||
                  (function (e, t, i) {
                    for (var n = 0, r = t.length; r > n; n++) oe(e, t[n], i);
                    return i;
                  })(t || "*", s.nodeType ? [s] : s, []),
                m = !e || (!o && t) ? f : Ie(f, p, e, s, l),
                j = i ? (r || (o ? e : I || n) ? [] : a) : m;
              if ((i && i(m, j, s, l), n))
                for (c = Ie(j, h), n(c, [], s, l), u = c.length; u--; )
                  (d = c[u]) && (j[h[u]] = !(m[h[u]] = d));
              if (o) {
                if (r || e) {
                  if (r) {
                    for (c = [], u = j.length; u--; )
                      (d = j[u]) && c.push((m[u] = d));
                    r(null, (j = []), c, l);
                  }
                  for (u = j.length; u--; )
                    (d = j[u]) &&
                      (c = r ? C.call(o, d) : p[u]) > -1 &&
                      (o[c] = !(a[c] = d));
                }
              } else (j = Ie(j === a ? j.splice(I, j.length) : j)), r ? r(null, a, j, l) : w.apply(a, j);
            })
          );
        }

        function me(e) {
          for (
            var t,
              i,
              n,
              o = e.length,
              a = r.relative[e[0].type],
              s = a || r.relative[" "],
              l = a ? 1 : 0,
              u = pe(
                function (e) {
                  return e === t;
                },
                s,
                !0
              ),
              d = pe(
                function (e) {
                  return C.call(t, e) > -1;
                },
                s,
                !0
              ),
              p = [
                function (e, i, n) {
                  return (
                    (!a && (n || i !== c)) ||
                    ((t = i).nodeType ? u(e, i, n) : d(e, i, n))
                  );
                },
              ];
            o > l;
            l++
          )
            if ((i = r.relative[e[l].type])) p = [pe(he(p), i)];
            else {
              if ((i = r.filter[e[l].type].apply(null, e[l].matches))[N]) {
                for (n = ++l; o > n && !r.relative[e[n].type]; n++);
                return fe(
                  l > 1 && he(p),
                  l > 1 && de(e.slice(0, l - 1)).replace(U, "$1"),
                  i,
                  n > l && me(e.slice(l, n)),
                  o > n && me((e = e.slice(n))),
                  o > n && de(e)
                );
              }
              p.push(i);
            }
          return he(p);
        }

        function je(e, t) {
          var i = 0,
            o = t.length > 0,
            a = e.length > 0,
            s = function (s, l, u, p, h) {
              var I,
                f,
                m,
                j = [],
                M = 0,
                y = "0",
                N = s && [],
                Y = null != h,
                T = c,
                g = s || (a && r.find.TAG("*", (h && l.parentNode) || l)),
                O = (Z += null == T ? 1 : Math.random() || 0.1);
              for (
                Y && ((c = l !== d && l), (n = i));
                null != (I = g[y]);
                y++
              ) {
                if (a && I) {
                  for (f = 0; (m = e[f++]); )
                    if (m(I, l, u)) {
                      p.push(I);
                      break;
                    }
                  Y && ((Z = O), (n = ++i));
                }
                o && ((I = !m && I) && M--, s && N.push(I));
              }
              if (((M += y), o && y !== M)) {
                for (f = 0; (m = t[f++]); ) m(N, j, l, u);
                if (s) {
                  if (M > 0) for (; y--; ) N[y] || j[y] || (j[y] = v.call(p));
                  j = Ie(j);
                }
                w.apply(p, j),
                  Y &&
                    !s &&
                    j.length > 0 &&
                    M + t.length > 1 &&
                    oe.uniqueSort(p);
              }
              return Y && ((Z = O), (c = T)), N;
            };
          return o ? ne(s) : s;
        }

        function Me(e, t, i, n) {
          var o,
            a,
            l,
            c,
            u,
            d = ue(e);
          if (!n && 1 === d.length) {
            if (
              (a = d[0] = d[0].slice(0)).length > 2 &&
              "ID" === (l = a[0]).type &&
              9 === t.nodeType &&
              !h &&
              r.relative[a[1].type]
            ) {
              if (!(t = r.find.ID(l.matches[0].replace(K, ee), t)[0])) return i;
              e = e.slice(a.shift().value.length);
            }
            for (
              o = A.needsContext.test(e) ? 0 : a.length;
              o-- && ((l = a[o]), !r.relative[(c = l.type)]);

            )
              if (
                (u = r.find[c]) &&
                (n = u(
                  l.matches[0].replace(K, ee),
                  (B.test(a[0].type) && t.parentNode) || t
                ))
              ) {
                if ((a.splice(o, 1), !(e = n.length && de(a))))
                  return w.apply(i, J.call(n, 0)), i;
                break;
              }
          }
          return s(e, d)(n, t, h, i, B.test(e)), i;
        }

        function ye() {}
        (s = oe.compile =
          function (e, t) {
            var i,
              n = [],
              r = [],
              o = W[e + " "];
            if (!o) {
              for (t || (t = ue(e)), i = t.length; i--; )
                (o = me(t[i]))[N] ? n.push(o) : r.push(o);
              o = W(e, je(r, n));
            }
            return o;
          }),
          (r.pseudos.nth = r.pseudos.eq),
          (r.filters = ye.prototype = r.pseudos),
          (r.setFilters = new ye()),
          u(),
          (oe.attr = y.attr),
          (y.find = oe),
          (y.expr = oe.selectors),
          (y.expr[":"] = y.expr.pseudos),
          (y.unique = oe.uniqueSort),
          (y.text = oe.getText),
          (y.isXMLDoc = oe.isXML),
          (y.contains = oe.contains);
      })(e);
    var oe = /Until$/,
      ae = /^(?:parents|prev(?:Until|All))/,
      se = /^.[^:#\[\.,]*$/,
      le = y.expr.match.needsContext,
      ce = {
        children: !0,
        contents: !0,
        next: !0,
        prev: !0,
      };

    function ue(e, t) {
      do {
        e = e[t];
      } while (e && 1 !== e.nodeType);
      return e;
    }

    function de(e, t, i) {
      if (((t = t || 0), y.isFunction(t)))
        return y.grep(e, function (e, n) {
          return !!t.call(e, n, e) === i;
        });
      if (t.nodeType)
        return y.grep(e, function (e) {
          return (e === t) === i;
        });
      if ("string" == typeof t) {
        var n = y.grep(e, function (e) {
          return 1 === e.nodeType;
        });
        if (se.test(t)) return y.filter(t, n, !i);
        t = y.filter(t, n);
      }
      return y.grep(e, function (e) {
        return y.inArray(e, t) >= 0 === i;
      });
    }

    function pe(e) {
      var t = he.split("|"),
        i = e.createDocumentFragment();
      if (i.createElement) for (; t.length; ) i.createElement(t.pop());
      return i;
    }
    y.fn.extend({
      find: function (e) {
        var t,
          i,
          n,
          r = this.length;
        if ("string" != typeof e)
          return (
            (n = this),
            this.pushStack(
              y(e).filter(function () {
                for (t = 0; r > t; t++) if (y.contains(n[t], this)) return !0;
              })
            )
          );
        for (i = [], t = 0; r > t; t++) y.find(e, this[t], i);
        return (
          ((i = this.pushStack(r > 1 ? y.unique(i) : i)).selector =
            (this.selector ? this.selector + " " : "") + e),
          i
        );
      },
      has: function (e) {
        var t,
          i = y(e, this),
          n = i.length;
        return this.filter(function () {
          for (t = 0; n > t; t++) if (y.contains(this, i[t])) return !0;
        });
      },
      not: function (e) {
        return this.pushStack(de(this, e, !1));
      },
      filter: function (e) {
        return this.pushStack(de(this, e, !0));
      },
      is: function (e) {
        return (
          !!e &&
          ("string" == typeof e
            ? le.test(e)
              ? y(e, this.context).index(this[0]) >= 0
              : y.filter(e, this).length > 0
            : this.filter(e).length > 0)
        );
      },
      closest: function (e, t) {
        for (
          var i,
            n = 0,
            r = this.length,
            o = [],
            a =
              le.test(e) || "string" != typeof e ? y(e, t || this.context) : 0;
          r > n;
          n++
        )
          for (
            i = this[n];
            i && i.ownerDocument && i !== t && 11 !== i.nodeType;

          ) {
            if (a ? a.index(i) > -1 : y.find.matchesSelector(i, e)) {
              o.push(i);
              break;
            }
            i = i.parentNode;
          }
        return this.pushStack(o.length > 1 ? y.unique(o) : o);
      },
      index: function (e) {
        return e
          ? "string" == typeof e
            ? y.inArray(this[0], y(e))
            : y.inArray(e.jquery ? e[0] : e, this)
          : this[0] && this[0].parentNode
          ? this.first().prevAll().length
          : -1;
      },
      add: function (e, t) {
        var i =
            "string" == typeof e
              ? y(e, t)
              : y.makeArray(e && e.nodeType ? [e] : e),
          n = y.merge(this.get(), i);
        return this.pushStack(y.unique(n));
      },
      addBack: function (e) {
        return this.add(
          null == e ? this.prevObject : this.prevObject.filter(e)
        );
      },
    }),
      (y.fn.andSelf = y.fn.addBack),
      y.each(
        {
          parent: function (e) {
            var t = e.parentNode;
            return t && 11 !== t.nodeType ? t : null;
          },
          parents: function (e) {
            return y.dir(e, "parentNode");
          },
          parentsUntil: function (e, t, i) {
            return y.dir(e, "parentNode", i);
          },
          next: function (e) {
            return ue(e, "nextSibling");
          },
          prev: function (e) {
            return ue(e, "previousSibling");
          },
          nextAll: function (e) {
            return y.dir(e, "nextSibling");
          },
          prevAll: function (e) {
            return y.dir(e, "previousSibling");
          },
          nextUntil: function (e, t, i) {
            return y.dir(e, "nextSibling", i);
          },
          prevUntil: function (e, t, i) {
            return y.dir(e, "previousSibling", i);
          },
          siblings: function (e) {
            return y.sibling((e.parentNode || {}).firstChild, e);
          },
          children: function (e) {
            return y.sibling(e.firstChild);
          },
          contents: function (e) {
            return y.nodeName(e, "iframe")
              ? e.contentDocument || e.contentWindow.document
              : y.merge([], e.childNodes);
          },
        },
        function (e, t) {
          y.fn[e] = function (i, n) {
            var r = y.map(this, t, i);
            return (
              oe.test(e) || (n = i),
              n && "string" == typeof n && (r = y.filter(n, r)),
              (r = this.length > 1 && !ce[e] ? y.unique(r) : r),
              this.length > 1 && ae.test(e) && (r = r.reverse()),
              this.pushStack(r)
            );
          };
        }
      ),
      y.extend({
        filter: function (e, t, i) {
          return (
            i && (e = ":not(" + e + ")"),
            1 === t.length
              ? y.find.matchesSelector(t[0], e)
                ? [t[0]]
                : []
              : y.find.matches(e, t)
          );
        },
        dir: function (e, i, n) {
          for (
            var r = [], o = e[i];
            o &&
            9 !== o.nodeType &&
            (n === t || 1 !== o.nodeType || !y(o).is(n));

          )
            1 === o.nodeType && r.push(o), (o = o[i]);
          return r;
        },
        sibling: function (e, t) {
          for (var i = []; e; e = e.nextSibling)
            1 === e.nodeType && e !== t && i.push(e);
          return i;
        },
      });
    var he =
        "abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",
      Ie = / jQuery\d+="(?:null|\d+)"/g,
      fe = RegExp("<(?:" + he + ")[\\s/>]", "i"),
      me = /^\s+/,
      je =
        /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
      Me = /<([\w:]+)/,
      ye = /<tbody/i,
      Ne = /<|&#?\w+;/,
      Ye = /<(?:script|style|link)/i,
      Te = /^(?:checkbox|radio)$/i,
      Ze = /checked\s*(?:[^=]|=\s*.checked.)/i,
      ge = /^$|\/(?:java|ecma)script/i,
      Oe = /^true\/(.*)/,
      ze = /^\s*<!(?:\[countriesData\[|--)|(?:\]\]|--)>\s*$/g,
      We = {
        option: [1, "<select multiple='multiple'>", "</select>"],
        legend: [1, "<fieldset>", "</fieldset>"],
        area: [1, "<map>", "</map>"],
        param: [1, "<object>", "</object>"],
        thead: [1, "<table>", "</table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        col: [2, "<table><tbody></tbody><colgroup>", "</colgroup></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: y.support.htmlSerialize
          ? [0, "", ""]
          : [1, "X<div>", "</div>"],
      },
      De = pe(o).appendChild(o.createElement("div"));

    function ke(e, t) {
      return (
        e.getElementsByTagName(t)[0] ||
        e.appendChild(e.ownerDocument.createElement(t))
      );
    }

    function xe(e) {
      var t = e.getAttributeNode("type");
      return (e.type = (t && t.specified) + "/" + e.type), e;
    }

    function ve(e) {
      var t = Oe.exec(e.type);
      return t ? (e.type = t[1]) : e.removeAttribute("type"), e;
    }

    function we(e, t) {
      for (var i, n = 0; null != (i = e[n]); n++)
        y._data(i, "globalEval", !t || y._data(t[n], "globalEval"));
    }

    function Je(e, t) {
      if (1 === t.nodeType && y.hasData(e)) {
        var i,
          n,
          r,
          o = y._data(e),
          a = y._data(t, o),
          s = o.events;
        if (s)
          for (i in (delete a.handle, (a.events = {}), s))
            for (n = 0, r = s[i].length; r > n; n++) y.event.add(t, i, s[i][n]);
        a.data && (a.data = y.extend({}, a.data));
      }
    }

    function Ce(e, t) {
      var i, n, r;
      if (1 === t.nodeType) {
        if (
          ((i = t.nodeName.toLowerCase()),
          !y.support.noCloneEvent && t[y.expando])
        ) {
          for (n in (r = y._data(t)).events) y.removeEvent(t, n, r.handle);
          t.removeAttribute(y.expando);
        }
        "script" === i && t.text !== e.text
          ? ((xe(t).text = e.text), ve(t))
          : "object" === i
          ? (t.parentNode && (t.outerHTML = e.outerHTML),
            y.support.html5Clone &&
              e.innerHTML &&
              !y.trim(t.innerHTML) &&
              (t.innerHTML = e.innerHTML))
          : "input" === i && Te.test(e.type)
          ? ((t.defaultChecked = t.checked = e.checked),
            t.value !== e.value && (t.value = e.value))
          : "option" === i
          ? (t.defaultSelected = t.selected = e.defaultSelected)
          : ("input" === i || "textarea" === i) &&
            (t.defaultValue = e.defaultValue);
      }
    }

    function be(e, i) {
      var n,
        o,
        a = 0,
        s =
          typeof e.getElementsByTagName !== r
            ? e.getElementsByTagName(i || "*")
            : typeof e.querySelectorAll !== r
            ? e.querySelectorAll(i || "*")
            : t;
      if (!s)
        for (s = [], n = e.childNodes || e; null != (o = n[a]); a++)
          !i || y.nodeName(o, i) ? s.push(o) : y.merge(s, be(o, i));
      return i === t || (i && y.nodeName(e, i)) ? y.merge([e], s) : s;
    }

    function Ee(e) {
      Te.test(e.type) && (e.defaultChecked = e.checked);
    }
    (We.optgroup = We.option),
      (We.tbody = We.tfoot = We.colgroup = We.caption = We.thead),
      (We.th = We.td),
      y.fn.extend({
        text: function (e) {
          return y.access(
            this,
            function (e) {
              return e === t
                ? y.text(this)
                : this.empty().append(
                    ((this[0] && this[0].ownerDocument) || o).createTextNode(e)
                  );
            },
            null,
            e,
            arguments.length
          );
        },
        wrapAll: function (e) {
          if (y.isFunction(e))
            return this.each(function (t) {
              y(this).wrapAll(e.call(this, t));
            });
          if (this[0]) {
            var t = y(e, this[0].ownerDocument).eq(0).clone(!0);
            this[0].parentNode && t.insertBefore(this[0]),
              t
                .map(function () {
                  for (
                    var e = this;
                    e.firstChild && 1 === e.firstChild.nodeType;

                  )
                    e = e.firstChild;
                  return e;
                })
                .append(this);
          }
          return this;
        },
        wrapInner: function (e) {
          return y.isFunction(e)
            ? this.each(function (t) {
                y(this).wrapInner(e.call(this, t));
              })
            : this.each(function () {
                var t = y(this),
                  i = t.contents();
                i.length ? i.wrapAll(e) : t.append(e);
              });
        },
        wrap: function (e) {
          var t = y.isFunction(e);
          return this.each(function (i) {
            y(this).wrapAll(t ? e.call(this, i) : e);
          });
        },
        unwrap: function () {
          return this.parent()
            .each(function () {
              y.nodeName(this, "body") || y(this).replaceWith(this.childNodes);
            })
            .end();
        },
        append: function () {
          return this.domManip(arguments, !0, function (e) {
            (1 === this.nodeType ||
              11 === this.nodeType ||
              9 === this.nodeType) &&
              this.appendChild(e);
          });
        },
        prepend: function () {
          return this.domManip(arguments, !0, function (e) {
            (1 === this.nodeType ||
              11 === this.nodeType ||
              9 === this.nodeType) &&
              this.insertBefore(e, this.firstChild);
          });
        },
        before: function () {
          return this.domManip(arguments, !1, function (e) {
            this.parentNode && this.parentNode.insertBefore(e, this);
          });
        },
        after: function () {
          return this.domManip(arguments, !1, function (e) {
            this.parentNode &&
              this.parentNode.insertBefore(e, this.nextSibling);
          });
        },
        remove: function (e, t) {
          for (var i, n = 0; null != (i = this[n]); n++)
            (!e || y.filter(e, [i]).length > 0) &&
              (t || 1 !== i.nodeType || y.cleanData(be(i)),
              i.parentNode &&
                (t && y.contains(i.ownerDocument, i) && we(be(i, "script")),
                i.parentNode.removeChild(i)));
          return this;
        },
        empty: function () {
          for (var e, t = 0; null != (e = this[t]); t++) {
            for (1 === e.nodeType && y.cleanData(be(e, !1)); e.firstChild; )
              e.removeChild(e.firstChild);
            e.options && y.nodeName(e, "select") && (e.options.length = 0);
          }
          return this;
        },
        clone: function (e, t) {
          return (
            (e = null != e && e),
            (t = null == t ? e : t),
            this.map(function () {
              return y.clone(this, e, t);
            })
          );
        },
        html: function (e) {
          return y.access(
            this,
            function (e) {
              var i = this[0] || {},
                n = 0,
                r = this.length;
              if (e === t)
                return 1 === i.nodeType ? i.innerHTML.replace(Ie, "") : t;
              if (
                !(
                  "string" != typeof e ||
                  Ye.test(e) ||
                  (!y.support.htmlSerialize && fe.test(e)) ||
                  (!y.support.leadingWhitespace && me.test(e)) ||
                  We[(Me.exec(e) || ["", ""])[1].toLowerCase()]
                )
              ) {
                e = e.replace(je, "<$1></$2>");
                try {
                  for (; r > n; n++)
                    1 === (i = this[n] || {}).nodeType &&
                      (y.cleanData(be(i, !1)), (i.innerHTML = e));
                  i = 0;
                } catch (e) {}
              }
              i && this.empty().append(e);
            },
            null,
            e,
            arguments.length
          );
        },
        replaceWith: function (e) {
          return (
            y.isFunction(e) ||
              "string" == typeof e ||
              (e = y(e).not(this).detach()),
            this.domManip([e], !0, function (e) {
              var t = this.nextSibling,
                i = this.parentNode;
              i && (y(this).remove(), i.insertBefore(e, t));
            })
          );
        },
        detach: function (e) {
          return this.remove(e, !0);
        },
        domManip: function (e, i, n) {
          e = p.apply([], e);
          var r,
            o,
            a,
            s,
            l,
            c,
            u = 0,
            d = this.length,
            h = this,
            I = d - 1,
            f = e[0],
            m = y.isFunction(f);
          if (
            m ||
            (!(1 >= d || "string" != typeof f || y.support.checkClone) &&
              Ze.test(f))
          )
            return this.each(function (r) {
              var o = h.eq(r);
              m && (e[0] = f.call(this, r, i ? o.html() : t)),
                o.domManip(e, i, n);
            });
          if (
            d &&
            ((r = (c = y.buildFragment(e, this[0].ownerDocument, !1, this))
              .firstChild),
            1 === c.childNodes.length && (c = r),
            r)
          ) {
            for (
              i = i && y.nodeName(r, "tr"),
                a = (s = y.map(be(c, "script"), xe)).length;
              d > u;
              u++
            )
              (o = c),
                u !== I &&
                  ((o = y.clone(o, !0, !0)), a && y.merge(s, be(o, "script"))),
                n.call(
                  i && y.nodeName(this[u], "table")
                    ? ke(this[u], "tbody")
                    : this[u],
                  o,
                  u
                );
            if (a)
              for (
                l = s[s.length - 1].ownerDocument, y.map(s, ve), u = 0;
                a > u;
                u++
              )
                (o = s[u]),
                  ge.test(o.type || "") &&
                    !y._data(o, "globalEval") &&
                    y.contains(l, o) &&
                    (o.src
                      ? y.ajax({
                          url: o.src,
                          type: "GET",
                          dataType: "script",
                          async: !1,
                          global: !1,
                          throws: !0,
                        })
                      : y.globalEval(
                          (
                            o.text ||
                            o.textContent ||
                            o.innerHTML ||
                            ""
                          ).replace(ze, "")
                        ));
            c = r = null;
          }
          return this;
        },
      }),
      y.each(
        {
          appendTo: "append",
          prependTo: "prepend",
          insertBefore: "before",
          insertAfter: "after",
          replaceAll: "replaceWith",
        },
        function (e, t) {
          y.fn[e] = function (e) {
            for (var i, n = 0, r = [], o = y(e), a = o.length - 1; a >= n; n++)
              (i = n === a ? this : this.clone(!0)),
                y(o[n])[t](i),
                h.apply(r, i.get());
            return this.pushStack(r);
          };
        }
      ),
      y.extend({
        clone: function (e, t, i) {
          var n,
            r,
            o,
            a,
            s,
            l = y.contains(e.ownerDocument, e);
          if (
            (y.support.html5Clone ||
            y.isXMLDoc(e) ||
            !fe.test("<" + e.nodeName + ">")
              ? (o = e.cloneNode(!0))
              : ((De.innerHTML = e.outerHTML),
                De.removeChild((o = De.firstChild))),
            !(
              (y.support.noCloneEvent && y.support.noCloneChecked) ||
              (1 !== e.nodeType && 11 !== e.nodeType) ||
              y.isXMLDoc(e)
            ))
          )
            for (n = be(o), s = be(e), a = 0; null != (r = s[a]); ++a)
              n[a] && Ce(r, n[a]);
          if (t)
            if (i)
              for (
                s = s || be(e), n = n || be(o), a = 0;
                null != (r = s[a]);
                a++
              )
                Je(r, n[a]);
            else Je(e, o);
          return (
            (n = be(o, "script")).length > 0 && we(n, !l && be(e, "script")),
            (n = s = r = null),
            o
          );
        },
        buildFragment: function (e, t, i, n) {
          for (
            var r, o, a, s, l, c, u, d = e.length, p = pe(t), h = [], I = 0;
            d > I;
            I++
          )
            if ((o = e[I]) || 0 === o)
              if ("object" === y.type(o)) y.merge(h, o.nodeType ? [o] : o);
              else if (Ne.test(o)) {
                for (
                  s = s || p.appendChild(t.createElement("div")),
                    l = (Me.exec(o) || ["", ""])[1].toLowerCase(),
                    u = We[l] || We._default,
                    s.innerHTML = u[1] + o.replace(je, "<$1></$2>") + u[2],
                    r = u[0];
                  r--;

                )
                  s = s.lastChild;
                if (
                  (!y.support.leadingWhitespace &&
                    me.test(o) &&
                    h.push(t.createTextNode(me.exec(o)[0])),
                  !y.support.tbody)
                )
                  for (
                    r =
                      (o =
                        "table" !== l || ye.test(o)
                          ? "<table>" !== u[1] || ye.test(o)
                            ? 0
                            : s
                          : s.firstChild) && o.childNodes.length;
                    r--;

                  )
                    y.nodeName((c = o.childNodes[r]), "tbody") &&
                      !c.childNodes.length &&
                      o.removeChild(c);
                for (
                  y.merge(h, s.childNodes), s.textContent = "";
                  s.firstChild;

                )
                  s.removeChild(s.firstChild);
                s = p.lastChild;
              } else h.push(t.createTextNode(o));
          for (
            s && p.removeChild(s),
              y.support.appendChecked || y.grep(be(h, "input"), Ee),
              I = 0;
            (o = h[I++]);

          )
            if (
              (!n || -1 === y.inArray(o, n)) &&
              ((a = y.contains(o.ownerDocument, o)),
              (s = be(p.appendChild(o), "script")),
              a && we(s),
              i)
            )
              for (r = 0; (o = s[r++]); ) ge.test(o.type || "") && i.push(o);
          return (s = null), p;
        },
        cleanData: function (e, t) {
          for (
            var i,
              n,
              o,
              a,
              s = 0,
              l = y.expando,
              c = y.cache,
              d = y.support.deleteExpando,
              p = y.event.special;
            null != (i = e[s]);
            s++
          )
            if ((t || y.acceptData(i)) && (a = (o = i[l]) && c[o])) {
              if (a.events)
                for (n in a.events)
                  p[n] ? y.event.remove(i, n) : y.removeEvent(i, n, a.handle);
              c[o] &&
                (delete c[o],
                d
                  ? delete i[l]
                  : typeof i.removeAttribute !== r
                  ? i.removeAttribute(l)
                  : (i[l] = null),
                u.push(o));
            }
        },
      });
    var Ge,
      Qe,
      Fe,
      Ue = /alpha\([^)]*\)/i,
      Se = /opacity\s*=\s*([^)]*)/,
      Le = /^(top|right|bottom|left)$/,
      Re = /^(none|table(?!-c[ea]).+)/,
      Ve = /^margin/,
      Ae = RegExp("^(" + N + ")(.*)$", "i"),
      Be = RegExp("^(" + N + ")(?!px)[a-z%]+$", "i"),
      qe = RegExp("^([+-])=(" + N + ")", "i"),
      _e = {
        BODY: "block",
      },
      He = {
        position: "absolute",
        visibility: "hidden",
        display: "block",
      },
      Xe = {
        letterSpacing: 0,
        fontWeight: 400,
      },
      Pe = ["Top", "Right", "Bottom", "Left"],
      $e = ["Webkit", "O", "Moz", "ms"];

    function Ke(e, t) {
      if (t in e) return t;
      for (
        var i = t.charAt(0).toUpperCase() + t.slice(1), n = t, r = $e.length;
        r--;

      )
        if ((t = $e[r] + i) in e) return t;
      return n;
    }

    function et(e, t) {
      return (
        (e = t || e),
        "none" === y.css(e, "display") || !y.contains(e.ownerDocument, e)
      );
    }

    function tt(e, t) {
      for (var i, n, r, o = [], a = 0, s = e.length; s > a; a++)
        (n = e[a]).style &&
          ((o[a] = y._data(n, "olddisplay")),
          (i = n.style.display),
          t
            ? (o[a] || "none" !== i || (n.style.display = ""),
              "" === n.style.display &&
                et(n) &&
                (o[a] = y._data(n, "olddisplay", ot(n.nodeName))))
            : o[a] ||
              ((r = et(n)),
              ((i && "none" !== i) || !r) &&
                y._data(n, "olddisplay", r ? i : y.css(n, "display"))));
      for (a = 0; s > a; a++)
        (n = e[a]).style &&
          ((t && "none" !== n.style.display && "" !== n.style.display) ||
            (n.style.display = t ? o[a] || "" : "none"));
      return e;
    }

    function it(e, t, i) {
      var n = Ae.exec(t);
      return n ? Math.max(0, n[1] - (i || 0)) + (n[2] || "px") : t;
    }

    function nt(e, t, i, n, r) {
      for (
        var o = i === (n ? "border" : "content") ? 4 : "width" === t ? 1 : 0,
          a = 0;
        4 > o;
        o += 2
      )
        "margin" === i && (a += y.css(e, i + Pe[o], !0, r)),
          n
            ? ("content" === i && (a -= y.css(e, "padding" + Pe[o], !0, r)),
              "margin" !== i &&
                (a -= y.css(e, "border" + Pe[o] + "Width", !0, r)))
            : ((a += y.css(e, "padding" + Pe[o], !0, r)),
              "padding" !== i &&
                (a += y.css(e, "border" + Pe[o] + "Width", !0, r)));
      return a;
    }

    function rt(e, t, i) {
      var n = !0,
        r = "width" === t ? e.offsetWidth : e.offsetHeight,
        o = Qe(e),
        a =
          y.support.boxSizing && "border-box" === y.css(e, "boxSizing", !1, o);
      if (0 >= r || null == r) {
        if (
          ((0 > (r = Fe(e, t, o)) || null == r) && (r = e.style[t]), Be.test(r))
        )
          return r;
        (n = a && (y.support.boxSizingReliable || r === e.style[t])),
          (r = parseFloat(r) || 0);
      }
      return r + nt(e, t, i || (a ? "border" : "content"), n, o) + "px";
    }

    function ot(e) {
      var t = o,
        i = _e[e];
      return (
        i ||
          (("none" !== (i = at(e, t)) && i) ||
            ((t = (
              (Ge = (
                Ge ||
                y("<iframe frameborder='0' width='0' height='0'/>").css(
                  "cssText",
                  "display:block !important"
                )
              ).appendTo(t.documentElement))[0].contentWindow ||
              Ge[0].contentDocument
            ).document).write("<!doctype html><html><body>"),
            t.close(),
            (i = at(e, t)),
            Ge.detach()),
          (_e[e] = i)),
        i
      );
    }

    function at(e, t) {
      var i = y(t.createElement(e)).appendTo(t.body),
        n = y.css(i[0], "display");
      return i.remove(), n;
    }
    y.fn.extend({
      css: function (e, i) {
        return y.access(
          this,
          function (e, i, n) {
            var r,
              o,
              a = {},
              s = 0;
            if (y.isArray(i)) {
              for (o = Qe(e), r = i.length; r > s; s++)
                a[i[s]] = y.css(e, i[s], !1, o);
              return a;
            }
            return n !== t ? y.style(e, i, n) : y.css(e, i);
          },
          e,
          i,
          arguments.length > 1
        );
      },
      show: function () {
        return tt(this, !0);
      },
      hide: function () {
        return tt(this);
      },
      toggle: function (e) {
        var t = "boolean" == typeof e;
        return this.each(function () {
          (t ? e : et(this)) ? y(this).show() : y(this).hide();
        });
      },
    }),
      y.extend({
        cssHooks: {
          opacity: {
            get: function (e, t) {
              if (t) {
                var i = Fe(e, "opacity");
                return "" === i ? "1" : i;
              }
            },
          },
        },
        cssNumber: {
          columnCount: !0,
          fillOpacity: !0,
          fontWeight: !0,
          lineHeight: !0,
          opacity: !0,
          orphans: !0,
          widows: !0,
          zIndex: !0,
          zoom: !0,
        },
        cssProps: {
          float: y.support.cssFloat ? "cssFloat" : "styleFloat",
        },
        style: function (e, i, n, r) {
          if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
            var o,
              a,
              s,
              l = y.camelCase(i),
              c = e.style;
            if (
              ((i = y.cssProps[l] || (y.cssProps[l] = Ke(c, l))),
              (s = y.cssHooks[i] || y.cssHooks[l]),
              n === t)
            )
              return s && "get" in s && (o = s.get(e, !1, r)) !== t ? o : c[i];
            if (
              ("string" === (a = typeof n) &&
                (o = qe.exec(n)) &&
                ((n = (o[1] + 1) * o[2] + parseFloat(y.css(e, i))),
                (a = "number")),
              !(
                null == n ||
                ("number" === a && isNaN(n)) ||
                ("number" !== a || y.cssNumber[l] || (n += "px"),
                y.support.clearCloneStyle ||
                  "" !== n ||
                  0 !== i.indexOf("background") ||
                  (c[i] = "inherit"),
                s && "set" in s && (n = s.set(e, n, r)) === t)
              ))
            )
              try {
                c[i] = n;
              } catch (e) {}
          }
        },
        css: function (e, i, n, r) {
          var o,
            a,
            s,
            l = y.camelCase(i);
          return (
            (i = y.cssProps[l] || (y.cssProps[l] = Ke(e.style, l))),
            (s = y.cssHooks[i] || y.cssHooks[l]) &&
              "get" in s &&
              (a = s.get(e, !0, n)),
            a === t && (a = Fe(e, i, r)),
            "normal" === a && i in Xe && (a = Xe[i]),
            "" === n || n
              ? ((o = parseFloat(a)), !0 === n || y.isNumeric(o) ? o || 0 : a)
              : a
          );
        },
        swap: function (e, t, i, n) {
          var r,
            o,
            a = {};
          for (o in t) (a[o] = e.style[o]), (e.style[o] = t[o]);
          for (o in ((r = i.apply(e, n || [])), t)) e.style[o] = a[o];
          return r;
        },
      }),
      e.getComputedStyle
        ? ((Qe = function (t) {
            return e.getComputedStyle(t, null);
          }),
          (Fe = function (e, i, n) {
            var r,
              o,
              a,
              s = n || Qe(e),
              l = s ? s.getPropertyValue(i) || s[i] : t,
              c = e.style;
            return (
              s &&
                ("" !== l ||
                  y.contains(e.ownerDocument, e) ||
                  (l = y.style(e, i)),
                Be.test(l) &&
                  Ve.test(i) &&
                  ((r = c.width),
                  (o = c.minWidth),
                  (a = c.maxWidth),
                  (c.minWidth = c.maxWidth = c.width = l),
                  (l = s.width),
                  (c.width = r),
                  (c.minWidth = o),
                  (c.maxWidth = a))),
              l
            );
          }))
        : o.documentElement.currentStyle &&
          ((Qe = function (e) {
            return e.currentStyle;
          }),
          (Fe = function (e, i, n) {
            var r,
              o,
              a,
              s = n || Qe(e),
              l = s ? s[i] : t,
              c = e.style;
            return (
              null == l && c && c[i] && (l = c[i]),
              Be.test(l) &&
                !Le.test(i) &&
                ((r = c.left),
                (a = (o = e.runtimeStyle) && o.left) &&
                  (o.left = e.currentStyle.left),
                (c.left = "fontSize" === i ? "1em" : l),
                (l = c.pixelLeft + "px"),
                (c.left = r),
                a && (o.left = a)),
              "" === l ? "auto" : l
            );
          })),
      y.each(["height", "width"], function (e, i) {
        y.cssHooks[i] = {
          get: function (e, n, r) {
            return n
              ? 0 === e.offsetWidth && Re.test(y.css(e, "display"))
                ? y.swap(e, He, function () {
                    return rt(e, i, r);
                  })
                : rt(e, i, r)
              : t;
          },
          set: function (e, t, n) {
            var r = n && Qe(e);
            return it(
              0,
              t,
              n
                ? nt(
                    e,
                    i,
                    n,
                    y.support.boxSizing &&
                      "border-box" === y.css(e, "boxSizing", !1, r),
                    r
                  )
                : 0
            );
          },
        };
      }),
      y.support.opacity ||
        (y.cssHooks.opacity = {
          get: function (e, t) {
            return Se.test(
              (t && e.currentStyle ? e.currentStyle.filter : e.style.filter) ||
                ""
            )
              ? 0.01 * parseFloat(RegExp.$1) + ""
              : t
              ? "1"
              : "";
          },
          set: function (e, t) {
            var i = e.style,
              n = e.currentStyle,
              r = y.isNumeric(t) ? "alpha(opacity=" + 100 * t + ")" : "",
              o = (n && n.filter) || i.filter || "";
            (i.zoom = 1),
              ((t >= 1 || "" === t) &&
                "" === y.trim(o.replace(Ue, "")) &&
                i.removeAttribute &&
                (i.removeAttribute("filter"), "" === t || (n && !n.filter))) ||
                (i.filter = Ue.test(o) ? o.replace(Ue, r) : o + " " + r);
          },
        }),
      y(function () {
        y.support.reliableMarginRight ||
          (y.cssHooks.marginRight = {
            get: function (e, i) {
              return i
                ? y.swap(
                    e,
                    {
                      display: "inline-block",
                    },
                    Fe,
                    [e, "marginRight"]
                  )
                : t;
            },
          }),
          !y.support.pixelPosition &&
            y.fn.position &&
            y.each(["top", "left"], function (e, i) {
              y.cssHooks[i] = {
                get: function (e, n) {
                  return n
                    ? ((n = Fe(e, i)),
                      Be.test(n) ? y(e).position()[i] + "px" : n)
                    : t;
                },
              };
            });
      }),
      y.expr &&
        y.expr.filters &&
        ((y.expr.filters.hidden = function (e) {
          return (
            (0 >= e.offsetWidth && 0 >= e.offsetHeight) ||
            (!y.support.reliableHiddenOffsets &&
              "none" === ((e.style && e.style.display) || y.css(e, "display")))
          );
        }),
        (y.expr.filters.visible = function (e) {
          return !y.expr.filters.hidden(e);
        })),
      y.each(
        {
          margin: "",
          padding: "",
          border: "Width",
        },
        function (e, t) {
          (y.cssHooks[e + t] = {
            expand: function (i) {
              for (
                var n = 0,
                  r = {},
                  o = "string" == typeof i ? i.split(" ") : [i];
                4 > n;
                n++
              )
                r[e + Pe[n] + t] = o[n] || o[n - 2] || o[0];
              return r;
            },
          }),
            Ve.test(e) || (y.cssHooks[e + t].set = it);
        }
      );
    var st = /%20/g,
      lt = /\[\]$/,
      ct = /\r?\n/g,
      ut = /^(?:submit|button|image|reset|file)$/i,
      dt = /^(?:input|select|textarea|keygen)/i;

    function pt(e, t, i, n) {
      var r;
      if (y.isArray(t))
        y.each(t, function (t, r) {
          i || lt.test(e)
            ? n(e, r)
            : pt(e + "[" + ("object" == typeof r ? t : "") + "]", r, i, n);
        });
      else if (i || "object" !== y.type(t)) n(e, t);
      else for (r in t) pt(e + "[" + r + "]", t[r], i, n);
    }
    y.fn.extend({
      serialize: function () {
        return y.param(this.serializeArray());
      },
      serializeArray: function () {
        return this.map(function () {
          var e = y.prop(this, "elements");
          return e ? y.makeArray(e) : this;
        })
          .filter(function () {
            var e = this.type;
            return (
              this.name &&
              !y(this).is(":disabled") &&
              dt.test(this.nodeName) &&
              !ut.test(e) &&
              (this.checked || !Te.test(e))
            );
          })
          .map(function (e, t) {
            var i = y(this).val();
            return null == i
              ? null
              : y.isArray(i)
              ? y.map(i, function (e) {
                  return {
                    name: t.name,
                    value: e.replace(ct, "\r\n"),
                  };
                })
              : {
                  name: t.name,
                  value: i.replace(ct, "\r\n"),
                };
          })
          .get();
      },
    }),
      (y.param = function (e, i) {
        var n,
          r = [],
          o = function (e, t) {
            (t = y.isFunction(t) ? t() : null == t ? "" : t),
              (r[r.length] =
                encodeURIComponent(e) + "=" + encodeURIComponent(t));
          };
        if (
          (i === t && (i = y.ajaxSettings && y.ajaxSettings.traditional),
          y.isArray(e) || (e.jquery && !y.isPlainObject(e)))
        )
          y.each(e, function () {
            o(this.name, this.value);
          });
        else for (n in e) pt(n, e[n], i, o);
        return r.join("&").replace(st, "+");
      }),
      y.each(
        "blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(
          " "
        ),
        function (e, t) {
          y.fn[t] = function (e, i) {
            return arguments.length > 0
              ? this.on(t, null, e, i)
              : this.trigger(t);
          };
        }
      ),
      (y.fn.hover = function (e, t) {
        return this.mouseenter(e).mouseleave(t || e);
      });
    var ht,
      It,
      ft = y.now(),
      mt = /\?/,
      jt = /#.*$/,
      Mt = /([?&])_=[^&]*/,
      yt = /^(.*?):[ \t]*([^\r\n]*)\r?$/gm,
      Nt = /^(?:GET|HEAD)$/,
      Yt = /^\/\//,
      Tt = /^([\w.+-]+:)(?:\/\/([^\/?#:]*)(?::(\d+)|)|)/,
      Zt = y.fn.load,
      gt = {},
      Ot = {},
      zt = "*/".concat("*");
    try {
      It = a.href;
    } catch (e) {
      ((It = o.createElement("a")).href = ""), (It = It.href);
    }

    function Wt(e) {
      return function (t, i) {
        "string" != typeof t && ((i = t), (t = "*"));
        var n,
          r = 0,
          o = t.toLowerCase().match(Y) || [];
        if (y.isFunction(i))
          for (; (n = o[r++]); )
            "+" === n[0]
              ? ((n = n.slice(1) || "*"), (e[n] = e[n] || []).unshift(i))
              : (e[n] = e[n] || []).push(i);
      };
    }

    function Dt(e, i, n, r) {
      var o = {},
        a = e === Ot;

      function s(l) {
        var c;
        return (
          (o[l] = !0),
          y.each(e[l] || [], function (e, l) {
            var u = l(i, n, r);
            return "string" != typeof u || a || o[u]
              ? a
                ? !(c = u)
                : t
              : (i.dataTypes.unshift(u), s(u), !1);
          }),
          c
        );
      }
      return s(i.dataTypes[0]) || (!o["*"] && s("*"));
    }

    function kt(e, i) {
      var n,
        r,
        o = y.ajaxSettings.flatOptions || {};
      for (r in i) i[r] !== t && ((o[r] ? e : n || (n = {}))[r] = i[r]);
      return n && y.extend(!0, e, n), e;
    }
    (ht = Tt.exec(It.toLowerCase()) || []),
      (y.fn.load = function (e, i, n) {
        if ("string" != typeof e && Zt) return Zt.apply(this, arguments);
        var r,
          o,
          a,
          s = this,
          l = e.indexOf(" ");
        return (
          l >= 0 && ((r = e.slice(l, e.length)), (e = e.slice(0, l))),
          y.isFunction(i)
            ? ((n = i), (i = t))
            : i && "object" == typeof i && (a = "POST"),
          s.length > 0 &&
            y
              .ajax({
                url: e,
                type: a,
                dataType: "html",
                data: i,
              })
              .done(function (e) {
                (o = arguments),
                  s.html(r ? y("<div>").append(y.parseHTML(e)).find(r) : e);
              })
              .complete(
                n &&
                  function (e, t) {
                    s.each(n, o || [e.responseText, t, e]);
                  }
              ),
          this
        );
      }),
      y.each(
        [
          "ajaxStart",
          "ajaxStop",
          "ajaxComplete",
          "ajaxError",
          "ajaxSuccess",
          "ajaxSend",
        ],
        function (e, t) {
          y.fn[t] = function (e) {
            return this.on(t, e);
          };
        }
      ),
      y.each(["get", "post"], function (e, i) {
        y[i] = function (e, n, r, o) {
          return (
            y.isFunction(n) && ((o = o || r), (r = n), (n = t)),
            y.ajax({
              url: e,
              type: i,
              dataType: o,
              data: n,
              success: r,
            })
          );
        };
      }),
      y.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
          url: It,
          type: "GET",
          isLocal:
            /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(
              ht[1]
            ),
          global: !0,
          processData: !0,
          async: !0,
          contentType: "application/x-www-form-urlencoded; charset=UTF-8",
          accepts: {
            "*": zt,
            text: "text/plain",
            html: "text/html",
            xml: "application/xml, text/xml",
            json: "application/json, text/javascript",
          },
          contents: {
            xml: /xml/,
            html: /html/,
            json: /json/,
          },
          responseFields: {
            xml: "responseXML",
            text: "responseText",
          },
          converters: {
            "* text": e.String,
            "text html": !0,
            "text json": y.parseJSON,
            "text xml": y.parseXML,
          },
          flatOptions: {
            url: !0,
            context: !0,
          },
        },
        ajaxSetup: function (e, t) {
          return t ? kt(kt(e, y.ajaxSettings), t) : kt(y.ajaxSettings, e);
        },
        ajaxPrefilter: Wt(gt),
        ajaxTransport: Wt(Ot),
        ajax: function (e, i) {
          "object" == typeof e && ((i = e), (e = t)), (i = i || {});
          var n,
            r,
            o,
            a,
            s,
            l,
            c,
            u,
            d = y.ajaxSetup({}, i),
            p = d.context || d,
            h = d.context && (p.nodeType || p.jquery) ? y(p) : y.event,
            I = y.Deferred(),
            f = y.Callbacks("once memory"),
            m = d.statusCode || {},
            j = {},
            M = {},
            N = 0,
            T = "canceled",
            Z = {
              readyState: 0,
              getResponseHeader: function (e) {
                var t;
                if (2 === N) {
                  if (!u)
                    for (u = {}; (t = yt.exec(a)); )
                      u[t[1].toLowerCase()] = t[2];
                  t = u[e.toLowerCase()];
                }
                return null == t ? null : t;
              },
              getAllResponseHeaders: function () {
                return 2 === N ? a : null;
              },
              setRequestHeader: function (e, t) {
                var i = e.toLowerCase();
                return N || ((e = M[i] = M[i] || e), (j[e] = t)), this;
              },
              overrideMimeType: function (e) {
                return N || (d.mimeType = e), this;
              },
              statusCode: function (e) {
                var t;
                if (e)
                  if (2 > N) for (t in e) m[t] = [m[t], e[t]];
                  else Z.always(e[Z.status]);
                return this;
              },
              abort: function (e) {
                var t = e || T;
                return c && c.abort(t), g(0, t), this;
              },
            };
          if (
            ((I.promise(Z).complete = f.add),
            (Z.success = Z.done),
            (Z.error = Z.fail),
            (d.url = ((e || d.url || It) + "")
              .replace(jt, "")
              .replace(Yt, ht[1] + "//")),
            (d.type = i.method || i.type || d.method || d.type),
            (d.dataTypes = y
              .trim(d.dataType || "*")
              .toLowerCase()
              .match(Y) || [""]),
            null == d.crossDomain &&
              ((n = Tt.exec(d.url.toLowerCase())),
              (d.crossDomain = !(
                !n ||
                (n[1] === ht[1] &&
                  n[2] === ht[2] &&
                  (n[3] || ("http:" === n[1] ? 80 : 443)) ==
                    (ht[3] || ("http:" === ht[1] ? 80 : 443)))
              ))),
            d.data &&
              d.processData &&
              "string" != typeof d.data &&
              (d.data = y.param(d.data, d.traditional)),
            Dt(gt, d, i, Z),
            2 === N)
          )
            return Z;
          for (r in ((l = d.global) &&
            0 == y.active++ &&
            y.event.trigger("ajaxStart"),
          (d.type = d.type.toUpperCase()),
          (d.hasContent = !Nt.test(d.type)),
          (o = d.url),
          d.hasContent ||
            (d.data &&
              ((o = d.url += (mt.test(o) ? "&" : "?") + d.data), delete d.data),
            !1 === d.cache &&
              (d.url = Mt.test(o)
                ? o.replace(Mt, "$1_=" + ft++)
                : o + (mt.test(o) ? "&" : "?") + "_=" + ft++)),
          d.ifModified &&
            (y.lastModified[o] &&
              Z.setRequestHeader("If-Modified-Since", y.lastModified[o]),
            y.etag[o] && Z.setRequestHeader("If-None-Match", y.etag[o])),
          ((d.data && d.hasContent && !1 !== d.contentType) || i.contentType) &&
            Z.setRequestHeader("Content-Type", d.contentType),
          Z.setRequestHeader(
            "Accept",
            d.dataTypes[0] && d.accepts[d.dataTypes[0]]
              ? d.accepts[d.dataTypes[0]] +
                  ("*" !== d.dataTypes[0] ? ", " + zt + "; q=0.01" : "")
              : d.accepts["*"]
          ),
          d.headers))
            Z.setRequestHeader(r, d.headers[r]);
          if (d.beforeSend && (!1 === d.beforeSend.call(p, Z, d) || 2 === N))
            return Z.abort();
          for (r in ((T = "abort"),
          {
            success: 1,
            error: 1,
            complete: 1,
          }))
            Z[r](d[r]);
          if ((c = Dt(Ot, d, i, Z))) {
            (Z.readyState = 1),
              l && h.trigger("ajaxSend", [Z, d]),
              d.async &&
                d.timeout > 0 &&
                (s = setTimeout(function () {
                  Z.abort("timeout");
                }, d.timeout));
            try {
              (N = 1), c.send(j, g);
            } catch (e) {
              if (!(2 > N)) throw e;
              g(-1, e);
            }
          } else g(-1, "No Transport");

          function g(e, i, n, r) {
            var u,
              j,
              M,
              Y,
              T,
              g = i;
            2 !== N &&
              ((N = 2),
              s && clearTimeout(s),
              (c = t),
              (a = r || ""),
              (Z.readyState = e > 0 ? 4 : 0),
              n &&
                (Y = (function (e, i, n) {
                  var r,
                    o,
                    a,
                    s,
                    l = e.contents,
                    c = e.dataTypes,
                    u = e.responseFields;
                  for (s in u) s in n && (i[u[s]] = n[s]);
                  for (; "*" === c[0]; )
                    c.shift(),
                      o === t &&
                        (o = e.mimeType || i.getResponseHeader("Content-Type"));
                  if (o)
                    for (s in l)
                      if (l[s] && l[s].test(o)) {
                        c.unshift(s);
                        break;
                      }
                  if (c[0] in n) a = c[0];
                  else {
                    for (s in n) {
                      if (!c[0] || e.converters[s + " " + c[0]]) {
                        a = s;
                        break;
                      }
                      r || (r = s);
                    }
                    a = a || r;
                  }
                  return a ? (a !== c[0] && c.unshift(a), n[a]) : t;
                })(d, Z, n)),
              (e >= 200 && 300 > e) || 304 === e
                ? (d.ifModified &&
                    ((T = Z.getResponseHeader("Last-Modified")) &&
                      (y.lastModified[o] = T),
                    (T = Z.getResponseHeader("etag")) && (y.etag[o] = T)),
                  204 === e
                    ? ((u = !0), (g = "nocontent"))
                    : 304 === e
                    ? ((u = !0), (g = "notmodified"))
                    : ((g = (u = (function (e, t) {
                        var i,
                          n,
                          r,
                          o,
                          a = {},
                          s = 0,
                          l = e.dataTypes.slice(),
                          c = l[0];
                        if (
                          (e.dataFilter && (t = e.dataFilter(t, e.dataType)),
                          l[1])
                        )
                          for (r in e.converters)
                            a[r.toLowerCase()] = e.converters[r];
                        for (; (n = l[++s]); )
                          if ("*" !== n) {
                            if ("*" !== c && c !== n) {
                              if (!(r = a[c + " " + n] || a["* " + n]))
                                for (i in a)
                                  if (
                                    (o = i.split(" "))[1] === n &&
                                    (r = a[c + " " + o[0]] || a["* " + o[0]])
                                  ) {
                                    !0 === r
                                      ? (r = a[i])
                                      : !0 !== a[i] &&
                                        ((n = o[0]), l.splice(s--, 0, n));
                                    break;
                                  }
                              if (!0 !== r)
                                if (r && e.throws) t = r(t);
                                else
                                  try {
                                    t = r(t);
                                  } catch (e) {
                                    return {
                                      state: "parsererror",
                                      error: r
                                        ? e
                                        : "No conversion from " +
                                          c +
                                          " to " +
                                          n,
                                    };
                                  }
                            }
                            c = n;
                          }
                        return {
                          state: "success",
                          data: t,
                        };
                      })(d, Y)).state),
                      (j = u.data),
                      (u = !(M = u.error))))
                : ((M = g), (e || !g) && ((g = "error"), 0 > e && (e = 0))),
              (Z.status = e),
              (Z.statusText = (i || g) + ""),
              u ? I.resolveWith(p, [j, g, Z]) : I.rejectWith(p, [Z, g, M]),
              Z.statusCode(m),
              (m = t),
              l &&
                h.trigger(u ? "ajaxSuccess" : "ajaxError", [Z, d, u ? j : M]),
              f.fireWith(p, [Z, g]),
              l &&
                (h.trigger("ajaxComplete", [Z, d]),
                --y.active || y.event.trigger("ajaxStop")));
          }
          return Z;
        },
        getScript: function (e, i) {
          return y.get(e, t, i, "script");
        },
        getJSON: function (e, t, i) {
          return y.get(e, t, i, "json");
        },
      }),
      y.ajaxSetup({
        accepts: {
          script:
            "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript",
        },
        contents: {
          script: /(?:java|ecma)script/,
        },
        converters: {
          "text script": function (e) {
            return y.globalEval(e), e;
          },
        },
      }),
      y.ajaxPrefilter("script", function (e) {
        e.cache === t && (e.cache = !1),
          e.crossDomain && ((e.type = "GET"), (e.global = !1));
      }),
      y.ajaxTransport("script", function (e) {
        if (e.crossDomain) {
          var i,
            n = o.head || y("head")[0] || o.documentElement;
          return {
            send: function (t, r) {
              ((i = o.createElement("script")).async = !0),
                e.scriptCharset && (i.charset = e.scriptCharset),
                (i.src = e.url),
                (i.onload = i.onreadystatechange =
                  function (e, t) {
                    (t ||
                      !i.readyState ||
                      /loaded|complete/.test(i.readyState)) &&
                      ((i.onload = i.onreadystatechange = null),
                      i.parentNode && i.parentNode.removeChild(i),
                      (i = null),
                      t || r(200, "success"));
                  }),
                n.insertBefore(i, n.firstChild);
            },
            abort: function () {
              i && i.onload(t, !0);
            },
          };
        }
      });
    var xt = [],
      vt = /(=)\?(?=&|$)|\?\?/;
    y.ajaxSetup({
      jsonp: "callback",
      jsonpCallback: function () {
        var e = xt.pop() || y.expando + "_" + ft++;
        return (this[e] = !0), e;
      },
    }),
      y.ajaxPrefilter("json jsonp", function (i, n, r) {
        var o,
          a,
          s,
          l =
            !1 !== i.jsonp &&
            (vt.test(i.url)
              ? "url"
              : "string" == typeof i.data &&
                !(i.contentType || "").indexOf(
                  "application/x-www-form-urlencoded"
                ) &&
                vt.test(i.data) &&
                "data");
        return l || "jsonp" === i.dataTypes[0]
          ? ((o = i.jsonpCallback =
              y.isFunction(i.jsonpCallback)
                ? i.jsonpCallback()
                : i.jsonpCallback),
            l
              ? (i[l] = i[l].replace(vt, "$1" + o))
              : !1 !== i.jsonp &&
                (i.url += (mt.test(i.url) ? "&" : "?") + i.jsonp + "=" + o),
            (i.converters["script json"] = function () {
              return s || y.error(o + " was not called"), s[0];
            }),
            (i.dataTypes[0] = "json"),
            (a = e[o]),
            (e[o] = function () {
              s = arguments;
            }),
            r.always(function () {
              (e[o] = a),
                i[o] && ((i.jsonpCallback = n.jsonpCallback), xt.push(o)),
                s && y.isFunction(a) && a(s[0]),
                (s = a = t);
            }),
            "script")
          : t;
      });
    var wt,
      Jt,
      Ct = 0,
      bt =
        e.ActiveXObject &&
        function () {
          var e;
          for (e in wt) wt[e](t, !0);
        };

    function Et() {
      try {
        return new e.XMLHttpRequest();
      } catch (e) {}
    }
    (y.ajaxSettings.xhr = e.ActiveXObject
      ? function () {
          return (
            (!this.isLocal && Et()) ||
            (function () {
              try {
                return new e.ActiveXObject("Microsoft.XMLHTTP");
              } catch (e) {}
            })()
          );
        }
      : Et),
      (Jt = y.ajaxSettings.xhr()),
      (y.support.cors = !!Jt && "withCredentials" in Jt),
      (Jt = y.support.ajax = !!Jt) &&
        y.ajaxTransport(function (i) {
          var n;
          if (!i.crossDomain || y.support.cors)
            return {
              send: function (r, o) {
                var a,
                  s,
                  l = i.xhr();
                if (
                  (i.username
                    ? l.open(i.type, i.url, i.async, i.username, i.password)
                    : l.open(i.type, i.url, i.async),
                  i.xhrFields)
                )
                  for (s in i.xhrFields) l[s] = i.xhrFields[s];
                i.mimeType &&
                  l.overrideMimeType &&
                  l.overrideMimeType(i.mimeType),
                  i.crossDomain ||
                    r["X-Requested-With"] ||
                    (r["X-Requested-With"] = "XMLHttpRequest");
                try {
                  for (s in r) l.setRequestHeader(s, r[s]);
                } catch (e) {}
                l.send((i.hasContent && i.data) || null),
                  (n = function (e, r) {
                    var s, c, u, d;
                    try {
                      if (n && (r || 4 === l.readyState))
                        if (
                          ((n = t),
                          a &&
                            ((l.onreadystatechange = y.noop),
                            bt && delete wt[a]),
                          r)
                        )
                          4 !== l.readyState && l.abort();
                        else {
                          (d = {}),
                            (s = l.status),
                            (c = l.getAllResponseHeaders()),
                            "string" == typeof l.responseText &&
                              (d.text = l.responseText);
                          try {
                            u = l.statusText;
                          } catch (e) {
                            u = "";
                          }
                          s || !i.isLocal || i.crossDomain
                            ? 1223 === s && (s = 204)
                            : (s = d.text ? 200 : 404);
                        }
                    } catch (e) {
                      r || o(-1, e);
                    }
                    d && o(s, u, d, c);
                  }),
                  i.async
                    ? 4 === l.readyState
                      ? setTimeout(n)
                      : ((a = ++Ct),
                        bt && (wt || ((wt = {}), y(e).unload(bt)), (wt[a] = n)),
                        (l.onreadystatechange = n))
                    : n();
              },
              abort: function () {
                n && n(t, !0);
              },
            };
        });
    var Gt,
      Qt,
      Ft = /^(?:toggle|show|hide)$/,
      Ut = RegExp("^(?:([+-])=|)(" + N + ")([a-z%]*)$", "i"),
      St = /queueHooks$/,
      Lt = [
        function (e, t, i) {
          var n,
            r,
            o,
            a,
            s,
            l,
            c,
            u,
            d,
            p = this,
            h = e.style,
            I = {},
            f = [],
            m = e.nodeType && et(e);
          for (r in (i.queue ||
            (null == (u = y._queueHooks(e, "fx")).unqueued &&
              ((u.unqueued = 0),
              (d = u.empty.fire),
              (u.empty.fire = function () {
                u.unqueued || d();
              })),
            u.unqueued++,
            p.always(function () {
              p.always(function () {
                u.unqueued--, y.queue(e, "fx").length || u.empty.fire();
              });
            })),
          1 === e.nodeType &&
            ("height" in t || "width" in t) &&
            ((i.overflow = [h.overflow, h.overflowX, h.overflowY]),
            "inline" === y.css(e, "display") &&
              "none" === y.css(e, "float") &&
              (y.support.inlineBlockNeedsLayout && "inline" !== ot(e.nodeName)
                ? (h.zoom = 1)
                : (h.display = "inline-block"))),
          i.overflow &&
            ((h.overflow = "hidden"),
            y.support.shrinkWrapBlocks ||
              p.always(function () {
                (h.overflow = i.overflow[0]),
                  (h.overflowX = i.overflow[1]),
                  (h.overflowY = i.overflow[2]);
              })),
          t))
            if (((a = t[r]), Ft.exec(a))) {
              if (
                (delete t[r],
                (l = l || "toggle" === a),
                a === (m ? "hide" : "show"))
              )
                continue;
              f.push(r);
            }
          if ((o = f.length)) {
            "hidden" in
              (s = y._data(e, "fxshow") || y._data(e, "fxshow", {})) &&
              (m = s.hidden),
              l && (s.hidden = !m),
              m
                ? y(e).show()
                : p.done(function () {
                    y(e).hide();
                  }),
              p.done(function () {
                var t;
                for (t in (y._removeData(e, "fxshow"), I)) y.style(e, t, I[t]);
              });
            for (r = 0; o > r; r++)
              (n = f[r]),
                (c = p.createTween(n, m ? s[n] : 0)),
                (I[n] = s[n] || y.style(e, n)),
                n in s ||
                  ((s[n] = c.start),
                  m &&
                    ((c.end = c.start),
                    (c.start = "width" === n || "height" === n ? 1 : 0)));
          }
        },
      ],
      Rt = {
        "*": [
          function (e, t) {
            var i,
              n,
              r = this.createTween(e, t),
              o = Ut.exec(t),
              a = r.cur(),
              s = +a || 0,
              l = 1,
              c = 20;
            if (o) {
              if (
                ((i = +o[2]),
                "px" !== (n = o[3] || (y.cssNumber[e] ? "" : "px")) && s)
              ) {
                s = y.css(r.elem, e, !0) || i || 1;
                do {
                  (s /= l = l || ".5"), y.style(r.elem, e, s + n);
                } while (l !== (l = r.cur() / a) && 1 !== l && --c);
              }
              (r.unit = n),
                (r.start = s),
                (r.end = o[1] ? s + (o[1] + 1) * i : i);
            }
            return r;
          },
        ],
      };

    function Vt() {
      return (
        setTimeout(function () {
          Gt = t;
        }),
        (Gt = y.now())
      );
    }

    function At(e, t, i) {
      var n,
        r,
        o = 0,
        a = Lt.length,
        s = y.Deferred().always(function () {
          delete l.elem;
        }),
        l = function () {
          if (r) return !1;
          for (
            var t = Gt || Vt(),
              i = Math.max(0, c.startTime + c.duration - t),
              n = 1 - (i / c.duration || 0),
              o = 0,
              a = c.tweens.length;
            a > o;
            o++
          )
            c.tweens[o].run(n);
          return (
            s.notifyWith(e, [c, n, i]),
            1 > n && a ? i : (s.resolveWith(e, [c]), !1)
          );
        },
        c = s.promise({
          elem: e,
          props: y.extend({}, t),
          opts: y.extend(
            !0,
            {
              specialEasing: {},
            },
            i
          ),
          originalProperties: t,
          originalOptions: i,
          startTime: Gt || Vt(),
          duration: i.duration,
          tweens: [],
          createTween: function (t, i) {
            var n = y.Tween(
              e,
              c.opts,
              t,
              i,
              c.opts.specialEasing[t] || c.opts.easing
            );
            return c.tweens.push(n), n;
          },
          stop: function (t) {
            var i = 0,
              n = t ? c.tweens.length : 0;
            if (r) return this;
            for (r = !0; n > i; i++) c.tweens[i].run(1);
            return t ? s.resolveWith(e, [c, t]) : s.rejectWith(e, [c, t]), this;
          },
        }),
        u = c.props;
      for (
        (function (e, t) {
          var i, n, r, o, a;
          for (r in e)
            if (
              ((n = y.camelCase(r)),
              (o = t[n]),
              (i = e[r]),
              y.isArray(i) && ((o = i[1]), (i = e[r] = i[0])),
              r !== n && ((e[n] = i), delete e[r]),
              (a = y.cssHooks[n]) && ("expand" in a))
            )
              for (r in ((i = a.expand(i)), delete e[n], i))
                (r in e) || ((e[r] = i[r]), (t[r] = o));
            else t[n] = o;
        })(u, c.opts.specialEasing);
        a > o;
        o++
      )
        if ((n = Lt[o].call(c, e, u, c.opts))) return n;
      return (
        (function (e, t) {
          y.each(t, function (t, i) {
            for (
              var n = (Rt[t] || []).concat(Rt["*"]), r = 0, o = n.length;
              o > r;
              r++
            )
              if (n[r].call(e, t, i)) return;
          });
        })(c, u),
        y.isFunction(c.opts.start) && c.opts.start.call(e, c),
        y.fx.timer(
          y.extend(l, {
            elem: e,
            anim: c,
            queue: c.opts.queue,
          })
        ),
        c
          .progress(c.opts.progress)
          .done(c.opts.done, c.opts.complete)
          .fail(c.opts.fail)
          .always(c.opts.always)
      );
    }

    function Bt(e, t, i, n, r) {
      return new Bt.prototype.init(e, t, i, n, r);
    }

    function qt(e, t) {
      var i,
        n = {
          height: e,
        },
        r = 0;
      for (t = t ? 1 : 0; 4 > r; r += 2 - t)
        n["margin" + (i = Pe[r])] = n["padding" + i] = e;
      return t && (n.opacity = n.width = e), n;
    }

    function _t(e) {
      return y.isWindow(e)
        ? e
        : 9 === e.nodeType && (e.defaultView || e.parentWindow);
    }
    (y.Animation = y.extend(At, {
      tweener: function (e, t) {
        y.isFunction(e) ? ((t = e), (e = ["*"])) : (e = e.split(" "));
        for (var i, n = 0, r = e.length; r > n; n++)
          (i = e[n]), (Rt[i] = Rt[i] || []), Rt[i].unshift(t);
      },
      prefilter: function (e, t) {
        t ? Lt.unshift(e) : Lt.push(e);
      },
    })),
      (y.Tween = Bt),
      (Bt.prototype = {
        constructor: Bt,
        init: function (e, t, i, n, r, o) {
          (this.elem = e),
            (this.prop = i),
            (this.easing = r || "swing"),
            (this.options = t),
            (this.start = this.now = this.cur()),
            (this.end = n),
            (this.unit = o || (y.cssNumber[i] ? "" : "px"));
        },
        cur: function () {
          var e = Bt.propHooks[this.prop];
          return e && e.get ? e.get(this) : Bt.propHooks._default.get(this);
        },
        run: function (e) {
          var t,
            i = Bt.propHooks[this.prop];
          return (
            (this.pos = t =
              this.options.duration
                ? y.easing[this.easing](
                    e,
                    this.options.duration * e,
                    0,
                    1,
                    this.options.duration
                  )
                : e),
            (this.now = (this.end - this.start) * t + this.start),
            this.options.step &&
              this.options.step.call(this.elem, this.now, this),
            i && i.set ? i.set(this) : Bt.propHooks._default.set(this),
            this
          );
        },
      }),
      (Bt.prototype.init.prototype = Bt.prototype),
      (Bt.propHooks = {
        _default: {
          get: function (e) {
            var t;
            return null == e.elem[e.prop] ||
              (e.elem.style && null != e.elem.style[e.prop])
              ? (t = y.css(e.elem, e.prop, "")) && "auto" !== t
                ? t
                : 0
              : e.elem[e.prop];
          },
          set: function (e) {
            y.fx.step[e.prop]
              ? y.fx.step[e.prop](e)
              : e.elem.style &&
                (null != e.elem.style[y.cssProps[e.prop]] || y.cssHooks[e.prop])
              ? y.style(e.elem, e.prop, e.now + e.unit)
              : (e.elem[e.prop] = e.now);
          },
        },
      }),
      (Bt.propHooks.scrollTop = Bt.propHooks.scrollLeft =
        {
          set: function (e) {
            e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
          },
        }),
      y.each(["toggle", "show", "hide"], function (e, t) {
        var i = y.fn[t];
        y.fn[t] = function (e, n, r) {
          return null == e || "boolean" == typeof e
            ? i.apply(this, arguments)
            : this.animate(qt(t, !0), e, n, r);
        };
      }),
      y.fn.extend({
        fadeTo: function (e, t, i, n) {
          return this.filter(et).css("opacity", 0).show().end().animate(
            {
              opacity: t,
            },
            e,
            i,
            n
          );
        },
        animate: function (e, t, i, n) {
          var r = y.isEmptyObject(e),
            o = y.speed(t, i, n),
            a = function () {
              var t = At(this, y.extend({}, e), o);
              (a.finish = function () {
                t.stop(!0);
              }),
                (r || y._data(this, "finish")) && t.stop(!0);
            };
          return (
            (a.finish = a),
            r || !1 === o.queue ? this.each(a) : this.queue(o.queue, a)
          );
        },
        stop: function (e, i, n) {
          var r = function (e) {
            var t = e.stop;
            delete e.stop, t(n);
          };
          return (
            "string" != typeof e && ((n = i), (i = e), (e = t)),
            i && !1 !== e && this.queue(e || "fx", []),
            this.each(function () {
              var t = !0,
                i = null != e && e + "queueHooks",
                o = y.timers,
                a = y._data(this);
              if (i) a[i] && a[i].stop && r(a[i]);
              else for (i in a) a[i] && a[i].stop && St.test(i) && r(a[i]);
              for (i = o.length; i--; )
                o[i].elem !== this ||
                  (null != e && o[i].queue !== e) ||
                  (o[i].anim.stop(n), (t = !1), o.splice(i, 1));
              (t || !n) && y.dequeue(this, e);
            })
          );
        },
        finish: function (e) {
          return (
            !1 !== e && (e = e || "fx"),
            this.each(function () {
              var t,
                i = y._data(this),
                n = i[e + "queue"],
                r = i[e + "queueHooks"],
                o = y.timers,
                a = n ? n.length : 0;
              for (
                i.finish = !0,
                  y.queue(this, e, []),
                  r && r.cur && r.cur.finish && r.cur.finish.call(this),
                  t = o.length;
                t--;

              )
                o[t].elem === this &&
                  o[t].queue === e &&
                  (o[t].anim.stop(!0), o.splice(t, 1));
              for (t = 0; a > t; t++)
                n[t] && n[t].finish && n[t].finish.call(this);
              delete i.finish;
            })
          );
        },
      }),
      y.each(
        {
          slideDown: qt("show"),
          slideUp: qt("hide"),
          slideToggle: qt("toggle"),
          fadeIn: {
            opacity: "show",
          },
          fadeOut: {
            opacity: "hide",
          },
          fadeToggle: {
            opacity: "toggle",
          },
        },
        function (e, t) {
          y.fn[e] = function (e, i, n) {
            return this.animate(t, e, i, n);
          };
        }
      ),
      (y.speed = function (e, t, i) {
        var n =
          e && "object" == typeof e
            ? y.extend({}, e)
            : {
                complete: i || (!i && t) || (y.isFunction(e) && e),
                duration: e,
                easing: (i && t) || (t && !y.isFunction(t) && t),
              };
        return (
          (n.duration = y.fx.off
            ? 0
            : "number" == typeof n.duration
            ? n.duration
            : n.duration in y.fx.speeds
            ? y.fx.speeds[n.duration]
            : y.fx.speeds._default),
          (null == n.queue || !0 === n.queue) && (n.queue = "fx"),
          (n.old = n.complete),
          (n.complete = function () {
            y.isFunction(n.old) && n.old.call(this),
              n.queue && y.dequeue(this, n.queue);
          }),
          n
        );
      }),
      (y.easing = {
        linear: function (e) {
          return e;
        },
        swing: function (e) {
          return 0.5 - Math.cos(e * Math.PI) / 2;
        },
      }),
      (y.timers = []),
      (y.fx = Bt.prototype.init),
      (y.fx.tick = function () {
        var e,
          i = y.timers,
          n = 0;
        for (Gt = y.now(); i.length > n; n++)
          (e = i[n])() || i[n] !== e || i.splice(n--, 1);
        i.length || y.fx.stop(), (Gt = t);
      }),
      (y.fx.timer = function (e) {
        e() && y.timers.push(e) && y.fx.start();
      }),
      (y.fx.interval = 13),
      (y.fx.start = function () {
        Qt || (Qt = setInterval(y.fx.tick, y.fx.interval));
      }),
      (y.fx.stop = function () {
        clearInterval(Qt), (Qt = null);
      }),
      (y.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400,
      }),
      (y.fx.step = {}),
      y.expr &&
        y.expr.filters &&
        (y.expr.filters.animated = function (e) {
          return y.grep(y.timers, function (t) {
            return e === t.elem;
          }).length;
        }),
      (y.fn.offset = function (e) {
        if (arguments.length)
          return e === t
            ? this
            : this.each(function (t) {
                y.offset.setOffset(this, e, t);
              });
        var i,
          n,
          o = {
            top: 0,
            left: 0,
          },
          a = this[0],
          s = a && a.ownerDocument;
        return s
          ? ((i = s.documentElement),
            y.contains(i, a)
              ? (typeof a.getBoundingClientRect !== r &&
                  (o = a.getBoundingClientRect()),
                (n = _t(s)),
                {
                  top:
                    o.top + (n.pageYOffset || i.scrollTop) - (i.clientTop || 0),
                  left:
                    o.left +
                    (n.pageXOffset || i.scrollLeft) -
                    (i.clientLeft || 0),
                })
              : o)
          : void 0;
      }),
      (y.offset = {
        setOffset: function (e, t, i) {
          var n = y.css(e, "position");
          "static" === n && (e.style.position = "relative");
          var r,
            o,
            a = y(e),
            s = a.offset(),
            l = y.css(e, "top"),
            c = y.css(e, "left"),
            u = {},
            d = {};
          ("absolute" === n || "fixed" === n) && y.inArray("auto", [l, c]) > -1
            ? ((r = (d = a.position()).top), (o = d.left))
            : ((r = parseFloat(l) || 0), (o = parseFloat(c) || 0)),
            y.isFunction(t) && (t = t.call(e, i, s)),
            null != t.top && (u.top = t.top - s.top + r),
            null != t.left && (u.left = t.left - s.left + o),
            "using" in t ? t.using.call(e, u) : a.css(u);
        },
      }),
      y.fn.extend({
        position: function () {
          if (this[0]) {
            var e,
              t,
              i = {
                top: 0,
                left: 0,
              },
              n = this[0];
            return (
              "fixed" === y.css(n, "position")
                ? (t = n.getBoundingClientRect())
                : ((e = this.offsetParent()),
                  (t = this.offset()),
                  y.nodeName(e[0], "html") || (i = e.offset()),
                  (i.top += y.css(e[0], "borderTopWidth", !0)),
                  (i.left += y.css(e[0], "borderLeftWidth", !0))),
              {
                top: t.top - i.top - y.css(n, "marginTop", !0),
                left: t.left - i.left - y.css(n, "marginLeft", !0),
              }
            );
          }
        },
        offsetParent: function () {
          return this.map(function () {
            for (
              var e = this.offsetParent || o.documentElement;
              e && !y.nodeName(e, "html") && "static" === y.css(e, "position");

            )
              e = e.offsetParent;
            return e || o.documentElement;
          });
        },
      }),
      y.each(
        {
          scrollLeft: "pageXOffset",
          scrollTop: "pageYOffset",
        },
        function (e, i) {
          var n = /Y/.test(i);
          y.fn[e] = function (r) {
            return y.access(
              this,
              function (e, r, o) {
                var a = _t(e);
                return o === t
                  ? a
                    ? i in a
                      ? a[i]
                      : a.document.documentElement[r]
                    : e[r]
                  : (a
                      ? a.scrollTo(
                          n ? y(a).scrollLeft() : o,
                          n ? o : y(a).scrollTop()
                        )
                      : (e[r] = o),
                    t);
              },
              e,
              r,
              arguments.length,
              null
            );
          };
        }
      ),
      y.each(
        {
          Height: "height",
          Width: "width",
        },
        function (e, i) {
          y.each(
            {
              padding: "inner" + e,
              content: i,
              "": "outer" + e,
            },
            function (n, r) {
              y.fn[r] = function (r, o) {
                var a = arguments.length && (n || "boolean" != typeof r),
                  s = n || (!0 === r || !0 === o ? "margin" : "border");
                return y.access(
                  this,
                  function (i, n, r) {
                    var o;
                    return y.isWindow(i)
                      ? i.document.documentElement["client" + e]
                      : 9 === i.nodeType
                      ? ((o = i.documentElement),
                        Math.max(
                          i.body["scroll" + e],
                          o["scroll" + e],
                          i.body["offset" + e],
                          o["offset" + e],
                          o["client" + e]
                        ))
                      : r === t
                      ? y.css(i, n, s)
                      : y.style(i, n, r, s);
                  },
                  i,
                  a ? r : t,
                  a,
                  null
                );
              };
            }
          );
        }
      ),
      (e.jQuery = e.$ = y),
      "function" == typeof define &&
        define.amd &&
        define.amd.jQuery &&
        define("jquery", [], function () {
          return y;
        });
  })(window),
    (document.addEventListener =
      document.addEventListener ||
      function (e, t) {
        document.attachEvent("on" + e, t);
      });
  var easyorder = {
    jq: jQuery.noConflict(!0),
    popupSelector: ".eorder_featherlight",
    urls: {
      order: "https://perfumery-w1z8.onrender.com/api/createOrder",
      //order: "https://ec2.perfumery.ma:8443/api/createOrder",
      // order: "https://perfumerymabckp.herokuapp.com/api/createOrder",
      geosrc: "//apps.nexusmedia-ua.com/geoip/",
      css: "//static.nexusmedia-ua.com/easyorder/externals/frontend/plugin.min.css",
    },
    countriesData:
      "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",
    shop: "",
    currency: "",
    priceFormatMarker: "eopmarker",
    showProducts: !1,
    showVendor: !1,
    singlePurchase: !1,
    reload: !1,
    reloadAfterClose: !1,
    fbPixel: null,
    initialCountryCode: "",
    shopCountryCode: "",
    isRtl: !1,
    resetButtons: {
      update: !0,
      native: !0,
    },
    unbinding: {
      buttons: !0,
      forms: !0,
    },
    phoneRegExp: new RegExp(/^[+]?[0-9\s-\.]+$/),
    orderSuccessCustomCode: null,
    roundPriceTo: 2,
    loadLink: function (e) {
      var t = document.createElement("link");
      (t.type = "text/css"),
        (t.rel = "stylesheet"),
        (t.href = e),
        document.getElementsByTagName("head")[0].appendChild(t);
    },
    getCookie: function (e) {
      if (easyorder.supportsLocalStorage() && null != localStorage[e]) {
        var t = JSON.parse(localStorage[e]);
        return t.expires && new Date().getTime().toString() - t.expires > 0
          ? void localStorage.removeItem(e)
          : t.value;
      }
      var i = document.cookie.match(
        new RegExp(
          "(?:^|; )" +
            e.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
            "=([^;]*)"
        )
      );
      return i ? decodeURIComponent(i[1]) : void 0;
    },
    setCookie: function (e, t, i) {
      var n = {
          value: t,
          expires: null,
        },
        r = (i = i || {}).expires;
      if (r) {
        r = parseInt(r);
        var o = new Date();
        o.setTime(o.getTime() + 1e3 * r),
          (r = i.expires = o).toUTCString && (i.expires = r.toUTCString()),
          (n.expires = r.getTime().toString());
      }
      if (easyorder.supportsLocalStorage()) localStorage[e] = JSON.stringify(n);
      else {
        var a = e + "=" + encodeURIComponent(t);
        for (var s in i) {
          a += ";" + s;
          var l = i[s];
          !0 !== l && (a += "=" + l);
        }
        (a += ";path=/"), (document.cookie = a);
      }
    },
    supportsLocalStorage: function () {
      try {
        return "localStorage" in window && null !== window.localStorage;
      } catch (e) {
        return !1;
      }
    },
    base64: {
      _keyStr:
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
      encode: function (e) {
        var t,
          i,
          n,
          r,
          o,
          a,
          s,
          l = "",
          c = 0;
        for (e = easyorder.base64._utf8_encode(e); c < e.length; )
          (r = (t = e.charCodeAt(c++)) >> 2),
            (o = ((3 & t) << 4) | ((i = e.charCodeAt(c++)) >> 4)),
            (a = ((15 & i) << 2) | ((n = e.charCodeAt(c++)) >> 6)),
            (s = 63 & n),
            isNaN(i) ? (a = s = 64) : isNaN(n) && (s = 64),
            (l =
              l +
              this._keyStr.charAt(r) +
              this._keyStr.charAt(o) +
              this._keyStr.charAt(a) +
              this._keyStr.charAt(s));
        return l;
      },
      decode: function (e) {
        var t,
          i,
          n,
          r,
          o,
          a,
          s = "",
          l = 0;
        for (e = e.replace(/[^A-Za-z0-9\+\/\=]/g, ""); l < e.length; )
          (t =
            (this._keyStr.indexOf(e.charAt(l++)) << 2) |
            ((r = this._keyStr.indexOf(e.charAt(l++))) >> 4)),
            (i =
              ((15 & r) << 4) |
              ((o = this._keyStr.indexOf(e.charAt(l++))) >> 2)),
            (n = ((3 & o) << 6) | (a = this._keyStr.indexOf(e.charAt(l++)))),
            (s += String.fromCharCode(t)),
            64 != o && (s += String.fromCharCode(i)),
            64 != a && (s += String.fromCharCode(n));
        return (s = easyorder.base64._utf8_decode(s));
      },
      _utf8_encode: function (e) {
        e = e.replace(/\r\n/g, "\n");
        for (var t = "", i = 0; i < e.length; i++) {
          var n = e.charCodeAt(i);
          n < 128
            ? (t += String.fromCharCode(n))
            : n > 127 && n < 2048
            ? ((t += String.fromCharCode((n >> 6) | 192)),
              (t += String.fromCharCode((63 & n) | 128)))
            : ((t += String.fromCharCode((n >> 12) | 224)),
              (t += String.fromCharCode(((n >> 6) & 63) | 128)),
              (t += String.fromCharCode((63 & n) | 128)));
        }
        return t;
      },
      _utf8_decode: function (e) {
        for (var t = "", i = 0, n = 0, r = 0; i < e.length; )
          if ((n = e.charCodeAt(i)) < 128) (t += String.fromCharCode(n)), i++;
          else if (n > 191 && n < 224)
            (r = e.charCodeAt(i + 1)),
              (t += String.fromCharCode(((31 & n) << 6) | (63 & r))),
              (i += 2);
          else {
            r = e.charCodeAt(i + 1);
            var o = e.charCodeAt(i + 2);
            (t += String.fromCharCode(
              ((15 & n) << 12) | ((63 & r) << 6) | (63 & o)
            )),
              (i += 3);
          }
        return t;
      },
    },
    base64Decode: function (e) {
      return easyorder.base64.decode(e);
    },
    popupOpen: function (e, t, i, n) {
      var r = document.createEvent("Event");
      r.initEvent("easyorder_popup_open", !0, !0), document.dispatchEvent(r);
      var o = e.attr("action");
      if (
        (void 0 !== t && (easyorder.showProducts = !!t),
        void 0 !== i && (easyorder.showVendor = !!i),
        void 0 !== n && (easyorder.singlePurchase = !!n),
        (easyorder.reloadAfterClose = !1),
        -1 === o.indexOf("/cart/add"))
      )
        easyorder.initOrderPopup(o), easyorder.popupUpdate();
      else {
        var a = {
          type: "POST",
          url: "/cart/add.js",
          data: e.serialize(),
          dataType: "json",
          success: function (e, t) {
            easyorder.initOrderPopup(o), easyorder.popupUpdate();
            var i = document.createEvent("Event");
            i.initEvent("easyorder_item_added", !0, !0),
              document.dispatchEvent(i);
          },
          error: function (e, t) {
            var i = JSON.parse(e.responseText);
            easyorder.initOrderPopup(o), easyorder.popupUpdate(i.description);
          },
        };
        easyorder.singlePurchase
          ? easyorder.jq.post("/cart/clear.js").always(function () {
              easyorder.jq.ajax(a);
            })
          : easyorder.jq.ajax(a);
      }
    },
    initOrderPopup: function (e) {
      easyorder.jq.featherlight("#easyorder-popup", {}),
        easyorder.popupSwitchContent("content");
      var t = easyorder.jq(easyorder.popupSelector).find("#easyorder-popup");
      t.find(".easyorder-popup-submit").attr("data-url", e),
        easyorder.pastePreselect(),
        t.find("input[type=checkbox]").change(function () {
          var e = parseInt(this.getAttribute("data-option-id"));
          e &&
            (($field = t.find("div[data-related-to=" + e + "]")),
            easyorder.updateFieldsTree($field, this.checked));
        }),
        t.find("input[type=radio]").change(function () {
          ($field = easyorder.jq(this).parent().closest(".radio-holder")),
            easyorder.updateFieldsTree($field, !0);
        }),
        t.find("select").change(function () {
          var e = easyorder.jq(this);
          e.children("option:selected").length &&
            (($field = e.parent()), easyorder.updateFieldsTree($field, !0));
        }),
        t
          .find(".easyorder-field-holder[data-related-to=0]")
          .find("input[type=checkbox], input[type=radio], select")
          .trigger("change"),
        easyorder.jq(easyorder.popupSelector).find("input[type=tel]").length &&
          easyorder.initLocation(easyorder.createCountriesSelector);
      var i = document.createEvent("Event");
      i.initEvent("easyorder_popup_after_open", !0, !0),
        document.dispatchEvent(i);
    },
    popupUpdate: function (e) {
      (e = e || ""),
        easyorder.jq.ajax({
          type: "GET",
          url: "/cart.js",
          dataType: "json",
          success: function (t) {
            easyorder.isRtl &&
              easyorder
                .jq(easyorder.popupSelector)
                .children()
                .addClass("easyorder-rtl-content");
            var i = easyorder
                .jq(easyorder.popupSelector)
                .find("#easyorder-popup"),
              n = i.find(".easyorder-popup-products").empty().show();
            if (
              (e &&
                n.append('<div class="easyorder-add-error">' + e + "</div>"),
              t.items.length > 0)
            ) {
              commandDetails = [];
              var r,
                o,
                a,
                s = i.find(".easyorder-popup-currency:first"),
                l = s.length ? s.text() : "",
                c = l.indexOf(easyorder.priceFormatMarker) >= 0,
                u = parseFloat(t.total_price / 100).toFixed(
                  easyorder.roundPriceTo
                );
              c
                ? ((a =
                    '<span class="easyorder-total-price" data-eo-native-total-price="' +
                    t.total_price +
                    '">'),
                  (a += l.replace(easyorder.priceFormatMarker, u)),
                  (a += "</span>"))
                : ((a =
                    '<span class="easyorder-total-currency">' + l + "</span>"),
                  (a +=
                    '<span class="easyorder-total-price" data-eo-native-total-price="' +
                    t.total_price +
                    '">' +
                    u +
                    "</span>")),
                easyorder.showProducts
                  ? (easyorder.jq.each(t.items, function () {
                      (r = parseFloat(this.line_price / 100).toFixed(
                        easyorder.roundPriceTo
                      )),
                        (o = parseFloat(this.price / 100).toFixed(
                          easyorder.roundPriceTo
                        )),
                        c
                          ? ((r = l.replace(easyorder.priceFormatMarker, r)),
                            (o = l.replace(easyorder.priceFormatMarker, o)))
                          : ((r = l + r), (o = l + o)),
                        n.append(
                          [
                            '<div class="easyorder-products-holder grid">',
                            '<div class="grid__item two-fifths easyorder-product-image-holder">',
                            '<div class="easyorder-field-holder easyorder-product-data-holder">',
                            '<input type="hidden" name="id[' +
                              this.variant_id +
                              '][quantity]"   value="' +
                              this.quantity +
                              '" />',
                            '<input type="hidden" name="id[' +
                              this.variant_id +
                              '][properties]" value="' +
                              encodeURIComponent(
                                JSON.stringify(this.properties)
                              ) +
                              '" />',
                            '<input type="hidden" name="id[' +
                              this.variant_id +
                              '][gift_card]"  value="' +
                              (this.gift_card ? 1 : 0) +
                              '" />',
                            '<input type="hidden" name="id[' +
                              this.variant_id +
                              '][grams]" value="' +
                              this.grams +
                              '" />',
                            '<input type="hidden" name="id[' +
                              this.variant_id +
                              '][sku]"   value="' +
                              this.sku +
                              '" />',
                            '<input type="hidden" name="id[' +
                              this.variant_id +
                              '][requires_shipping]" value="' +
                              (this.requires_shipping ? 1 : 0) +
                              '" />',
                            "</div>",
                            '<a href="' + this.url + '">',
                            '<img src="' + this.image + '" />',
                            "</a>",
                            "</div>",
                            '<div class="grid__item three-fifths easyorder-product-desc-holder">',
                            '<h4 class="easyorder-product-title">',
                            '<a href="' + this.url + '">',
                            this.product_title,
                            "</a>",
                            "</h4>",
                            easyorder.showVendor
                              ? "<p>" + this.vendor + "</p>"
                              : "",
                            '<p class="easyorder-item-price-holder">',
                            '<b class="easyorder-item-price-price">' +
                              r +
                              "</b>",
                            '<span class="easyorder-item-price-separator">, </span>',
                            "<small>",
                            '<span class="easyorder-item-price-quantity">' +
                              this.quantity +
                              "</span>",
                            '<span class="easyorder-item-price-for-one"><span class="easyorder-item-x-for-one"> x </span>' +
                              o +
                              "</span>",
                            "</small>",
                            "</p>",
                            '<p class="easyorder-item-remove-holder"><a href="#" onclick="easyorder.popupRemove(' +
                              this.variant_id +
                              ');return false;">Remove</a></p>',
                            "</div>",
                            "</div>",
                          ].join("")
                        );
                    }),
                    n.append(
                      '<h4 class="easyorder-text-left easyorder-total-price-holder"><span class="easyorder-total-label">Total: </span>' +
                        a +
                        "</h4>"
                    ))
                  : (easyorder.jq.each(t.items, function () {
                      const title = this.title.includes("- TESTEUR")
                        ? this.title.replace("- TESTEUR", "")
                        : this.title;
                      const itemValue = {
                        product: title.trim(),
                        quantity: this.quantity,
                        product_price: parseFloat(this.price / 100).toFixed(
                          easyorder.roundPriceTo
                        ),
                        final_price: parseFloat(
                          this.final_line_price / 100
                        ).toFixed(easyorder.roundPriceTo),
                        variant_title: this.variant_title,
                      };
                      commandDetails.push(itemValue);
                    }),
                    n.append(
                      '<h4 class="easyorder-text-left easyorder-total-price-holder easyorder-hidden">' +
                        a +
                        "</h4>"
                    ));
            } else e || easyorder.jq.featherlight.close();
            var d = document.createEvent("Event");
            d.initEvent("easyorder_popup_updated", !0, !0),
              document.dispatchEvent(d);
          },
        });
    },
    popupRemove: function (e) {
      easyorder.jq.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: "id=" + e + "&quantity=0",
        dataType: "json",
        success: function (e, t) {
          easyorder.popupUpdate();
        },
        error: function (e, t) {
          API.onError(e);
        },
      });
    },
    popupSwitchContent: function (e) {
      var t = easyorder.jq(easyorder.popupSelector).find("#easyorder-popup");
      "content" == e
        ? (t.find(".easyorder-popup-result").hide(),
          t.find(".easyorder-loader").hide(),
          t.find(".easyorder-popup-content").show())
        : "result" == e
        ? (t.find(".easyorder-popup-content").hide(),
          t.find(".easyorder-loader").hide(),
          t.find(".easyorder-popup-result").show())
        : "loader" == e &&
          (t.find(".easyorder-popup-content").hide(),
          t.find(".easyorder-popup-result").hide(),
          t.find(".easyorder-loader").show());
    },
    afterOpenActions: function () {
      easyorder.iosFixPack();
    },
    afterCloseActions: function () {
      easyorder
        .jq("body")
        .removeClass("easyorder-ios-fix-caret")
        .removeClass("easyorder-ios-fix-scroll");
    },
    updateFieldsTree: function (e, t) {
      t = t || !1;
      var i = e.find(
        "input[type=checkbox], input[type=radio], select > option"
      );
      i.length &&
        i.each(function (e, i) {
          var n = i.getAttribute("data-option-id"),
            r = easyorder
              .jq(easyorder.popupSelector)
              .find("#easyorder-popup div[data-related-to=" + n + "]");
          r.length &&
            ((displayNext = t && (i.checked || i.selected)),
            easyorder.updateFieldsTree(r, displayNext));
        }),
        e.toggle(t);
    },
    validateForm: function (e, t) {
      var i = !1;
      return (
        e.each(function () {
          var e,
            t = easyorder.jq(this),
            n = 1 == this.getAttribute("data-required");
          return (
            t
              .removeClass("easyorder-field-error")
              .removeAttr("data-error-type"),
            (e = t.find(
              "input[type=text], textarea, select:not(.easyorder-flag-selector-select)"
            )).length
              ? (e.each(function () {
                  (this.value = easyorder.jq.trim(this.value)),
                    n &&
                      "" == this.value &&
                      (t
                        .addClass("easyorder-field-error")
                        .attr("data-error-type", "required"),
                      (i = !0));
                }),
                !0)
              : (e = easyorder
                  .jq(this)
                  .find("input[type=radio], input[type=checkbox]")).length
              ? (n &&
                  !e.filter(":checked").length &&
                  (t
                    .addClass("easyorder-field-error")
                    .attr("data-error-type", "required"),
                  (i = !0)),
                !0)
              : (e = t.find("input[type=email]")).length
              ? (e.each(function () {
                  (this.value = easyorder.jq.trim(this.value)),
                    "" == this.value
                      ? n &&
                        (t
                          .addClass("easyorder-field-error")
                          .attr("data-error-type", "required"),
                        (i = !0))
                      : easyorder.isValidEmailAddress(this.value) ||
                        (t
                          .addClass("easyorder-field-error")
                          .attr("data-error-type", "invalid_email"),
                        (i = !0));
                }),
                !0)
              : (e = t.find('input[type=tel][data-type="email-or-phone"]'))
                  .length
              ? (e.each(function () {
                  this.value = easyorder.jq.trim(this.value);
                  var e = this.value.match(easyorder.phoneRegExp),
                    r = e && e[0] ? e[0] : null;
                  "" == this.value
                    ? n &&
                      (t
                        .addClass("easyorder-field-error")
                        .attr("data-error-type", "required"),
                      (i = !0))
                    : r
                    ? (this.value.length < 2 || this.value.length > 20) &&
                      (t
                        .addClass("easyorder-field-error")
                        .attr("data-error-type", "invalid_phone"),
                      (i = !0))
                    : easyorder.isValidEmailAddress(this.value) ||
                      (t
                        .addClass("easyorder-field-error")
                        .attr("data-error-type", "invalid_email"),
                      (i = !0));
                }),
                !0)
              : void 0
          );
        }),
        i
      );
    },
    isValidEmailAddress: function (e) {
      return new RegExp(
        /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*){2,}|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)){2,})@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]){2,}|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]){2,}))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i
      ).test(e);
    },
    createCountriesSelector: function () {
      var e = JSON.parse(easyorder.base64Decode(easyorder.countriesData)),
        t = easyorder.jq(easyorder.popupSelector).find("input[type=tel]"),
        i = function (t, i) {
          t.attr("data-previous", easyorder.jq.trim(i))
            .val(i)
            .siblings(".easyorder-flag-selector-icon")
            .css(
              "background-image",
              "url(//cdn.shopify.com/s/assets/flags/" + e[i].img + ".svg)"
            );
        },
        n = function (t) {
          var n = easyorder.jq.trim(t.value),
            r = easyorder.jq(t).siblings(".easyorder-flag-selector:first"),
            o = r.find(".easyorder-flag-selector-select:first");
          if (n.length > 1) {
            var a = t.value.match(easyorder.phoneRegExp),
              s = a && a[0] ? a[0] : null;
            if (s && "+" === s[0][0]) {
              s = s.replace(/[\+\s-\.]/g, "").slice(0, 4);
              var l = ["", "", "", ""];
              easyorder.jq.each(e, function (t, i) {
                0 === s.indexOf(e[t].c) && (l[e[t].c.length - 1] = t);
              });
              for (var c = "", u = 3; u >= 0; u--)
                if (l[u] && "" != l[u]) {
                  c = l[u];
                  break;
                }
              if (c && "" != c) {
                var d = o.val();
                (!e[d] || (c != d && e[c].c != e[d].c)) &&
                  (o.val(l[u]), i(o, l[u]));
              } else
                (s = !1),
                  o.val(easyorder.initialCountryCode),
                  i(o, easyorder.initialCountryCode);
            }
            r.toggleClass("easyorder-hidden", !s);
          } else r.addClass("easyorder-hidden");
        },
        r = easyorder.jq(
          [
            '<div class="easyorder-flag-selector">',
            '<div class="easyorder-flag-selector-icon"></div>',
            '<svg focusable="false" aria-hidden="true" role="presentation" class="easyorder-flag-selector-caret" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10"><path d="M0 3h10L5 8" fill-rule="nonzero"></path></svg>',
            "</div>",
          ].join("")
        ),
        o = easyorder.jq('<select class="easyorder-flag-selector-select">');
      easyorder.jq.each(e, function (e, t) {
        o.append(
          '<option value="' + e + '">' + t.t + " (+" + t.c + ")</option>"
        );
      }),
        r.append(o),
        t.each(function () {
          var e = r.clone(!0, !0),
            t = e.find(".easyorder-flag-selector-select:first");
          this.id && t.attr("id", this.id + "-flag-selector"),
            this.name && t.attr("name", this.name + "_flag_selector"),
            i(t, easyorder.initialCountryCode),
            easyorder
              .jq(this)
              .after(
                e.css("height", easyorder.jq(this).outerHeight() - 2 + "px")
              ),
            n(this);
        }),
        t.on("keyup", function () {
          n(this);
        }),
        easyorder
          .jq(easyorder.popupSelector)
          .find(".easyorder-flag-selector-select")
          .on("change", function () {
            var t = easyorder.jq(this).parent().siblings("input:first"),
              n = e[this.getAttribute("data-previous")]
                ? "^\\+" + e[this.getAttribute("data-previous")].c + "\\s?"
                : "",
              r = new RegExp(n, "g"),
              o = easyorder.jq.trim(t.val()),
              a = o.replace(r, "");
            !o.length ||
              (a === o && "+" === o[0]) ||
              ((a = "+" + e[this.value].c + " " + a), t.val(a)),
              i(easyorder.jq(this), this.value);
          });
    },
    savePreselect: function () {
      var e = easyorder
        .jq(easyorder.popupSelector)
        .find(".easyorder-popup-content")
        .find(
          "input[type=text], input[type=email], input[type=tel], textarea, select"
        );
      if (e.length) {
        var t = {};
        e.each(function () {
          this.id && (t[this.id] = this.value);
        }),
          easyorder.setCookie("easyorder-preselect", JSON.stringify(t), {
            expires: 20,
          });
      }
    },
    pastePreselect: function () {
      var e = easyorder
          .jq(easyorder.popupSelector)
          .find(".easyorder-popup-content")
          .find(
            "input[type=text], input[type=email], input[type=tel], textarea, select"
          ),
        t = easyorder.getCookie("easyorder-preselect");
      t &&
        e.length &&
        ((t = JSON.parse(t)),
        e.each(function () {
          this.id && t[this.id] && (this.value = t[this.id]);
        }));
    },
    initFeatherlight: function () {
      "use strict";
      if (void 0 !== easyorder.jq) {
        var e = [],
          t = function (t) {
            return (e = easyorder.jq.grep(e, function (e) {
              return e !== t && e.$instance.closest("body").length > 0;
            }));
          },
          i = {
            keyup: "onKeyUp",
            resize: "onResize",
          },
          n = function (e) {
            easyorder.jq.each(o.opened().reverse(), function () {
              if (!e.isDefaultPrevented() && !1 === this[i[e.type]](e))
                return e.preventDefault(), e.stopPropagation(), !1;
            });
          },
          r = function (e) {
            if (e !== o._globalHandlerInstalled) {
              o._globalHandlerInstalled = e;
              var t = easyorder.jq
                .map(i, function (e, t) {
                  return t + "." + o.prototype.namespace;
                })
                .join(" ");
              easyorder.jq(window)[e ? "on" : "off"](t, n);
            }
          };
        (o.prototype = {
          constructor: o,
          namespace: easyorder.popupSelector.replace(/\.|#/g, ""),
          targetAttr: "data-featherlight",
          variant: null,
          resetCss: !1,
          background: null,
          openTrigger: "click",
          closeTrigger: "click",
          filter: null,
          root: "#easyorder-popup-holder",
          openSpeed: 250,
          closeSpeed: 250,
          closeOnClick: "background",
          closeOnEsc: !0,
          closeIcon: "&#10005;",
          loading: "",
          persist: !1,
          otherClose: null,
          beforeOpen: easyorder.jq.noop,
          beforeContent: easyorder.jq.noop,
          beforeClose: easyorder.savePreselect,
          afterOpen: function (e) {
            easyorder.afterOpenActions();
          },
          afterContent: easyorder.jq.noop,
          afterClose: function (e) {
            easyorder.afterCloseActions();
          },
          onKeyUp: easyorder.jq.noop,
          onResize: easyorder.jq.noop,
          type: null,
          contentFilters: ["jquery", "image", "html", "ajax", "iframe", "text"],
          setup: function (e, t) {
            "object" != typeof e ||
              e instanceof easyorder.jq != !1 ||
              t ||
              ((t = e), (e = void 0));
            var i = easyorder.jq.extend(this, t, {
                target: e,
              }),
              n = i.resetCss ? i.namespace + "-reset" : i.namespace,
              r = easyorder.jq(
                i.background ||
                  [
                    '<div class="' + n + "-loading " + n + '">',
                    '<div class="' + n + '-content">',
                    '<span class="' +
                      n +
                      "-close-icon " +
                      i.namespace +
                      '-close">',
                    i.closeIcon,
                    "</span>",
                    '<div class="' +
                      i.namespace +
                      '-inner">' +
                      i.loading +
                      "</div>",
                    "</div>",
                    "</div>",
                  ].join("")
              ),
              o =
                "." +
                i.namespace +
                "-close" +
                (i.otherClose ? "," + i.otherClose : "");
            return (
              (i.$instance = r.clone().addClass(i.variant)),
              i.$instance.on(i.closeTrigger + "." + i.namespace, function (e) {
                var t = easyorder.jq(e.target);
                (("background" === i.closeOnClick && t.is("." + i.namespace)) ||
                  "anywhere" === i.closeOnClick ||
                  t.closest(o).length) &&
                  (e.preventDefault(), i.close());
              }),
              this
            );
          },
          getContent: function () {
            if (!1 !== this.persist && this.$content) return this.$content;
            var e = this,
              t = this.constructor.contentFilters,
              i = function (t) {
                return e.$currentTarget && e.$currentTarget.attr(t);
              },
              n = i(e.targetAttr),
              r = e.target || n || "",
              o = t[e.type];
            if (
              (!o && r in t && ((o = t[r]), (r = e.target && n)),
              (r = r || i("href") || ""),
              !o)
            )
              for (var a in t) e[a] && ((o = t[a]), (r = e[a]));
            if (!o) {
              var s = r;
              if (
                ((r = null),
                easyorder.jq.each(e.contentFilters, function () {
                  return (
                    (o = t[this]).test && (r = o.test(s)),
                    !r && o.regex && s.match && s.match(o.regex) && (r = s),
                    !r
                  );
                }),
                !r)
              )
                return (
                  "console" in window &&
                    window.console.error(
                      "Featherlight: no content filter found " +
                        (s ? ' for "' + s + '"' : " (no target specified)")
                    ),
                  !1
                );
            }
            return o.process.call(e, r);
          },
          setContent: function (e) {
            return (
              (e.is("iframe") || easyorder.jq("iframe", e).length > 0) &&
                this.$instance.addClass(this.namespace + "-iframe"),
              this.$instance.removeClass(this.namespace + "-loading"),
              this.$instance
                .find("." + this.namespace + "-inner")
                .not(e)
                .slice(1)
                .remove()
                .end()
                .replaceWith(
                  easyorder.jq.contains(this.$instance[0], e[0]) ? "" : e
                ),
              (this.$content = e.addClass(this.namespace + "-inner")),
              this
            );
          },
          open: function (t) {
            var i = this;
            if (
              (i.$instance.hide().appendTo(i.root),
              !((t && t.isDefaultPrevented()) || !1 === i.beforeOpen(t)))
            ) {
              t && t.preventDefault();
              var n = i.getContent();
              if (n)
                return (
                  e.push(i),
                  r(!0),
                  i.$instance.fadeIn(i.openSpeed),
                  i.beforeContent(t),
                  easyorder.jq
                    .when(n)
                    .always(function (e) {
                      i.setContent(e), i.afterContent(t);
                    })
                    .then(i.$instance.promise())
                    .done(function () {
                      i.afterOpen(t);
                    })
                );
            }
            return (
              i.$instance.detach(), easyorder.jq.Deferred().reject().promise()
            );
          },
          close: function (e) {
            var i = this,
              n = easyorder.jq.Deferred();
            return (
              !1 === i.beforeClose(e)
                ? n.reject()
                : (0 === t(i).length && r(!1),
                  i.$instance.fadeOut(i.closeSpeed, function () {
                    i.$instance.detach(), i.afterClose(e), n.resolve();
                  })),
              easyorder.reloadAfterClose && window.location.reload(!0),
              n.promise()
            );
          },
          chainCallbacks: function (e) {
            for (var t in e)
              this[t] = easyorder.jq.proxy(
                e[t],
                this,
                easyorder.jq.proxy(this[t], this)
              );
          },
        }),
          easyorder.jq.extend(o, {
            id: 0,
            autoBind: "[data-featherlight]",
            defaults: o.prototype,
            contentFilters: {
              jquery: {
                regex: /^[#.]\w/,
                test: function (e) {
                  return e instanceof easyorder.jq && e;
                },
                process: function (e) {
                  return !1 !== this.persist
                    ? easyorder.jq(e)
                    : easyorder.jq(e).clone(!0);
                },
              },
              image: {
                regex: /\.(png|jpg|jpeg|gif|tiff|bmp)(\?\S*)?$/i,
                process: function (e) {
                  var t = easyorder.jq.Deferred(),
                    i = new Image(),
                    n = easyorder.jq(
                      '<img src="' +
                        e +
                        '" alt="" class="' +
                        this.namespace +
                        '-image" />'
                    );
                  return (
                    (i.onload = function () {
                      (n.naturalWidth = i.width),
                        (n.naturalHeight = i.height),
                        t.resolve(n);
                    }),
                    (i.onerror = function () {
                      t.reject(n);
                    }),
                    (i.src = e),
                    t.promise()
                  );
                },
              },
              html: {
                regex: /^\s*<[\w!][^<]*>/,
                process: function (e) {
                  return easyorder.jq(e);
                },
              },
              ajax: {
                regex: /./,
                process: function (e) {
                  var t = easyorder.jq.Deferred(),
                    i = easyorder.jq("<div></div>").load(e, function (e, n) {
                      "error" !== n && t.resolve(i.contents()), t.fail();
                    });
                  return t.promise();
                },
              },
              iframe: {
                process: function (e) {
                  var t = new easyorder.jq.Deferred(),
                    i = easyorder
                      .jq("<iframe/>")
                      .hide()
                      .attr("src", e)
                      .css(
                        (function (e, t) {
                          var i = {},
                            n = new RegExp("^" + t + "([A-Z])(.*)");
                          for (var r in e) {
                            var o = r.match(n);
                            o &&
                              (i[
                                (
                                  o[1] + o[2].replace(/([A-Z])/g, "-$1")
                                ).toLowerCase()
                              ] = e[r]);
                          }
                          return i;
                        })(this, "iframe")
                      )
                      .on("load", function () {
                        t.resolve(i.show());
                      })
                      .appendTo(
                        this.$instance.find("." + this.namespace + "-content")
                      );
                  return t.promise();
                },
              },
              text: {
                process: function (e) {
                  return easyorder.jq("<div>", {
                    text: e,
                  });
                },
              },
            },
            functionAttributes: [
              "beforeOpen",
              "afterOpen",
              "beforeContent",
              "afterContent",
              "beforeClose",
              "afterClose",
            ],
            readElementConfig: function (e, t) {
              var i = this,
                n = new RegExp("^data-" + t + "-(.*)"),
                r = {};
              return (
                e &&
                  e.attributes &&
                  easyorder.jq.each(e.attributes, function () {
                    var e = this.name.match(n);
                    if (e) {
                      var t = this.value,
                        o = easyorder.jq.camelCase(e[1]);
                      if (easyorder.jq.inArray(o, i.functionAttributes) >= 0)
                        t = new Function(t);
                      else
                        try {
                          t = easyorder.jq.parseJSON(t);
                        } catch (e) {}
                      r[o] = t;
                    }
                  }),
                r
              );
            },
            extend: function (e, t) {
              var i = function () {
                this.constructor = e;
              };
              return (
                (i.prototype = this.prototype),
                (e.prototype = new i()),
                (e.__super__ = this.prototype),
                easyorder.jq.extend(e, this, t),
                (e.defaults = e.prototype),
                e
              );
            },
            attach: function (e, t, i) {
              var n = this;
              "object" != typeof t ||
                t instanceof easyorder.jq != !1 ||
                i ||
                ((i = t), (t = void 0));
              var r,
                o =
                  (i = easyorder.jq.extend({}, i)).namespace ||
                  n.defaults.namespace,
                a = easyorder.jq.extend(
                  {},
                  n.defaults,
                  n.readElementConfig(e[0], o),
                  i
                );
              return (
                e.on(a.openTrigger + "." + a.namespace, a.filter, function (o) {
                  var s = easyorder.jq.extend(
                      {
                        $source: e,
                        $currentTarget: easyorder.jq(this),
                      },
                      n.readElementConfig(e[0], a.namespace),
                      n.readElementConfig(this, a.namespace),
                      i
                    ),
                    l =
                      r ||
                      easyorder.jq(this).data("featherlight-persisted") ||
                      new n(t, s);
                  "shared" === l.persist
                    ? (r = l)
                    : !1 !== l.persist &&
                      easyorder.jq(this).data("featherlight-persisted", l),
                    l.open(o);
                }),
                e
              );
            },
            current: function () {
              var e = this.opened();
              return e[e.length - 1] || null;
            },
            opened: function () {
              var i = this;
              return (
                t(),
                easyorder.jq.grep(e, function (e) {
                  return e instanceof i;
                })
              );
            },
            close: function () {
              var e = this.current();
              if (e) return e.close();
            },
            _onReady: function () {
              var e = this;
              e.autoBind &&
                (e.attach(easyorder.jq(document), {
                  filter: e.autoBind,
                }),
                easyorder
                  .jq(e.autoBind)
                  .filter("[data-featherlight-filter]")
                  .each(function () {
                    e.attach(easyorder.jq(this));
                  }));
            },
            _callbackChain: {
              onKeyUp: function (e, t) {
                return 27 === t.keyCode
                  ? (this.closeOnEsc &&
                      this.$instance
                        .find("." + this.namespace + "-close:first")
                        .click(),
                    !1)
                  : e(t);
              },
              onResize: function (e, t) {
                if (this.$content.naturalWidth) {
                  var i = this.$content.naturalWidth,
                    n = this.$content.naturalHeight;
                  this.$content.css("width", "").css("height", "");
                  var r = Math.max(
                    i / parseInt(this.$content.parent().css("width"), 10),
                    n / parseInt(this.$content.parent().css("height"), 10)
                  );
                  r > 1 &&
                    this.$content
                      .css("width", i / r + "px")
                      .css("height", n / r + "px");
                }
                return e(t);
              },
              afterContent: function (e, t) {
                var i = e(t);
                return this.onResize(t), i;
              },
            },
          }),
          (easyorder.jq.featherlight = o),
          (easyorder.jq.fn.featherlight = function (e, t) {
            return o.attach(this, e, t);
          }),
          easyorder.jq(document).ready(function () {
            o._onReady();
          });
      } else
        "console" in window &&
          window.console.info(
            "Too much lightness, Featherlight needs jQuery v1.9.1."
          );

      function o(e, t) {
        if (!(this instanceof o)) {
          var i = new o(e, t);
          return i.open(), i;
        }
        (this.id = o.id++),
          this.setup(e, t),
          this.chainCallbacks(o._callbackChain);
      }
    },
    facebookConversionPixel: function (e, t, i) {
      // if (e = e || easyorder.fbPixel, i = i || easyorder.currency, void 0 === t) {
      //     var n = easyorder.jq(easyorder.popupSelector).find("h4.easyorder-total-price-holder > span.easyorder-total-price");
      //     t = n.attr("data-eo-native-total-price") ? parseFloat(n.attr("data-eo-native-total-price") / 100).toFixed(easyorder.roundPriceTo) : n.text()
      // }
      // void 0 !== e && "function" == typeof fbq && fbq("track", "Purchase", {
      //     value: t,
      //     currency: i
      // })
    },
    iosFixPack: function () {
      var e = navigator.userAgent;
      /iPad|iPhone|iPod/.test(e) &&
        (easyorder.jq("body").addClass("easyorder-ios-fix-scroll"),
        /OS 11_0_1|OS 11_0_2|OS 11_0_3|OS 11_1|OS 11_1_1|OS 11_2/.test(e) &&
          easyorder.jq("body").addClass("easyorder-ios-fix-caret"));
    },
    initPage: function () {
      "function" == typeof window.getComputedStyle &&
        (easyorder.isRtl =
          "rtl" === window.getComputedStyle(document.body).direction),
        easyorder.initFeatherlight();
      var e = document.createEvent("Event");
      e.initEvent("easyorder_init", !0, !0),
        document.dispatchEvent(e),
        easyorder.jq("#easyorder-hpbtn-style").remove();
    },
    bindingPopup: function () {
      var key1 = "bdc_a90f85557173402bb4576d1be5524249";
      var key2 = "bdc_454c734eeb3245ca896c28172a7c6094";
      var ip = "";
      var location = "";
      $.getJSON(
        "https://api.bigdatacloud.net/data/ip-geolocation?key=bdc_454c734eeb3245ca896c28172a7c6094",
        function (data) {
          ip = data.ip;
          location = data.location.localityName;
        }
      );
      if (window.location.href.indexOf("/cart") > -1) {
        //   var location_prec = {
        //    lat: 0,
        //    lng:0,
        //    acc:0
        //  }
        //     const options = {
        //     enableHighAccuracy: true,
        //     timeout: 5000,
        //     maximumAge: 0,
        //   };
        // function successs(pos) {
        //   const crd = pos.coords;
        //   location_prec.lat = crd.latitude;
        //   location_prec.lng = crd.longitude;
        //   location_prec.acc = crd.accuracy
        // }
        // function errors(err) {
        //   console.log(`ERROR(${err.code}): ${err.message}`);
        // }
        //navigator.geolocation.getCurrentPosition(successs, errors, options);
      }
      easyorder.jq(".easyorder-popup-submit").click(function (e) {
        e.preventDefault(), e.stopImmediatePropagation();
        const productsList = new Map();
        productsList.set("ARMANI - SI PASSIONE", 7067727801474074370);
        productsList.set(
          "CAROLINA HERRERA - 212 VIP ROSE",
          7067727551916967682
        );
        productsList.set("ARMANI - MY WAY", 7067727551916951298);
        productsList.set("LANCOME - LA VIE EST BELLE", 7067727551916934914);
        productsList.set(
          "YVES SAINT LAURENT - BLACK OPIUM",
          7067727547341260546
        );
        productsList.set("ARMANI - ACQUA DI GIO PROFUMO", 7067727547341244162);
        productsList.set("TOM FORD - BLACK ORCHID", 7067727181241796353);
        productsList.set("TOM FORD - FREAKING FABULOUS", 7067727038874912513);
        productsList.set(
          "DOLCE & GABBANA - THE ONE BAROQUE FOR MEN",
          7067727038874896129
        );
        productsList.set("JEAN PAUL GAUTHIER - LE MALE", 7067726612725548801);
        productsList.set(
          "BACCARAT ROUGE 540 EAU DE PARFUM",
          7067724297628468993
        );
        productsList.set("PACO RABANNE - ONE MILLION", 7067723590318245634);
        productsList.set("MARC JACOBS - DECADENCE", 7067723590318229250);
        productsList.set("CHANEL - ALLURE HOMME SPORT", 7067722840379770625);
        productsList.set("VERSACE - EROS", 7067722831040268033);
        productsList.set("DIOR - SAUVAGE", 7067722831040251649);
        productsList.set("CAROLINA HERRERA - 212 MEN", 7067722637460588290);
        productsList.set(
          "YVES SAINT LAURENT - LA NUIT DE L'HOMME INTENSE",
          7067722637460571906
        );
        productsList.set("CHANEL - COCO MADEMOISELLE", 7067722632884700930);
        productsList.set(
          "JEAN PAUL GAULTIER - LE BEAU MALE",
          7067634466768553729
        );
        ttq.track("AddToCart", {
          content_id: commandDetails[0].product,
          content_type: "product",
          content_name: commandDetails[0].product,
          quantity: 1,
          price: commandDetails[0].final_price,
          value: commandDetails[0].final_price,
          currency: "MAD",
        });

        var t = easyorder.jq(this),
          i = easyorder.jq(easyorder.popupSelector).find("#easyorder-popup");
        if (i.length) {
          var n = i.find(
              ".easyorder-field-holder:visible, .easyorder-product-data-holder"
            ),
            r = n.filter("[data-required=1]");
          if (easyorder.validateForm(n, r)) return !1;
          easyorder.savePreselect(),
            easyorder.popupSwitchContent("loader"),
            i.find(".easyorder-ok-btn").removeAttr("onclick");
          var o = document.createElement("form");
          easyorder.jq(o).append(n.clone()),
            easyorder
              .jq(o)
              .find("select")
              .each(function (e, t) {
                if (t.name) {
                  var i = n.find('select[name="' + t.name + '"]');
                  i.length && (t.value = i.val());
                }
              });
          var a = new FormData(o);
          var json = {};
          a.forEach(function (value, key) {
            json[key] = value;
          });
          a.append("commandDetails", JSON.stringify(commandDetails));

          ttq.track("CompletePayment", {
            content_id: commandDetails[0].product,
            content_type: "product",
            content_name: commandDetails[0].product,
            quantity: 1,
            price: commandDetails[0].final_price,
            value: commandDetails[0].final_price,
            currency: "MAD",
          });

          json["product"] = commandDetails[0].product;
          json["quantity"] = commandDetails[0].quantity;
          json["product_price"] = commandDetails[0].product_price;
          json["final_price"] = commandDetails[0].final_price;
          json["orderDetail"] = commandDetails;
          json["from"] = "perfumery.ma";
          json["ip"] = ip;
          // location = location + "(" + "https://maps.google.com/?q=+"+location_prec.lat+","+location_prec.lng+")";
          json["location"] = location;

          var finalPrice = 0.0;
          for (let product of commandDetails) {
            finalPrice = finalPrice + parseFloat(product.final_price);
          }

          const orderItemsArray = [];
          for (let index = 0; index < json.orderDetail.length; index++) {
            orderItemsArray.push({
              product: {
                name : json.orderDetail[index].product
              },
              unitPrice: json.orderDetail[index].final_price,
              quantity: json.orderDetail[index].quantity
            })
          }
          const payloadAndOrder = {
            store: 'Perfumery',
            customer: {
              fullName: json.fullName,
              phone: json.phoneNumber,
            },
            shippingAddress: {
              addressLine1: json.address
            },
            totalAmount: json.final_price,
            orderItems: orderItemsArray
          };
          a.append("json_response", 1),
            easyorder.jq.ajax({
              type: "POST",
              url: easyorder.urls.order,
              data: JSON.stringify(payloadAndOrder),
              contentType: "application/json; charset=utf-8",
              cache: false,
              success: function (e, n) {
                if (
                  (i
                    .find(".easyorder-popup-result")
                    .toggleClass(
                      "easyorder-popup-error-result",
                      "success" != e.status
                    )
                    .children("p:first")
                    .html(e.message),
                  "success" == e.status)
                )
                  easyorder.fbPixel,
                    "function" == typeof ga && "function" == typeof ga.getAll
                      ? (ga("send", "pageview"),
                        ga("send", {
                          hitType: "event",
                          eventCategory: "App",
                          eventAction: "order_completed",
                          eventLabel: easyorder.shop,
                        }))
                      : console.info("GA is not defined."),
                    easyorder.jq.post("/cart/clear.js").always(function () {
                      (easyorder.reloadAfterClose =
                        easyorder.reload || "/cart" == t.attr("data-url")),
                        i
                          .find(".easyorder-ok-btn")
                          .attr(
                            "onclick",
                            "easyorder.jq.featherlight.close();"
                          );
                    }),
                    easyorder.popupSwitchContent("result"),
                    easyorder.orderSuccessCustomCode &&
                      i
                        .find(
                          ".easyorder-popup-result .easyorder-ok-btn-holder"
                        )
                        .before(
                          [
                            '<div class="easyorder-custom-success-result">',
                            easyorder.base64Decode(
                              easyorder.orderSuccessCustomCode
                            ),
                            "</div>",
                          ].join("")
                        );
                else if (
                  (i
                    .find(".easyorder-ok-btn")
                    .attr(
                      "onclick",
                      "easyorder.popupSwitchContent('content');"
                    ),
                  e.field)
                ) {
                  var r = i.find("#easyorder-field-" + e.field);
                  r.length &&
                    (r
                      .addClass("easyorder-field-error")
                      .attr("data-error-type", e.type),
                    e.field_value &&
                      r
                        .find(
                          "input[type=text]input[type=email],input[type=tel]"
                        )
                        .val(e.field_value)),
                    easyorder.popupSwitchContent("content");
                } else easyorder.popupSwitchContent("result");

                // const cookies_ = new Map();
                // var cookies = document.cookie.split(';');
                //  for(var indexito = 1; indexito <= cookies.length; indexito++)
                //  {
                //     if(cookies[indexito]){
                //         const data =  cookies[indexito].split("=");
                //         const key = data[0].replace('=','');
                //         const value = data[1];
                //         cookies_.set(key.trim(),value);
                //     }
                //  }
                fbq("track", "Purchase", {
                  currency: "MAD",
                  value: finalPrice,
                });
                //    fbq('track', 'Purchase', {currency: "MAD", value: finalPrice+""});
              },
            });
        }
      });
    },
    bindingForms: function (e) {
      if (window.location.pathname == "/cart") {
        setTimeout(function () {
          var t = easyorder.jq(e),
            i = t.find("[type=submit],[data-product-submit]"),
            n = null;
          easyorder.unbinding.buttons &&
            i.each(function (e, t) {
              this.onclick = null;
              var i = this.cloneNode(!0);
              i.setAttribute("type", "submit"),
                this.parentNode.replaceChild(i, this);
            }),
            easyorder.unbinding.forms &&
              t.each(function (e, t) {
                this.onsubmit = null;
                try {
                  this.removeEventListener("submit");
                } catch (e) {}
                "function" == typeof jQuery &&
                  ("function" == typeof jQuery.fn.unbind &&
                    jQuery(this).unbind(),
                  "function" == typeof jQuery.fn.off && jQuery(this).off()),
                  "function" == typeof jquery &&
                    ("function" == typeof jquery.fn.unbind &&
                      jquery(this).unbind(),
                    "function" == typeof jquery.fn.off && jquery(this).off()),
                  "function" == typeof $ &&
                    ("function" == typeof $.fn.unbind && $(this).unbind(),
                    "function" == typeof $.fn.off && $(this).off());
              }),
            easyorder.jq(document).on("click", "[name=checkout]", function (t) {
              if (easyorder.jq(this).closest(e).length) {
                if ((n = easyorder.jq(this)) && n.length) {
                  if ("update" == n.attr("name"))
                    return easyorder.resetButtons.update && (n = null), !0;
                  if (n.hasClass("easyorder-native-checkout"))
                    return easyorder.resetButtons.native && (n = null), !0;
                }
                t.preventDefault(),
                  t.stopImmediatePropagation(),
                  n.parent().closest("form").submit();
              }
            }),
            easyorder.jq(document).on("submit", e, function (e) {
              if (n) {
                if (
                  n &&
                  n.length &&
                  ("update" == n.attr("name") ||
                    n.hasClass("easyorder-native-checkout"))
                )
                  return (n = null), !0;
                e.preventDefault(),
                  e.stopImmediatePropagation(),
                  (n = null),
                  easyorder.popupOpen(easyorder.jq(this));
              }
            });
        }, 10);
      }
    },
    initLocation: function (e) {
      var t = easyorder.getCookie("easyorder-current-iso");
      t
        ? ((easyorder.initialCountryCode = t), "function" == typeof e && e())
        : easyorder.jq.ajax({
            type: "post",
            url: easyorder.urls.geosrc,
            dataType: "json",
            success: function (t) {
              (easyorder.initialCountryCode = t.country.iso_code),
                easyorder.setCookie(
                  "easyorder-current-iso",
                  easyorder.initialCountryCode,
                  {
                    expires: 86400,
                  }
                ),
                "function" == typeof e && e();
            },
            error: function (t) {
              (easyorder.initialCountryCode = easyorder.shopCountryCode),
                "function" == typeof e && e();
            },
          });
    },
  };
  easyorder.loadLink(easyorder.urls.css),
    easyorder.jq(document).ready(function () {
      "object" == typeof InstantClick &&
        InstantClick.on("change", easyorder.initPage),
        easyorder.initPage();
    });
}
